<template>
  <section class="hero is-info is-fullheight">
    <div class="hero-head">
      <nav class="navbar is-transparent">
        <div class="container">
          <div class="navbar-brand">
            <router-link to="/" class="navbar-item is-title">
              <h1 class="title is-5">Crafting DB</h1>
            </router-link>
            <span class="navbar-burger burger" @click="showNav = !showNav">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </div>
          <div :class="showNav ? 'is-active navbar-menu' : 'navbar-menu'">
            <div class="navbar-end">
              <router-link to="/" :class="$route.path === '/' ? 'is-active navbar-item' : 'navbar-item'">
                Blueprints
              </router-link>
              <router-link to="/materials"
                :class="$route.path === '/materials' ? 'is-active navbar-item' : 'navbar-item'">
                Materials
              </router-link>
              <router-link to="/compare" :class="$route.path === '/compare' ? 'is-active navbar-item' : 'navbar-item'">
                Compare
              </router-link>
              <span class="navbar-item">
                <a class="button is-info is-inverted" href="https://discord.gg/8ZD3Wqf" target="_blank">
                  <span class="icon">
                    <i class="fab fa-discord"></i>
                  </span>
                  <span>Discord</span>
                </a>
              </span>
            </div>
          </div>
        </div>
      </nav>
    </div>

    <div class="hero-body">
      <router-view></router-view>
    </div>

  </section>
</template>

<script>
  export default {
    name: "App",
    data() {
      return {
        showNav: false,
        items: [
          // "Robot Beacon (1110101010100000001001) Blueprint (L)",
          "Animal Brush (L) Blueprint",
          "Animal Brush, Advanced (L) Blueprint",
          "Animal Brush (L) Blueprint (L)",
          "Animal Brush, Advanced (L) Blueprint (L)",
          "Finder F-210 (L) Blueprint (L)",
          "Finder F-210 (L) Blueprint",
          "Finder F-211 (L) Blueprint (L)",
          "Finder F-211 (L) Blueprint",
          "Finder F-212 (L) Blueprint (L)",
          "Finder F-214 (L) Blueprint (L)",
          "Finder F-212 (L) Blueprint",
          "Finder F-213 (L) Blueprint (L)",
          "Finder F-213 (L) Blueprint",
          "Finder F-213, Adapted (L) Blueprint (L)",
          "Finder F-213, Customized (L) Blueprint (L)",
          "Finder F-213, Reworked (L) Blueprint (L)",
          "Resource Extractor RE-201 (L) Blueprint (L)",
          "Resource Extractor RE-201 (L) Blueprint",
          "Resource Extractor RE-202 (L) Blueprint (L)",
          "Resource Extractor RE-202 (L) Blueprint",
          "Resource Extractor RE-203 (L) Blueprint (L)",
          "Resource Extractor RE-204 (L) Blueprint (L)",
          "Resource Extractor RE-204, Adapted (L) Blueprint (L)",
          "Ziplex Z5 Seeker (L) Blueprint (L)",
          "Ziplex Z10 Seeker (L) Blueprint (L)",
          "Ziplex Z15 Seeker (L) Blueprint (L)",
          "Ziplex Z20 Seeker (L) Blueprint (L)",
          "Ziplex Z25 Seeker (L) Blueprint (L)",
          "Ziplex TK120 Seeker (L) Blueprint (L)",
          "Ziplex TK220 Seeker (L) Blueprint (L)",
          "Ziplex TK320 Seeker (L) Blueprint (L)",
          "Ziplex VRX2000 Seeker (L) Blueprint (L)",
          "Ziplex VRX3000 Seeker (L) Blueprint (L)",
          "Vivo T5 (L) Blueprint (L)",
          "Vivo T10 (L) Blueprint (L)",
          "Vivo T15 (L) Blueprint (L)",
          "Vivo T20 (L) Blueprint (L)",
          "Vivo UR125 (L) Blueprint (L)",
          "Vivo UR175 (L) Blueprint (L)",
          "Vivo UR200 (L) Blueprint (L)",
          "Vivo Oxy1500 (L) Blueprint (L)",
          "Vivo Oxy2000 (L) Blueprint (L)",
          "Vivo Oxy2500 (L) Blueprint (L)",
          "Vivo Neo (L) Blueprint (L)",
          "Vivo Survivor (L) Blueprint (L)",
          "Vivo Zychion Pro (L) Blueprint (L)",
          "Vivo T5 (L) Blueprint",
          "Vivo T10 (L) Blueprint",
          "Vivo T15 (L) Blueprint",
          "Vivo T20 (L) Blueprint",
          "Vivo UR125 (L) Blueprint",
          "Vivo UR175 (L) Blueprint",
          "Vivo UR200 (L) Blueprint",
          "Vivo Oxy1500 (L) Blueprint",
          "Vivo Oxy2000 (L) Blueprint",
          "Vivo Oxy2500 (L) Blueprint",
          "Vivo Neo (L) Blueprint",
          "Vivo Survivor (L) Blueprint",
          "Vivo Zychion Pro (L) Blueprint",
          "Vivo T5, Adapted (L) Blueprint (L)",
          "Vivo T10, Adapted (L) Blueprint (L)",
          "Vivo T15, Adapted (L) Blueprint (L)",
          "Vivo T20, Adapted (L) Blueprint (L)",
          "Vivo UR125, Adapted (L) Blueprint (L)",
          "Vivo UR175, Adapted (L) Blueprint (L)",
          "Vivo UR200, Adapted (L) Blueprint (L)",
          "Vivo Oxy1500, Adapted (L) Blueprint (L)",
          "Vivo Oxy2000, Adapted (L) Blueprint (L)",
          "Vivo Oxy2500, Adapted (L) Blueprint (L)",
          "Vivo Neo, Adapted (L) Blueprint (L)",
          "Vivo Survivor, Adapted (L) Blueprint (L)",
          "Vivo Zychion Pro, Adapted (L) Blueprint (L)",
          "Vivo T5 Blueprint (L)",
          "Vivo T10 Blueprint (L)",
          "Vivo T15 Blueprint (L)",
          "Vivo T20 Blueprint (L)",
          "Vivo UR125 Blueprint (L)",
          "Vivo UR175 Blueprint (L)",
          "Vivo UR200 Blueprint (L)",
          "Vivo Oxy1500 Blueprint (L)",
          "Vivo Oxy2000 Blueprint (L)",
          "Vivo Oxy2500 Blueprint (L)",
          "Vivo Neo Blueprint (L)",
          "Vivo Survivor Blueprint (L)",
          "Vivo Zychion Pro Blueprint (L)",
          "Vivo T5, Adapted Blueprint (L)",
          "Vivo T10, Adapted Blueprint (L)",
          "Vivo T15, Adapted Blueprint (L)",
          "Vivo T20, Adapted Blueprint (L)",
          "Vivo UR125, Adapted Blueprint (L)",
          "Vivo UR175, Adapted Blueprint (L)",
          "Vivo UR200, Adapted Blueprint (L)",
          "Vivo Oxy1500, Adapted Blueprint (L)",
          "Vivo Oxy2000, Adapted Blueprint (L)",
          "Vivo Oxy2500, Adapted Blueprint (L)",
          "Vivo Neo, Adapted Blueprint (L)",
          "Vivo Survivor, Adapted Blueprint (L)",
          "Vivo Zychion Pro, Adapted Blueprint (L)",
          "Ziplex Z5 Seeker (L) Blueprint",
          "Ziplex Z10 Seeker (L) Blueprint",
          "Ziplex Z15 Seeker (L) Blueprint",
          "Ziplex Z20 Seeker (L) Blueprint",
          "Ziplex 'Fashion Line' Colorator (L) Blueprint",
          "Ziplex 'Fashion Line' Bleacher Addon (L) Blueprint",
          "Ziplex T100 Texturizer (L) Blueprint",
          "Ziplex B101 Material Texture Bleacher (L) Blueprint",
          "Ziplex Z25 Seeker (L) Blueprint",
          "Ziplex TK120 Seeker (L) Blueprint",
          "Ziplex TK220 Seeker (L) Blueprint",
          "Ziplex TK320 Seeker (L) Blueprint",
          "Ziplex VRX2000 Seeker (L) Blueprint",
          "Ziplex VRX3000 Seeker (L) Blueprint",
          "Vivo UR150 (L) Blueprint (L)",
          "Vivo Oxy1000 (L) Blueprint (L)",
          "Vivo Oxy2250 (L) Blueprint (L)",
          "Vivo Oxy3000 (L) Blueprint (L)",
          "Vivo Olympian (L) Blueprint (L)",
          "Resource Extractor RE-205 (L) Blueprint (L)",
          "eMINE FS (L) Blueprint (L)",
          "eMINE E (L) Blueprint (L)",
          "eMINE FS (L) Blueprint",
          "eMINE E (L) Blueprint",
          "Vivo T15, Adapted, SGA Edition (L) Blueprint (L)",
          "Vivo Oxy2500, SGA Edition (L) Blueprint (L)",
          "Finder F-212, SGA Edition (L) Blueprint (L)",
          "Ziplex VRX2000 Seeker, SGA Edition (L) Blueprint (L)",
          "Ziplex Z10 Seeker, SGA Edition (L) Blueprint (L)",
          "Vehicle RK-5 (L) Blueprint (L)",
          "Vehicle RK-20 (L) Blueprint (L)",
          "Vehicle RK-50 (L) Blueprint (L)",
          "Pitbull Mk. 1 (C,L) Blueprint (L)",
          "Pitbull Mk. 2 (C,L) Blueprint (L)",
          "Pitbull Mk. 3 (C,L) Blueprint (L)",
          "Pitbull Mk. 4 (C,L) Blueprint (L)",
          "0x0F382C8C91E58C8273C0 (L) Blueprint (L)",
          "Laserfaust SL-G 10 (L) Blueprint (L)",
          "Advanced Heavy Springs Blueprint (L)",
          "Advanced Spur Gears 6K Blueprint (L)",
          "Advanced Fluid Energy Source Blueprint (L)",
          "Advanced Cooling System Unit Blueprint (L)",
          "Laserfaust SL-G 20 (L) Blueprint (L)",
          "Laserfaust SL-G 30 (L) Blueprint (L)",
          "Laserfaust SL-G 40 (L) Blueprint (L)",
          "Laserfaust SL-G 50 (L) Blueprint (L)",
          "Aelgen Type E91 (L) Blueprint (L)",
          "Aelgen Type D98 (L) Blueprint (L)",
          "Aelgen Type C106 (L) Blueprint (L)",
          "Aelgen Type B114 (L) Blueprint (L)",
          "Aelgen Type A122 (L) Blueprint (L)",
          "Castorian Nano-Blade Famine (L) Blueprint (L)",
          "Castorian Nano-Blade Pestilence (L) Blueprint (L)",
          "Castorian Nano-Blade War (L) Blueprint (L)",
          "Castorian Nano-Blade Death (L) Blueprint (L)",
          "Castorian Nano-Blade Apocalypse (L) Blueprint (L)",
          "Isis Alr.3Li (L) Blueprint (L)",
          "Isis Alr.11Na (L) Blueprint (L)",
          "Isis Alr.19K (L) Blueprint (L)",
          "Isis Alr.37Rb (L) Blueprint (L)",
          "Isis Alr.55Cs (L) Blueprint (L)",
          "Isis Alr.87Fr (L) Blueprint (L)",
          "Primordial Longu Leather Texture Blueprint",
          "Mechanomatrix Adapter Unit 1 Blueprint",
          "Mechanomatrix Adapter Unit 2 Blueprint",
          "Mechanomatrix Adapter Unit 3 Blueprint",
          "Maddox 1 GDC (L) Blueprint",
          "Maddox 2 GDC (L) Blueprint",
          "Maddox 3 GDC (L) Blueprint",
          "Maddox 4 GDC (L) Blueprint",
          "Svempa X2 (L) Blueprint",
          "GeoTrek H66 Just (L) Blueprint",
          "GeoTrek H8 Mean (L) Blueprint (L)",
          "GeoTrek H15 Vile (L) Blueprint (L)",
          "GeoTrek H24 Sin (L) Blueprint (L)",
          "GeoTrek H29 Wretched (L) Blueprint (L)",
          "GeoTrek H35 Evil (L) Blueprint (L)",
          "GeoTrek H42 Demonic (L) Blueprint (L)",
          "GeoTrek H52 Diabolic (L) Blueprint (L)",
          "GeoTrek H57 Kind (L) Blueprint (L)",
          "GeoTrek H63 Fair (L) Blueprint (L)",
          "GeoTrek H70 Honor (L) Blueprint (L)",
          "GeoTrek H73 Pure (L) Blueprint (L)",
          "GeoTrek H78 Righteous (L) Blueprint (L)",
          "GeoTrek H83 Holy (L) Blueprint (L)",
          "GeoTrek H89 Saint (L) Blueprint (L)",
          "GeoTrek H93 Angelic (L) Blueprint (L)",
          "GeoTrek H98 Godlike (L) Blueprint (L)",
          "Breer H5a (L) Blueprint",
          "Breer H11a (L) Blueprint",
          "Breer H19a (L) Blueprint",
          "Breer H31a (L) Blueprint",
          "Breer L5c (L) Blueprint",
          "Breer L12c (L) Blueprint",
          "Breer L20c (L) Blueprint",
          "GeoTrek LR34 Aves (L) Blueprint",
          "GeoTrek LR47 Ursus (L) Blueprint",
          "GeoTrek LR69 Arachnid (L) Blueprint",
          "Jester D-4 (L) Blueprint (L)",
          "Jester D-5 (L) Blueprint (L)",
          "Jester D-6 (L) Blueprint (L)",
          "Jester D-7 (L) Blueprint (L)",
          "Fireforge FF39 (L) Blueprint (L)",
          "Fireforge FF43 (L) Blueprint (L)",
          "Fireforge FF53E (L) Blueprint (L)",
          "Fireforge FF61 (L) Blueprint (L)",
          "Fireforge FF66 (L) Blueprint (L)",
          "Breer L72c (L) Blueprint (L)",
          "Fireforge FF76 (L) Blueprint (L)",
          "Fireforge FF81 (L) Blueprint (L)",
          "Laserfaust SL-G 1E (L) Blueprint (L)",
          "Laserfaust SL-G 5 (L) Blueprint (L)",
          "Laserfaust SL-G 15 (L) Blueprint (L)",
          "Laserfaust SL-G 18 (L) Blueprint (L)",
          "Prosecutor M5 (L) Blueprint",
          "Prosecutor M13 (L) Blueprint",
          "Starkhov LPR-20 (L) Blueprint",
          "GeoTrek LP34 Whirlwind (L) Blueprint",
          "GeoTrek LP47 Twister (L) Blueprint",
          "GeoTrek LP68 Tornado (L) Blueprint",
          "Prosecutor M9 (L) Blueprint (L)",
          "Starkhov LPR-17 (L) Blueprint (L)",
          "Starkhov LPR-25 (L) Blueprint (L)",
          "Starkhov LPR-30 (L) Blueprint (L)",
          "GeoTrek LP39 Gust (L) Blueprint (L)",
          "GeoTrek LP43 Gale (L) Blueprint (L)",
          "GeoTrek LP53 Storm (L) Blueprint (L)",
          "GeoTrek LP58 Hurricane (L) Blueprint (L)",
          "GeoTrek LP63 Cyclone (L) Blueprint (L)",
          "GeoTrek LP72 Typhoon (L) Blueprint (L)",
          "Prosecutor M76 Turbo (L) Blueprint (L)",
          "Aelgen Type H81 (L) Blueprint (L)",
          "Aelgen Type G85 (L) Blueprint (L)",
          "Aelgen Type F89 (L) Blueprint (L)",
          "GeoTrek LP93 Akbal (L) Blueprint (L)",
          "GeoTrek LP97 Cimi (L) Blueprint (L)",
          "OmegaTrek P46 (L) Blueprint",
          "GeoTrek LH66 Specialist (L) Blueprint",
          "Shriek Back Alley (L) Blueprint (L)",
          "True Faith (L) Blueprint (L)",
          "Karma Killer (L) Blueprint (L)",
          "GeoTrek LH27 Rookie (L) Blueprint (L)",
          "OmegaTrek P36 (L) Blueprint (L)",
          "OmegaTrek P41 (L) Blueprint (L)",
          "OmegaTrek P52 (L) Blueprint (L)",
          "GeoTrek LH57 Recruit (L) Blueprint (L)",
          "GeoTrek LH62 Private (L) Blueprint (L)",
          "GeoTrek LH73 Corporal (L) Blueprint (L)",
          "GeoTrek LH76 Sergeant (L) Blueprint (L)",
          "GeoTrek LH80 Lieutenant (L) Blueprint (L)",
          "GeoTrek LH84 Captain (L) Blueprint (L)",
          "GeoTrek LH89 Major (L) Blueprint (L)",
          "GeoTrek LH93 Colonel (L) Blueprint (L)",
          "GeoTrek LH97 General (L) Blueprint (L)",
          "Jolly Christmas Blue Hat (L) Blueprint (L)",
          "Jolly Christmas Green Hat (L) Blueprint (L)",
          "Jolly Christmas Pink Hat (L) Blueprint (L)",
          "Jolly Christmas Yellow Hat (L) Blueprint (L)",
          "Jolly Christmas Blue Mittens (F.L) (L) Blueprint (L)",
          "Jolly Christmas Green Mittens (L) Blueprint (L)",
          "Jolly Christmas Pink Mittens (L) Blueprint (L)",
          "Jolly Christmas Yellow Mittens (L) Blueprint (L)",
          "Advanced Cooling System Unit Blueprint",
          "Advanced Fluid Energy Source Blueprint",
          "Advanced Heavy Springs Blueprint",
          "Advanced Spur Gears 6K Blueprint",
          "Laserfaust PK-44 Outlaw (L) Blueprint (L)",
          "Laserfaust PK-51 Bandit (L) Blueprint (L)",
          "Laserfaust PK-68 Marauder (L) Blueprint (L)",
          "Laserfaust PK-70 Desperado (L) Blueprint (L)",
          "Jolly Christmas Black Hat (L) Blueprint (L)",
          "Standard Matrix Blueprint Adjusted (L)",
          "Standard Matrix Blueprint Improved (L)",
          "Standard Matrix Blueprint Modified (L)",
          "Jester D-1 Blueprint Adjusted (L)",
          "Jester D-1 Blueprint Improved (L)",
          "Jester D-1 Blueprint Modified (L)",
          "Starkhov LPR-1 (L) Blueprint Adjusted (L)",
          "Starkhov LPR-1 (L) Blueprint Improved (L)",
          "Starkhov LPR-1 (L) Blueprint Modified (L)",
          "Settler Gloves Blueprint Adjusted (L)",
          "Settler Gloves Blueprint Improved (L)",
          "Settler Gloves Blueprint Modified (L)",
          "Level 2 Finder Amplifier (L) Blueprint Adjusted (L)",
          "Level 2 Finder Amplifier (L) Blueprint Improved (L)",
          "Level 2 Finder Amplifier (L) Blueprint Modified (L)",
          "Basic Auxiliary Socket Blueprint Adjusted (L)",
          "Basic Auxiliary Socket Blueprint Improved (L)",
          "Basic Auxiliary Socket Blueprint Modified (L)",
          "Traeskeron Leather Texture Blueprint (L)",
          "Feffox Leather Texture Blueprint (L)",
          "Hussk Leather Texture Blueprint (L)",
          "Corrupt Fuel Pump Blueprint (L)",
          "Fi/Ra/Co Evil, Adjusted Blueprint (L)",
          "Fi/Ra/Co Evil, Improved Blueprint (L)",
          "Fi/Ra/Co Evil, Modified Blueprint (L)",
          "Fi/Ra/Co Cause, Adjusted Blueprint (L)",
          "Fi/Ra/Co Cause, Improved Blueprint (L)",
          "Fi/Ra/Co Cause, Modified Blueprint (L)",
          "Sollomate Rubio (L) Blueprint (L)",
          "Sollomate Azuro (L) Blueprint (L)",
          "EWE EP-2 Proton (L) Blueprint (L)",
          "Skildek Lancehead (L) Blueprint (L)",
          "Omegaton B101 (L) Blueprint (L)",
          "Nanobots - Accuracy Blueprint (L)",
          "Nanobots - Kill Strike Blueprint (L)",
          "Nanobots - Adrenaline Boost Blueprint (L)",
          "Nanobots - Regenerative Blueprint (L)",
          "Nanobots - Resilience Blueprint (L)",
          "Nanobots - Metabolic Boost Blueprint (L)",
          "Nanobots - System Overload Blueprint (L)",
          "Nanobots - Memory Enhancer Blueprint (L)",
          "Ziplex A10 (L) Blueprint (L)",
          "Ziplex A13 (L) Blueprint (L)",
          "Ziplex A16 (L) Blueprint (L)",
          "Ziplex A19 (L) Blueprint (L)",
          "Ziplex A22 (L) Blueprint (L)",
          "Ziplex A25 (L) Blueprint (L)",
          "Ziplex A28 (L) Blueprint (L)",
          "Ziplex A31 (L) Blueprint (L)",
          "Ziplex A33 (L) Blueprint (L)",
          "Ziplex A35 (L) Blueprint (L)",
          "Ziplex B35 (L) Blueprint (L)",
          "Ziplex B40 (L) Blueprint (L)",
          "Ziplex B50 (L) Blueprint (L)",
          "Ziplex B60 (L) Blueprint (L)",
          "Ziplex B70 (L) Blueprint (L)",
          "Ziplex B80 (L) Blueprint (L)",
          "Ziplex B90 (L) Blueprint (L)",
          "Ziplex C50 (L) Blueprint (L)",
          "Ziplex C65 (L) Blueprint (L)",
          "Ziplex C70 (L) Blueprint (L)",
          "Ziplex D33 (L) Blueprint (L)",
          "Ziplex D44 (L) Blueprint (L)",
          "Ziplex D52 (L) Blueprint (L)",
          "Robot Beacon (001010010110001) Blueprint (L)",
          "Robot Beacon (100101110100100101) Blueprint (L)",
          "Robot Beacon (1100001000010111011011) Blueprint (L)",
          "Robot Beacon (111100000000000000001001) Blueprint (L)",
          "Robot Beacon (1111100010101101011011) Blueprint (L)",
          "Robot Beacon (111111001101101110001111) Blueprint (L)",
          "Maddox 4 Blueprint (L)",
          "Monria Boxing Gloves 36oz Middleweight (F,L) Blueprint (L)",
          "Monria Boxing Gloves 54oz Middleweight (F,L) Blueprint (L)",
          "Monria Boxing Gloves 18oz Lightweight (F,L) Blueprint (L)",
          "Monria Boxing Gloves 12oz Lightweight (F,L) Blueprint (L)",
          "Isis LLP 10, Adapted (L) Blueprint (L)",
          "Isis LLC 10, Adapted (L) Blueprint (L)",
          "Isis LBP 10, Adapted (L) Blueprint (L)",
          "Isis LBC 10, Adapted (L) Blueprint (L)",
          "Modec BX 1 (L) Blueprint (L)",
          "Monria Boxing Gloves 12oz Lightweight (M,L) Blueprint (L)",
          "Monria Boxing Gloves 18oz Lightweight (M,L) Blueprint (L)",
          "Monria Boxing Gloves 36oz Middleweight (M,L) Blueprint (L)",
          "Monria Boxing Gloves 54oz Middleweight (M,L) Blueprint (L)",
          "Monria Boxing Gloves 70oz Heavyweight (M,L) Blueprint (L)",
          "Monria Boxing Gloves 70oz Heavyweight (F,L) Blueprint (L)",
          "Monria Boxing Gloves 90oz Heavyweight (M,L) Blueprint (L)",
          "Monria Boxing Gloves 90oz Heavyweight (F,L) Blueprint (L)",
          "DSEC Seeker Amplifier 2 (L) Blueprint (L)",
          "DSEC Seeker Amplifier 3 (L) Blueprint (L)",
          "Vigor 1 (L) Blueprint (L)",
          "Vigor 2 (L) Blueprint (L)",
          "DSEC Seeker L2 (L) Blueprint (L)",
          "DSEC Seeker L12 (L) Blueprint (L)",
          "DSEC Seeker L30 (L) Blueprint (L)",
          "Tarsus SG 1 Blueprint (L)",
          "Tarsus BG 10 (L) Blueprint (L)",
          "Modec VXT 300 (L) Blueprint (L)",
          "Monrian Plating Blueprint",
          "Monrian Power System Blueprint",
          "Monrian Enhanced Plating Blueprint",
          "Monrian Enhanced Power System Blueprint",
          "DSEC Laser Amp v1 (L) Blueprint (L)",
          "DSEC Laser Amp v2 (L) Blueprint (L)",
          "DSEC BLP Amp v1 (L) Blueprint (L)",
          "DSEC BLP Amp v2 (L) Blueprint (L)",
          "Arctic Snow Boots Blueprint",
          "Arctic Survival Parka Blueprint",
          "Arctic Combat Parka Blueprint",
          "Arctic Snow Pants Blueprint",
          "Arctic Snow Boots Blueprint (L)",
          "Arctic Survival Parka Blueprint (L)",
          "Arctic Combat Parka Blueprint (L)",
          "Arctic Snow Pants Blueprint (L)",
          "Cheap A$$ Foot Guards (L) Blueprint",
          "Cheap A$$ Gloves (L) Blueprint",
          "Cheap A$$ Face Guard (L) Blueprint",
          "Cheap A$$ Shin Guards (L) Blueprint",
          "Cheap A$$ Thigh Guards (L) Blueprint",
          "Cheap A$$ Harness (L) Blueprint",
          "Cheap A$$ Arm Guards (L) Blueprint",
          "Cochran LR1 Blueprint (L)",
          "Cochran LR3 (L) Blueprint (L)",
          "Cochran LR5 (L) Blueprint (L)",
          "Cochran LR7 (L) Blueprint (L)",
          "Cochran LR9 (L) Blueprint (L)",
          "Adapted Cochran LR10 (L) Blueprint (L)",
          "Cochran LP1 (L) Blueprint (L)",
          "Cochran LP3 (L) Blueprint (L)",
          "Cochran LP5 (L) Blueprint (L)",
          "Cochran LP7 (L) Blueprint (L)",
          "Cochran LP9 (L) Blueprint (L)",
          "Adapted Cochran LP10 (L) Blueprint (L)",
          "Cochran P1 Blueprint (L)",
          "Cochran P3 (L) Blueprint (L)",
          "Cochran P5 (L) Blueprint (L)",
          "Cochran P7 (L) Blueprint (L)",
          "Cochran P9 (L) Blueprint (L)",
          "Adapted Cochran P10 (L) Blueprint (L)",
          "Cochran R1 (L) Blueprint (L)",
          "Cochran R3 (L) Blueprint (L)",
          "Cochran R5 (L) Blueprint (L)",
          "Cochran R7 (L) Blueprint (L)",
          "Cochran R9 (L) Blueprint (L)",
          "Adapted Cochran R10 (L) Blueprint (L)",
          "Vincent DPS P12 (L) Blueprint (L)",
          "Vincent DPS P16 (L) Blueprint (L)",
          "Vincent DPS P20 (L) Blueprint (L)",
          "Vincent DPS P24 (L) Blueprint (L)",
          "Vincent DPS P28 (L) Blueprint (L)",
          "Vincent DPS P32 (L) (L) Blueprint (L)",
          "Vincent DPS P37 (L)Blueprint (L)",
          "Vincent DPS P43 (L) Blueprint (L)",
          "Vincent DPS P50 (L) Blueprint (L)",
          "Vincent DPS P58 (L) Blueprint (L)",
          "Vincent DPS P66 (L) Blueprint (L)",
          "Vincent DPS P74 (L) Blueprint (L)",
          "Vincent DPS P82 (L) Blueprint (L)",
          "Vincent DPS P91 (L) Blueprint (L)",
          "Vincent DPS R12 (L) Blueprint (L)",
          "Vincent DPS R16 (L) Blueprint (L)",
          "Vincent DPS R20 (L) Blueprint (L)",
          "Vincent DPS R24 (L) Blueprint (L)",
          "Vincent DPS R28 (L) Blueprint (L)",
          "Vincent DPS R32 (L) Blueprint (L)",
          "Vincent DPS R37 (L) Blueprint (L)",
          "Vincent DPS R43 (L) Blueprint (L)",
          "Vincent DPS R50 (L) Blueprint (L)",
          "Vincent DPS R58 (L) Blueprint (L)",
          "Vincent DPS R66 (L) Blueprint (L)",
          "Vincent DPS R74 (L) Blueprint (L)",
          "Vincent DPS R82 (L) Blueprint (L)",
          "Vincent DPS R91 (L) Blueprint (L)",
          "Vincent DPS LP12 (L) Blueprint (L)",
          "Vincent DPS LP16 (L) Blueprint (L)",
          "Vincent DPS LP20 (L) Blueprint (L)",
          "Vincent DPS LP24 (L) Blueprint (L)",
          "Vincent DPS LP28 (L) Blueprint (L)",
          "Vincent DPS LP32 (L) Blueprint (L)",
          "Vincent DPS LP37 (L) Blueprint (L)",
          "Vincent DPS LP43 (L) Blueprint (L)",
          "Vincent DPS LP50 (L) Blueprint (L)",
          "Vincent DPS LP58 (L) Blueprint (L)",
          "Vincent DPS LP66 (L) Blueprint (L)",
          "Vincent DPS LP74 (L) Blueprint (L)",
          "Vincent DPS LP82 (L) Blueprint (L)",
          "Vincent DPS LP91 (L) Blueprint (L)",
          "Vincent DPS LR12 (L) Blueprint (L)",
          "Vincent DPS LR16 (L) Blueprint (L)",
          "Vincent DPS LR20 (L) Blueprint (L)",
          "Vincent DPS LR24 (L) Blueprint (L)",
          "Vincent DPS LR28 (L) Blueprint (L)",
          "Vincent DPS LR32 (L) Blueprint (L)",
          "Vincent DPS LR37 (L) Blueprint (L)",
          "Vincent DPS LR43 (L) Blueprint (L)",
          "Vincent DPS LR50 (L) Blueprint (L)",
          "Vincent DPS LR58 (L) Blueprint (L)",
          "Vincent DPS LR66 (L) Blueprint (L)",
          "Vincent DPS LR74 (L) Blueprint (L)",
          "Vincent DPS LR82 (L) Blueprint (L)",
          "Vincent DPS LR91 (L) Blueprint (L)",
          "Holly ECO R14 (L) Blueprint (L)",
          "Holly ECO R18 (L) Blueprint (L)",
          "Holly ECO R22 (L) Blueprint (L)",
          "Holly ECO R26 (L) Blueprint (L)",
          "Holly ECO R30 (L) Blueprint (L)",
          "Holly ECO R35 (L) Blueprint (L)",
          "Holly ECO R41 (L) Blueprint (L)",
          "Holly ECO R48 (L) Blueprint (L)",
          "Holly ECO R56 (L) Blueprint (L)",
          "Holly ECO R64 (L) Blueprint (L)",
          "Holly ECO R72 (L) Blueprint (L)",
          "Holly ECO R80 (L) Blueprint (L)",
          "Holly ECO R89 (L) Blueprint (L)",
          "Holly ECO P14 (L) Blueprint (L)",
          "Holly ECO P18 (L) Blueprint (L)",
          "Holly ECO P22 (L) Blueprint (L)",
          "Holly ECO P26 (L) Blueprint (L)",
          "Holly ECO P30 (L) Blueprint (L)",
          "Holly ECO P35 (L) Blueprint (L)",
          "Holly ECO P41 (L) Blueprint (L)",
          "Holly ECO P48 (L) Blueprint (L)",
          "Holly ECO P56 (L) Blueprint (L)",
          "Holly ECO P64 (L) Blueprint (L)",
          "Holly ECO P72 (L) Blueprint (L)",
          "Holly ECO P80 (L) Blueprint (L)",
          "Holly ECO P89 (L) Blueprint (L)",
          "Holly ECO LP14 (L) Blueprint (L)",
          "Holly ECO LP18 (L) Blueprint (L)",
          "Holly ECO LP22 (L) Blueprint (L)",
          "Holly ECO LP26 (L) Blueprint (L)",
          "Holly ECO LP30 (L) Blueprint (L)",
          "Holly ECO LP35 (L) Blueprint (L)",
          "Holly ECO LP41 (L) Blueprint (L)",
          "Holly ECO LP48 (L) Blueprint (L)",
          "Holly ECO LP56 (L) Blueprint (L)",
          "Holly ECO LP64 (L) Blueprint (L)",
          "Holly ECO LP72 (L) Blueprint (L)",
          "Holly ECO LP80 (L) Blueprint (L)",
          "Holly ECO LP89 (L) Blueprint (L)",
          "Holly ECO LR14 (L) Blueprint (L)",
          "Holly ECO LR18 (L) Blueprint (L)",
          "Holly ECO LR22 (L) Blueprint (L)",
          "Holly ECO LR26 (L) Blueprint (L)",
          "Holly ECO LR30 (L) Blueprint (L)",
          "Holly ECO LR35 (L) Blueprint (L)",
          "Holly ECO LR41 (L) Blueprint (L)",
          "Holly ECO LR48 (L) Blueprint (L)",
          "Holly ECO LR56 (L) Blueprint (L)",
          "Holly ECO LR64 (L) Blueprint (L)",
          "Holly ECO LR72 (L) Blueprint (L)",
          "Holly ECO LR80 (L) Blueprint (L)",
          "Holly ECO LR89 (L) Blueprint (L)",
          "Luck Potion Blueprint",
          "Optimism Potion Blueprint",
          "Patience Potion Blueprint",
          "Flair Potion Blueprint",
          "Disapointment Potion Blueprint",
          "Tears Potion Blueprint",
          "Nepotism Potion Blueprint",
          "Failure Potion Blueprint",
          "Discipline Potion Blueprint",
          "Talent Potion Blueprint",
          "Hard Work Potion Blueprint",
          "Focus Potion Blueprint",
          "Charisma Potion Blueprint",
          "Desire Potion Blueprint",
          "Big Daddys' Nut Potion Blueprint",
          "Style Potion Blueprint",
          "Faith Potion Blueprint",
          "Foresight Potion Blueprint",
          "Love Potion Blueprint",
          "Insight Potion Blueprint",
          "Lockpick Kit I Blueprint (L)",
          "Lockpick Kit II Blueprint (L)",
          "Lockpick Kit III Blueprint (L)",
          "Lockpick Kit IV Blueprint (L)",
          "Lockpick Kit V Blueprint (L)",
          "Lockpick Kit VI Blueprint (L)",
          "Lockpick Kit VII Blueprint (L)",
          "Lockpick Kit VIII Blueprint (L)",
          "Lockpick Kit IX Blueprint (L)",
          "Lockpick Kit X Blueprint (L)",
          "Hell Key I Blueprint (L)",
          "Hell Key II Blueprint (L)",
          "Hell Key III Blueprint (L)",
          "Hell Key IV Blueprint (L)",
          "Hell Key V Blueprint (L)",
          "Hell Key VI Blueprint (L)",
          "Hell Key VII Blueprint (L)",
          "Hell Key VIII Blueprint (L)",
          "Hell Key IX Blueprint (L)",
          "Hell Key X Blueprint (L)",
          "Spam Helmet Blueprint (L)",
          "Spam Arm Guards (L) Blueprint (L)",
          "Spam Gloves (L) Blueprint (L)",
          "Spam Harness (L) Blueprint (L)",
          "Spam Thigh Guards (L) Blueprint (L)",
          "Spam Shin Guards (L) Blueprint (L)",
          "Spam Foot Guards (L) Blueprint (L)",
          "Malware Helmet (L) Blueprint (L)",
          "Malware Arm Guards (L) Blueprint (L)",
          "Malware Gloves (L) Blueprint (L)",
          "Malware Harness (L) Blueprint (L)",
          "Malware Thigh Guards (L) Blueprint (L)",
          "Malware Shin Guards (L) Blueprint (L)",
          "Malware Foot Guards (L) Blueprint (L)",
          "Spam Plate (L) Blueprint (L)",
          "Malware Plate (L) Blueprint (L)",
          "Anti Virus Plate (L) Blueprint (L)",
          "Cheetah Texture Blueprint",
          "Couger Texture Blueprint",
          "Elvis Dragon Texture Blueprint",
          "Garcia Dragon Texture Blueprint",
          "Hendrix Dragon Texture Blueprint",
          "Joplin Dragon Texture Blueprint",
          "Lemmy Dragon Texture Blueprint",
          "Leopard Texture Blueprint",
          "Morrison Dragon Texture Blueprint",
          "NEVERDIE Dragon Texture Blueprint",
          "Panther Texture Blueprint",
          "Pop Dragon Texture Blueprint",
          "Rudolf Texture Blueprint",
          "Tiger Texture Blueprint",
          "Code Demon Texture Blueprint",
          "Cyber Demon Texture Blueprint",
          "Demon Hacker Texture Blueprint",
          "Demon Virus Texture Blueprint",
          "Lockpick Kit I Blueprint",
          "Lockpick Kit II Blueprint",
          "Lockpick Kit III Blueprint",
          "Lockpick Kit IV Blueprint",
          "Lockpick Kit V Blueprint",
          "Lockpick Kit VI Blueprint",
          "Lockpick Kit VII Blueprint",
          "Lockpick Kit VIII Blueprint",
          "Lockpick Kit IX Blueprint",
          "Lockpick Kit X Blueprint",
          "Hell Key I Blueprint",
          "Hell Key II Blueprint",
          "Hell Key III Blueprint",
          "Hell Key IV Blueprint",
          "Hell Key V Blueprint",
          "Hell Key VI Blueprint",
          "Hell Key VII Blueprint",
          "Hell Key VIII Blueprint",
          "Hell Key IX Blueprint",
          "Hell Key X Blueprint",
          "NEVERDIE Dragon Plate mk1 Blueprint (L)",
          "NEVERDIE Dragon Plate mk2 (L) Blueprint (L)",
          "NEVERDIE Dragon Plate mk3 (L) Blueprint (L)",
          "MORRISON Dragon Plate mk1 (L) Blueprint (L)",
          "MORRISON Dragon Plate mk2 (L) Blueprint (L)",
          "MORRISON Dragon Plate mk3 (L) Blueprint (L)",
          "ELVIS Dragon Plate mk1 (L) Blueprint (L)",
          "ELVIS Dragon Plate mk2 (L) Blueprint (L)",
          "ELVIS Dragon Plate mk3 (L) Blueprint (L)",
          "GARCIA Dragon Plate mk1 (L) Blueprint (L)",
          "GARCIA Dragon Plate mk2 (L) Blueprint (L)",
          "GARCIA Dragon Plate mk3 (L) Blueprint (L)",
          "HENDRIX Dragon Plate mk1 (L) Blueprint (L)",
          "HENDRIX Dragon Plate mk2 (L) Blueprint (L)",
          "HENDRIX Dragon Plate mk3 (L) Blueprint (L)",
          "POP Dragon Plate mk1 (L) Blueprint (L)",
          "POP Dragon Plate mk2 (L) Blueprint (L)",
          "POP Dragon Plate mk3 (L) Blueprint (L)",
          "JOPLIN Dragon Plate mk1 (L) Blueprint (L)",
          "JOPLIN Dragon Plate mk2 (L) Blueprint (L)",
          "JOPLIN Dragon Plate mk3 (L) Blueprint (L)",
          "RUDOLF Dragon Plate mk1 (L) Blueprint (L)",
          "RUDOLF Dragon Plate mk2 (L) Blueprint (L)",
          "RUDOLF Dragon Plate mk3 (L) Blueprint (L)",
          "LEMMY Dragon Plate mk1 (L) Blueprint (L)",
          "LEMMY Dragon Plate mk2 (L) Blueprint (L)",
          "LEMMY Dragon Plate mk3 (L) Blueprint (L)",
          "ROCTEC Disc Brake Blueprint",
          "ROCTEC Chair Frame Blueprint",
          "ROCTEC Drive Shaft Blueprint",
          "ROCTEC Girder Beams Blueprint",
          "ROCTEC Radiator Blueprint",
          "ROCTEC Steering Rod Blueprint",
          "ROCTEC Wind Screen Blueprint",
          "ROCTEC Combuster Blueprint",
          "ROCTEC Lamp Attachments Blueprint",
          "ROCTEC Vehicle Battery Blueprint (L)",
          "PRX Limited Blueprint (L)",
          "PRX Biohazard (L) Blueprint (L)",
          "PRX Sport (L) Blueprint (L)",
          "PRX Funky Monkey (L) Blueprint (L)",
          "PRX Scorpion (L) Blueprint (L)",
          "PRX Superstar (L) Blueprint (L)",
          "PRX Double Dragon (L) Blueprint (L)",
          "PRX Roadster (L) Blueprint (L)",
          "PRX Pirate (L) Blueprint (L)",
          "PRX Pirate SE (L) Blueprint (L)",
          "Weak Witchs Broom (L) Blueprint (L)",
          "Apprentice Witchs Broom (L) Blueprint (L)",
          "Cursed Witchs Broom (L) Blueprint (L)",
          "Conjured Witchs Broom (L) Blueprint (L)",
          "Magical Witchs Broom (L) Blueprint (L)",
          "Mystical Witchs Broom (L) Blueprint (L)",
          "Evil Witchs Broom (L) Blueprint (L)",
          "Sacred Witchs Broom (L) Blueprint (L)",
          "Ancient Witchs Broom (L) Blueprint (L)",
          "Queen Of The Witchs Broom (L) Blueprint (L)",
          "Cochran LR1 (L) Blueprint",
          "Cochran LR3 (L) Blueprint",
          "Cochran LR5 (L) Blueprint",
          "Cochran LR7 (L) Blueprint",
          "Cochran LR9 (L) Blueprint",
          "Adapted Cochran LR10 (L) Blueprint",
          "Cochran LP1 (L) Blueprint",
          "Cochran LP3 (L) Blueprint",
          "Cochran LP5 (L) Blueprint",
          "Cochran LP7 (L) Blueprint",
          "Cochran LP9 (L) Blueprint",
          "Adapted Cochran LP10 (L) Blueprint",
          "Cochran P1 (L) Blueprint",
          "Cochran P3 (L) Blueprint",
          "Cochran P5 (L) Blueprint",
          "Cochran P7 (L) Blueprint",
          "Cochran P9 (L) Blueprint",
          "Adapted Cochran P10 (L) Blueprint",
          "Cochran R1 (L) Blueprint",
          "Cochran R3 (L) Blueprint",
          "Cochran R5 (L) Blueprint",
          "Cochran R7 (L) Blueprint",
          "Cochran R9 (L) Blueprint",
          "Adapted Cochran R10 (L) Blueprint",
          "Vincent DPS P12 (L) (L) Blueprint",
          "Vincent DPS P16 (L) (L) Blueprint",
          "Vincent DPS P20 (L) Blueprint",
          "Vincent DPS P24 (L) Blueprint",
          "Vincent DPS P28 (L) Blueprint",
          "Vincent DPS P32 (L) Blueprint",
          "Vincent DPS P37 (L) Blueprint",
          "Vincent DPS P43 (L) Blueprint",
          "Vincent DPS P50 (L) Blueprint",
          "Vincent DPS P58 (L) Blueprint",
          "Vincent DPS P66 (L) Blueprint",
          "Vincent DPS P74 (L) Blueprint",
          "Vincent DPS P82 (L) Blueprint",
          "Vincent DPS P91 (L) Blueprint",
          "Vincent DPS R12 (L) Blueprint",
          "Vincent DPS R16 (L) Blueprint",
          "Vincent DPS R20 (L) Blueprint",
          "Vincent DPS R24 (L) Blueprint",
          "Vincent DPS R28 (L) Blueprint",
          "Vincent DPS R32 (L) Blueprint",
          "Vincent DPS R37 (L) Blueprint",
          "Vincent DPS R43 (L) Blueprint",
          "Vincent DPS R50 (L) Blueprint",
          "Vincent DPS R58 (L) Blueprint",
          "Vincent DPS R66 (L) Blueprint",
          "Vincent DPS R74 (L) Blueprint",
          "Vincent DPS R82 (L) Blueprint",
          "Vincent DPS R91 (L) Blueprint",
          "Vincent DPS LP12 (L) Blueprint",
          "Vincent DPS LP16 (L) Blueprint",
          "Vincent DPS LP20 (L) Blueprint",
          "Vincent DPS LP24 (L) Blueprint",
          "Vincent DPS LP28 (L) Blueprint",
          "Vincent DPS LP32 (L) Blueprint",
          "Vincent DPS LP37 (L) Blueprint",
          "Vincent DPS LP43 (L) Blueprint",
          "Vincent DPS LP50 (L) Blueprint",
          "Vincent DPS LP58 (L) Blueprint",
          "Vincent DPS LP66 (L) Blueprint",
          "Vincent DPS LP74 (L) Blueprint",
          "Vincent DPS LP82 (L) Blueprint",
          "Vincent DPS LP91 (L) Blueprint",
          "Vincent DPS LR12 (L) Blueprint",
          "Vincent DPS LR16 (L) Blueprint",
          "Vincent DPS LR20 (L) Blueprint",
          "Vincent DPS LR24 (L) Blueprint",
          "Vincent DPS LR28 (L) Blueprint",
          "Vincent DPS LR32 (L) Blueprint",
          "Vincent DPS LR37 (L) Blueprint",
          "Vincent DPS LR43 (L) Blueprint",
          "Vincent DPS LR50 (L) Blueprint",
          "Vincent DPS LR58 (L) Blueprint",
          "Vincent DPS LR66 (L) Blueprint",
          "Vincent DPS LR74 (L) Blueprint",
          "Vincent DPS LR82 (L) Blueprint",
          "Vincent DPS LR91 (L) Blueprint",
          "Holly ECO R14 (L) Blueprint",
          "Holly ECO R18 (L) Blueprint",
          "Holly ECO R22 (L) Blueprint",
          "Holly ECO R26 (L) Blueprint",
          "Holly ECO R30 (L) Blueprint",
          "Holly ECO R35 (L) Blueprint",
          "Holly ECO R41 (L) Blueprint",
          "Holly ECO R48 (L) Blueprint",
          "Holly ECO R56 (L) Blueprint",
          "Holly ECO R64 (L) Blueprint",
          "Holly ECO R72 (L) Blueprint",
          "Holly ECO R80 (L) Blueprint",
          "Holly ECO R89 (L) Blueprint",
          "Holly ECO P14 (L) Blueprint",
          "Holly ECO P18 (L) Blueprint",
          "Holly ECO P22 (L) Blueprint",
          "Holly ECO P26 (L) Blueprint",
          "Holly ECO P30 (L) Blueprint",
          "Holly ECO P35 (L) Blueprint",
          "Holly ECO P41 (L) Blueprint",
          "Holly ECO P48 (L) Blueprint",
          "Holly ECO P56 (L) Blueprint",
          "Holly ECO P64 (L) Blueprint",
          "Holly ECO P72 (L) Blueprint",
          "Holly ECO P80 (L) Blueprint",
          "Holly ECO P89 (L) Blueprint",
          "Holly ECO LP14 (L) Blueprint",
          "Holly ECO LP18 (L) Blueprint",
          "Holly ECO LP22 (L) Blueprint",
          "Holly ECO LP26 (L) Blueprint",
          "Holly ECO LP30 (L) Blueprint",
          "Holly ECO LP35 (L) Blueprint",
          "Holly ECO LP41 (L) Blueprint",
          "Holly ECO LP48 (L) Blueprint",
          "Holly ECO LP56 (L) Blueprint",
          "Holly ECO LP64 (L) Blueprint",
          "Holly ECO LP72 (L) Blueprint",
          "Holly ECO LP80 (L) Blueprint",
          "Holly ECO LP89 (L) Blueprint",
          "Holly ECO LR14 (L) Blueprint",
          "Holly ECO LR18 (L) Blueprint",
          "Holly ECO LR22 (L) Blueprint",
          "Holly ECO LR26 (L) Blueprint",
          "Holly ECO LR30 (L) Blueprint",
          "Holly ECO LR35 (L) Blueprint",
          "Holly ECO LR41 (L) Blueprint",
          "Holly ECO LR48 (L) Blueprint",
          "Holly ECO LR56 (L) Blueprint",
          "Holly ECO LR64 (L) Blueprint",
          "Holly ECO LR72 (L) Blueprint",
          "Holly ECO LR80 (L) Blueprint",
          "Holly ECO LR89 (L) Blueprint",
          "Hoverboard Low Power Pod Blueprint (L)",
          "Hoverboard Mid Power Pod Blueprint (L)",
          "Hoverboard High Power Pod Blueprint (L)",
          "Hoverboard Low Power Board Blueprint (L)",
          "Hoverboard Mid Power Board Blueprint (L)",
          "Hoverboard High Power Board Blueprint (L)",
          "Hoverboard Limited Blueprint (L)",
          "Hoverboard Alien Edition (L) Blueprint (L)",
          "Hoverboard Nasty Bat Edition (L) Blueprint (L)",
          "Hoverboard Purty Butterfly Edition (L) Blueprint (L)",
          "Hoverboard Death To Life Edition (L) Blueprint (L)",
          "Hoverboard Funky Monkey Edition (L) Blueprint (L)",
          "Hoverboard Space Invasion Edition (L) Blueprint (L)",
          "Hoverboard Superstar Edition (L) Blueprint (L)",
          "Hoverboard Dual Pistols Edition (L) Blueprint (L)",
          "Hoverboard Lucha Libre Edition (L) Blueprint (L)",
          "Hoverboard FAHQ Edition (L) Blueprint (L)",
          "Surfboard Space Invasion Edition (L) Blueprint (L)",
          "Surfboard Flower Power Edition (L) Blueprint (L)",
          "Surfboard Funky Monkey Edition (L) Blueprint (L)",
          "Surfboard Sexy Time Edition (L) Blueprint (L)",
          "Surfboard Stylin Edition (L) Blueprint (L)",
          "Blueprint Hoverboard Crapster Edition (L)",
          "Blueprint Hoverboard Alien Lame Edition (L)",
          "Blueprint Hoverboard Nasty Bat Junky Edition (L)",
          "Level III Finder Amplifier 'Athena' Blueprint",
          "Level III Finder Amplifier 'Athena' Blueprint (L)",
          "Level V Finder Amplifier 'Athena' Blueprint",
          "Level V Finder Amplifier 'Athena' Blueprint (L)",
          "Grindhouse Sleaze Blueprint",
          "Grindhouse Rodriguez (L) Blueprint",
          "Grindhouse Tarantino (L) Blueprint",
          "Grindhouse Striptease (L) Blueprint",
          "Three Inch Nails Blueprint (L)",
          "Six Inch Nails Blueprint (L)",
          "Nine Inch Nails Blueprint (L)",
          "JUELZ MIC-Killa SG-1 Blueprint (L)",
          "JUELZ MC-Killa Rifle SG-2 (L) Blueprint (L)",
          "JUELZ MIC-Killa SG-3 (L) Blueprint (L)",
          "JUELZ MIC-Killa SG-4 (L) Blueprint (L)",
          "JUELZ MIC-Killa SG-5 (L) Blueprint (L)",
          "JUELZ MIC-Killa SG-6 (L) Blueprint (L)",
          "JUELZ MIC-Killa SG-7 (L) Blueprint (L)",
          "JUELZ MIC-Killa SG-8 (L) Blueprint (L)",
          "JUELZ MIC-Killa SG-9 (L) Blueprint (L)",
          "JUELZ MIC-Killa SG-10 (L) Blueprint (L)",
          "JUELZ MIC-Killa SG-ULTRA (L) Blueprint (L)",
          "Marcato-9 503:3509 Blueprint (L)",
          "Marcato-9 RFZ (L) Blueprint (L)",
          "Marcato-9 Steampunk (L) Blueprint (L)",
          "Marcato-9 PK-Pal (L) Blueprint (L)",
          "Niente-11 (L) Blueprint (L)",
          "Niente-11 RFZ (L) Blueprint (L)",
          "Niente-11 Steampunk (L) Blueprint (L)",
          "Niente-11 PK-Pal (L) Blueprint (L)",
          "Cressendo-41 (L) Blueprint (L)",
          "Cressendo-41 RFZ (L) Blueprint (L)",
          "Cressendo-41 Steampunk (L) Blueprint (L)",
          "Cressendo-41 PK-Pal (L) Blueprint (L)",
          "Calmando-12 (L) Blueprint (L)",
          "Calmando-12 RFZ (L) Blueprint (L)",
          "Calmando-12 Steampunk (L) Blueprint (L)",
          "Calmando-12 PK-Pal (L) Blueprint (L)",
          "Fortissimo-18 Blueprint (L)",
          "Fortissimo-18 RFZ (L) Blueprint (L)",
          "Fortissimo-18 Steampunk (L) Blueprint (L)",
          "Fortissimo-18 PK-Pal (L) Blueprint (L)",
          "California FAP mk I Blueprint (L)",
          "California FAP mk II Blueprint (L)",
          "Winston Classic Pub Stool Blueprint (L)",
          "Dekotown Modern Bar Stool Blueprint (L)",
          "New Order Hexigon Wall Shelf Blueprint (L)",
          "Classic Decotown Short Wall Shelf Blueprint",
          "Traditional Decotown Short Wall Shelf Blueprint (L)",
          "Classic Decotown Long Wall Shelf Blueprint",
          "Traditional Decotown Long Wall Shelf Blueprint (L)",
          "Winston Short Corner Bookshelf Blueprint (L)",
          "Winston Short Bookshelf Blueprint",
          "Winston Short Slim Bookshelf Blueprint (L)",
          "Winston Short Wide Bookshelf Blueprint (L)",
          "Winston Tall Corner Bookshelf Blueprint (L)",
          "Winston Tall Bookshelf Blueprint (L)",
          "Winston Tall Slim Bookshelf Blueprint (L)",
          "Winston Tall Wide Bookshelf Blueprint (L)",
          "Decotown Moderno Coffee Table Blueprint (L)",
          "Classic Winston Long Table Blueprint (L)",
          "Traditional Winston Long Table Blueprint (L)",
          "Distinguished Winston Long Table Blueprint (L)",
          "Traditional Winston Round Table Blueprint (L)",
          "Classic Winston Round Table Blueprint (L)",
          "Distinguished Winston Round Table Blueprint (L)",
          "Classic Winston Half-Round Table Blueprint (L)",
          "Traditional Winston Half-Round Table Blueprint (L)",
          "Distinguished Winston Half-Round Table Blueprint (L)",
          "Classic Winston Short Table Blueprint (L)",
          "Traditional Winston Short Table Blueprint (L)",
          "Distinguished Winston Short Table Blueprint (L)",
          "Relaxo Blue Groove Chair Blueprint (L)",
          "Relaxo Green Groove Chair Blueprint (L)",
          "Relaxo Red Groove Chair Blueprint (L)",
          "Relaxo Yellow Groove Chair Blueprint (L)",
          "Supreme Relaxo Blue Groove Chair Blueprint (L)",
          "Supreme Relaxo Green Groove Chair Blueprint (L)",
          "Supreme Relaxo Red Groove Chair Blueprint (L)",
          "Supreme Relaxo Yellow Groove Chair Blueprint (L)",
          "Creative Juice Blueprint",
          "Rolled Smokes Blueprint (L)",
          "Hell Coin Blueprint (L)",
          "NEVERDIE Pardon Blueprint (L)",
          "ROCKtropia War Bond Blueprint (L)",
          "ROCKtropia Liberty Bond Blueprint (L)",
          "ROCKtropia Victory Bond Blueprint (L)",
          "M-Ray 1000 Laser Rifle (L) Blueprint (L)",
          "M-Ray 2000 Laser Rifle (L) Blueprint (L)",
          "M-Ray 3000 Laser Rifle (L) Blueprint (L)",
          "M-Ray 4000 Laser Rifle (L) Blueprint (L)",
          "M-Ray 1000 Laser Pistol (L) Blueprint (L)",
          "M-Ray 2000 Laser Pistol (L) Blueprint (L)",
          "M-Ray 3000 Laser Pistol (L) Blueprint (L)",
          "M-Ray 4000 Laser Pistol (L) Blueprint (L)",
          "M-Ray 5000 Laser Pistol (L) Blueprint (L)",
          "JoJo-1 Laser Rifle (L) Blueprint (L)",
          "JoJo-2 Laser Rifle (L) Blueprint (L)",
          "JoJo-3 Laser Rifle (L) Blueprint (L)",
          "JoJo-4 Laser Rifle (L) Blueprint (L)",
          "JoJo-5 Laser Rifle (L) Blueprint (L)",
          "JoJo-6 Laser Rifle (L) Blueprint (L)",
          "Toddler-1 Laser Pistol (L) Blueprint (L)",
          "Toddler-2 Laser Pistol (L) Blueprint (L)",
          "Toddler-3 Laser Pistol (L) Blueprint (L)",
          "Toddler-4 Laser Pistol (L) Blueprint (L)",
          "Toddler-5 Laser Pistol (L) Blueprint (L)",
          "Toddler-6 Laser Pistol (L) Blueprint (L)",
          "SmallFry-1 Laser Rifle (L) Blueprint (L)",
          "SmallFry-2 Laser Rifle (L) Blueprint (L)",
          "SmallFry-3 Laser Rifle (L) Blueprint (L)",
          "Lux Deed Case Blueprint (L)",
          "Lux Blueprint Book Case Blueprint (L)",
          "Lux Breif Case Blueprint (L)",
          "Lux Assassin Case Blueprint (L)",
          "Lux Enhancer Case Blueprint (L)",
          "Lux Plate Case Blueprint (L)",
          "Lux Attachment Case Blueprint (L)",
          "Lux Mind Case Blueprint (L)",
          "Lux Miners Trunk Blueprint (L)",
          "Lux Amplifier Trunk Blueprint (L)",
          "Lux ROCK Trunk Blueprint (L)",
          "Lux Cocktail Trunk Blueprint (L)",
          "Lux Doctor Trunk Blueprint (L)",
          "Lux Foot Locker Blueprint (L)",
          "Lux Tuckbox Blueprint (L)",
          "Lux Ammo Trunk Blueprint (L)",
          "Lux Suit Luggage Blueprint (L)",
          "Lux Dress Luggage Blueprint (L)",
          "Lux Armor Luggage Blueprint (L)",
          "Lux Secondary Armor Luggage Blueprint (L)",
          "Lux Special Armor Luggage Blueprint (L)",
          "Lux Accessory Luggage Blueprint (L)",
          "Lux Rifle Luggage Blueprint (L)",
          "Lux Melee Luggage Blueprint (L)",
          "Lux Casual Luggage Blueprint (L)",
          "Lux Fashion Luggage Blueprint (L)",
          "Creative Juice Remix Blueprint",
          "Rolled Smokes Remix Blueprint (L)",
          "Teleman Coin Remix Blueprint (L)",
          "Vampire Charm Bracelets Blueprint (L)",
          "Lycan Charm Bracelets Blueprint (L)",
          "Zombie Charm Bracelets Blueprint (L)",
          "Wolf Charm Bracelets Blueprint (L)",
          "Snaggle Charm Bracelets Blueprint (L)",
          "Spare Tire Marina Basement Key Blueprint",
          "The Vampire Tomb Basement Key Blueprint",
          "X-Change Creatives Basement Key Blueprint",
          "Wolf and Vixen Pub Basement Key Blueprint",
          "TEX-NO Records Basement Key Blueprint",
          "Blisco Marketplace Basement Key Blueprint",
          "Backlot Shop Basement Key Blueprint",
          "South End Shop Basement Key Blueprint",
          "Jolly Hoffer Basement Key Blueprint",
          "UK Fashion Basement Key Blueprint",
          "Brixton Bass Basement Key Blueprint",
          "Wasted ROCKstar Basement Key Blueprint",
          "Hi-Style Salon Basement Key Blueprint",
          "Hounslow Exchange Basement Key Blueprint",
          "Zombie Arms Basement Key Blueprint",
          "Tangerine Basement Key Blueprint",
          "Green Hack Code Blueprint",
          "Blue Hack Code Blueprint",
          "Orange Hack Code Blueprint",
          "Purple Hack Code Blueprint",
          "Red Hack Code Blueprint",
          "Yellow Hack Code Blueprint",
          "Brown Hack Code Blueprint",
          "White Hack Code Blueprint",
          "Black Hack Code Blueprint",
          "Master Hack Code Blueprint",
          "Speed Bike (L) Blueprint (L)",
          "Vampire Charm Bracelets Blueprint",
          "Lycan Charm Bracelets Blueprint",
          "Zombie Charm Bracelets Blueprint",
          "Wolf Charm Bracelets Blueprint",
          "Snaggle Charm Bracelets Blueprint",
          "Ancient Pirate Flag Blueprint",
          "German Pirate Flag Blueprint",
          "Romanian Pirate Flag Blueprint",
          "Dutch Pirate Flag Blueprint",
          "Spanish Pirate Flag Blueprint",
          "British Pirate Flag Blueprint",
          "Swedish Pirate Flag Blueprint",
          "Polish Pirate Flag Blueprint",
          "Russian Pirate Flag Blueprint",
          "Australian Pirate Flag Blueprint",
          "French Pirate Flag Blueprint",
          "Canadian Pirate Flag Blueprint",
          "American Pirate Flag Blueprint",
          "Horny Devil Monster Truck (L) Blueprint (L)",
          "Zombie Kong Monster Truck (L) Blueprint (L)",
          "Vamp Bite Monster Truck (L) Blueprint (L)",
          "Monster Truck (L) Blueprint (L)",
          "Monster Truck Wheel (L) Blueprint (L)",
          "ROCTEC S16 Finder (L) Blueprint (L)",
          "ROCTEC M1-LF Finder (L) Blueprint (L)",
          "ROCTEC C0UGR Finder (L) Blueprint (L)",
          "California FAP mk III (L) Blueprint (L)",
          "California FAP mk IV (L) Blueprint (L)",
          "B.A.M.F Cute Chainsaw (L) Blueprint (L)",
          "B.A.M.F Rustic Chainsaw (L) Blueprint (L)",
          "B.A.M.F Marine Chainsaw (L) Blueprint (L)",
          "B.A.M.F Bloody Chainsaw (L) Blueprint (L)",
          "B.A.M.F Golden Chainsaw (L) Blueprint (L)",
          "Bonzo Slim Jim Blueprint (L)",
          "Bonzos Lockpick Blueprint",
          "Pawn Shop Lockpick Blueprint",
          "ROCTEC Wetski Steering Column Blueprint (L)",
          "Wetski (L) Blueprint (L)",
          "Gas and Go Lockpick Kit Blueprint",
          "Cheeky Finder Amp (L) Blueprint (L)",
          "Cheeky Finder Amp (L) Blueprint",
          "F-Class Mining Amp (L) Blueprint (L)",
          "E-Class Mining Amp (L) Blueprint",
          "D-Class Mining Amp (L) Blueprint (L)",
          "C-Class Mining Amp (L) Blueprint (L)",
          "B-Class Mining Amp (L) Blueprint (L)",
          "A-Class Mining Amp (L) Blueprint (L)",
          "F-Class Mining Amp (L) Blueprint",
          "D-Class Mining Amp (L) Blueprint",
          "C-Class Mining Amp (L) Blueprint",
          "B-Class Mining Amp (L) Blueprint",
          "A-Class Mining Amp (L) Blueprint",
          "Demonic Miners Detector MK-I (L) Blueprint",
          "Demonic Excavator MK-I (L) Blueprint",
          "Demonic Refiner MK-I (L) Blueprint",
          "Miners Detector MK-I (L) Blueprint (L)",
          "Miners Excavator MK-I (L) Blueprint (L)",
          "Miners Refiner MK-I (L) Blueprint (L)",
          "Miners Excavator MK-II (L) Blueprint (L)",
          "Miners Detector MK-II (L) Blueprint (L)",
          "Miners Refiner MK-II (L) Blueprint (L)",
          "Demonic Detector MK-II (L) Blueprint (L)",
          "Demonic Excavator MK-II (L) Blueprint (L)",
          "Demonic Refiner MK-II (L) Blueprint (L)",
          "Miners Detector MK-III (L) Blueprint (L)",
          "Miners Excavator MK-III (L) Blueprint (L)",
          "Miners Refiner MK-III (L) Blueprint (L)",
          "Demonic Detector MK-III (L) Blueprint (L)",
          "Demonic Excavator MK-III (L) Blueprint (L)",
          "Demonic Refiner MK-III (L) Blueprint (L)",
          "NEVERDIE LS Series 001 (L) Blueprint (L)",
          "NEVERDIE LS Series 002 (L) Blueprint (L)",
          "NEVERDIE LS Series 003 (L) Blueprint (L)",
          "NEVERDIE LS Series 004 (L) Blueprint (L)",
          "NEVERDIE LS Series 005 (L) Blueprint (L)",
          "NEVERDIE LS Series 006 (L) Blueprint (L)",
          "NEVERDIE LS Series 007 (L) Blueprint (L)",
          "NEVERDIE LS Series 008 (L) Blueprint (L)",
          "NEVERDIE LS Series 009 (L) Blueprint (L)",
          "NEVERDIE LS Series 010 (L) Blueprint (L)",
          "Firewall Helmet (L) Blueprint",
          "Firewall Arm Guards (L) Blueprint",
          "Firewall Gloves (L) Blueprint",
          "Firewall Harness (L) Blueprint",
          "Firewall Thigh Guards (L) Blueprint",
          "Firewall Shin Guards (L) Blueprint",
          "Firewall Foot Guards (L) Blueprint",
          "Green Snake Skin Texture Blueprint",
          "Purple Snake Skin Texture Blueprint",
          "Brown Snake Skin Texture Blueprint",
          "Firewall Foot Guards Mk-II (L) Blueprint",
          "Firewall Gloves Mk-II (L) Blueprint",
          "Firewall Helmet Mk-II (L) Blueprint",
          "Firewall Shin Guards Mk-II (L) Blueprint",
          "Firewall Thigh Guards Mk-II (L) Blueprint",
          "Firewall Harness Mk-II (L) Blueprint",
          "Firewall Arm Guards Mk-II (L) Blueprint",
          "Coral Snake Skin Texture Blueprint",
          "Black Snake Skin Texture Blueprint",
          "Firewall Foot Guards Mk-III (L) Blueprint",
          "Firewall Gloves Mk-III (L) Blueprint",
          "Firewall Helmet Mk-III (L) Blueprint",
          "Firewall Shin Guards Mk-III (L) Blueprint",
          "Firewall Thigh Guards Mk-III (L) Blueprint",
          "Firewall Harness Mk-III (L) Blueprint",
          "Firewall Arm Guards Mk-III (L) Blueprint",
          "Awesome Foot Guards (L) Blueprint",
          "Awesome Gloves (L) Blueprint",
          "Awesome Helmet (L) Blueprint",
          "Awesome Shin Guards (L) Blueprint",
          "Awesome Thigh Guards (L) Blueprint",
          "Awesome Harness (L) Blueprint",
          "Awesome Arm Guards (L) Blueprint",
          "Disco Foot Guards (L) Blueprint",
          "Disco Gloves (L) Blueprint",
          "Disco Helmet (L)Blueprint",
          "Disco Shin Guards (L) Blueprint",
          "Disco Thigh Guards (L) Blueprint",
          "Disco Harness (L) Blueprint",
          "Disco Arm Guards (L) Blueprint",
          "Jarhead Foot Guards Blueprint (L)",
          "Jarhead Gloves Blueprint (L)",
          "Jarhead Helmet Blueprint (L)",
          "Jarhead Shin Guards Blueprint (L)",
          "Jarhead Thigh Guards Blueprint (L)",
          "Jarhead Harness Blueprint (L)",
          "Jarhead Arm Guards Blueprint (L)",
          "Grunt Foot Guards Blueprint (L)",
          "Grunt Gloves Blueprint (L)",
          "Grunt Helmet Blueprint (L)",
          "Grunt Shin Guards Blueprint (L)",
          "Grunt Thigh Guards Blueprint (L)",
          "Grunt Harness Blueprint (L)",
          "Grunt Arm Guards Blueprint (L)",
          "Stealth Foot Guards (L) Blueprint",
          "Stealth Gloves (L) Blueprint",
          "Stealth Helmet (L) Blueprint",
          "Stealth Shin Guards (L) Blueprint",
          "Stealth Thigh Guards (L) Blueprint",
          "Stealth Harness (L) Blueprint",
          "Stealth Arm Guards (L) Blueprint",
          "Road-Monkey Laser Amp Mk I (L) Blueprint",
          "Road-Monkey Laser Amp Mk II (L) Blueprint",
          "Road-Monkey Laser Amp Mk III (L) Blueprint",
          "Road-Monkey Laser Amp Mk IV (L) Blueprint",
          "Road-Monkey Laser Amp Mk V (L) Blueprint",
          "Road-Monkey Laser Amp Mk VI (L) Blueprint",
          "Road-Monkey Laser Amp Mk VII (L) Blueprint",
          "Road-Monkey Laser Amp Mk VIII (L) Blueprint",
          "Road-Monkey Laser Amp Mk IX (L) Blueprint",
          "Road-Monkey Laser Amp Mk X (L) Blueprint",
          "Shack-A-Lacka Laser Amp Mk I (L) Blueprint",
          "Shack-A-Lacka Laser Amp Mk II (L) Blueprint",
          "Shack-A-Lacka Laser Amp Mk III (L) Blueprint",
          "Shack-A-Lacka Laser Amp Mk IV (L) Blueprint",
          "Shack-A-Lacka Laser Amp Mk V (L) Blueprint",
          "Shack-A-Lacka Laser Amp Mk VI (L) Blueprint",
          "Shack-A-Lacka Laser Amp Mk VII (L) Blueprint",
          "Shack-A-Lacka Laser Amp Mk VIII (L) Blueprint",
          "Shack-A-Lacka Superstar Laser Amp Mk I (L) Blueprint",
          "Teenie Weenie Laser Amp Mk I (L) Blueprint",
          "Teenie Weenie Laser Amp Mk II (L) Blueprint",
          "Teenie Weenie Laser Amp Mk III (L) Blueprint",
          "Teenie Weenie Laser Amp Mk IV (L) Blueprint",
          "Teenie Weenie Laser Amp Mk V (L) Blueprint",
          "Teenie Weenie Laser Amp Mk VI (L) Blueprint",
          "Teenie Weenie Laser Amp Mk VII (L) Blueprint",
          "Teenie Weenie Laser Amp Mk II Light (L) Blueprint",
          "Teenie Weenie Laser Amp Mk III Light (L) Blueprint",
          "Lucky Laser Sight Mk I Blueprint",
          "Lucky Laser Sight Mk II Blueprint",
          "Lucky Laser Sight Mk III Blueprint",
          "Lucky Laser Sight Mk IV Blueprint",
          "Lucky Laser Sight Mk V Blueprint",
          "Lucky Laser Sight Mk VI Blueprint",
          "Lucky Laser Sight Mk VII Blueprint",
          "Lucky Laser Sight Mk VIII Blueprint",
          "Lucky Laser Sight Mk IX Blueprint",
          "Lucky Laser Sight Mk X Blueprint",
          "Sweet Scope Mk I Blueprint",
          "Sweet Scope Mk II Blueprint",
          "Sweet Scope Mk III Blueprint",
          "Sweet Scope Mk IV Blueprint",
          "Sweet Scope Mk V Blueprint",
          "Sweet Scope Mk VI Blueprint",
          "Sweet Scope Mk VII Blueprint",
          "Sweet Scope Mk VIII Blueprint",
          "Sweet Scope Mk IX Blueprint",
          "Sweet Scope Mk X Blueprint",
          "Roadie BLP Amp Mk I (L) Blueprint",
          "Roadie BLP Amp Mk II (L) Blueprint",
          "Roadie BLP Amp Mk III (L) Blueprint",
          "Roadie BLP Amp Mk IV (L) Blueprint",
          "Roadie BLP Amp Mk V (L) Blueprint",
          "Roadie BLP Amp Mk VI (L) Blueprint",
          "Roadie BLP Amp Mk VII (L) Blueprint",
          "Roadie BLP Amp Mk VIII (L) Blueprint",
          "Roadie BLP Amp Mk IX (L) Blueprint",
          "Roadie BLP Amp Mk X (L) Blueprint",
          "Bust-A-BLP Amp Mk I (L) Blueprint",
          "Bust-A-BLP Amp Mk II (L) Blueprint",
          "Bust-A-BLP Amp Mk III (L) Blueprint",
          "Bust-A-BLP Amp Mk IV (L) Blueprint",
          "Bust-A-BLP Amp Mk V (L) Blueprint",
          "Bust-A-BLP Amp Mk VI (L) Blueprint",
          "Bust-A-BLP Amp Lite Mk I (L) Blueprint",
          "Bust-A-BLP Amp Lite Mk II (L) Blueprint",
          "Bust-A-BLP Amp Mk VII (L) Blueprint",
          "Low Rider BLP Amp Mk I (L) Blueprint",
          "Low Rider BLP Amp Mk II (L) Blueprint",
          "Low Rider BLP Amp Puny (L) Blueprint",
          "Low Rider BLP Amp Boostie (L) Blueprint",
          "Camp Crunk Cloth Crate Key Blueprint",
          "B.A.M.F Cute Chainsaw (L) Blueprint",
          "B.A.M.F Rustic Chainsaw (L) Blueprint",
          "B.A.M.F Marine Chainsaw (L) Blueprint",
          "B.A.M.F Bloody Chainsaw (L) Blueprint",
          "B.A.M.F Golden Chainsaw (L) Blueprint",
          "Star Blueprint (L)",
          "TPT Fragment Blueprint (L)",
          "NEVERDIE Token Blueprint (L)",
          "Custo Parka Blueprint (L)",
          "Custo Snow Pants Blueprint (L)",
          "La Fleur Sexy Top Blueprint (L)",
          "Nuclear Blast Sexy Top Blueprint (L)",
          "Motorhead Sexy Top Blueprint (L)",
          "Sweety Pie ROCK T-Shirt Blueprint (L)",
          "Space Sexy Top Blueprint (L)",
          "Heavy Metal Sexy Top Blueprint (L)",
          "Hot Sexy Top Blueprint (L)",
          "Anarchy Sexy Top Blueprint (L)",
          "Distorted Peace Sexy Top Blueprint (L)",
          "Up Here Sexy Top Blueprint (L)",
          "Butterfly Sexy Top Blueprint (L)",
          "Skully Sexy Top Blueprint (L)",
          "Star Sexy Top Blueprint (L)",
          "Superstar Sexy Top Blueprint (L)",
          "Angelic Sexy Top Blueprint (L)",
          "Sweety Sexy Top Blueprint (L)",
          "Locked & Loaded Sexy Top Blueprint (L)",
          "Camo Sexy Top Blueprint (L)",
          "Vampire Sexy Top Blueprint (L)",
          "Simple Shovel Blueprint (L)",
          "Troll Ganja Seeds Blueprint (L)",
          "Vixen Ganja Seeds Blueprint (L)",
          "Nuclear Ganja Seeds Blueprint (L)",
          "Lemmy Ganja Seeds Blueprint (L)",
          "Pop Ganja Seeds Blueprint (L)",
          "Zombie Ganja Seeds Blueprint (L)",
          "Crypto Ganja Seeds Blueprint (L)",
          "Lost Soul Seeker(L) Blueprint (L)",
          "Lost Soul Savior (L) Blueprint (L)",
          "Lockpick Kit I Remix Blueprint",
          "Lockpick Kit II Remix Blueprint",
          "Failure Potion Remix Blueprint",
          "Flare Potion Remix Blueprint",
          "Faith Potion Remix Blueprint",
          "Focus Potion Remix Blueprint",
          "Talent Potion Remix Blueprint",
          "Teleman Coin Bootleg Blueprint (L)",
          "Insight Potion Remix Blueprint",
          "Vampire Charm Bracelets Remix Blueprint",
          "Lycan Charm Bracelets Remix Blueprint",
          "Zombie Charm Bracelets Remix Blueprint",
          "Wolf Charm Bracelets Remix Blueprint",
          "Snaggle Charm Bracelets Remix Blueprint",
          "Modo Blue Table Lamp Blueprint (L)",
          "Modo Orange Table Lamp Blueprint (L)",
          "Modo Purple Table Lamp Blueprint (L)",
          "Modo Green Table Lamp Blueprint (L)",
          "Modo Red Table Lamp Blueprint (L)",
          "Modo White Table Lamp Blueprint (L)",
          "Modo White Ground Lamp Blueprint (L)",
          "Modo Blue Ground Blueprint (L)",
          "Modo Orange Ground Blueprint (L)",
          "Modo Green Ground Blueprint (L)",
          "Modo Purple Ground Blueprint (L)",
          "Modo Red Ground Blueprint (L)",
          "Outback Campfire Blueprint (L)",
          "Motorhead Ball Cap Blueprint",
          "Motorhead Trucker Hat Blueprint",
          "Gamer Chick Trucker Cap Blueprint",
          "ROCKtropia Trucker Cap Blueprint",
          "CND Trucker Cap Blueprint",
          "Super Vixen Trucker Cap Blueprint",
          "Vixen Trucker Cap Blueprint",
          "Sexy Trucker Cap Blueprint",
          "Flower Power Trucker Cap Blueprint",
          "LOL Trucker Cap Blueprint",
          "Wink Trucker Cap Blueprint",
          "WTF Trucker Cap Blueprint",
          "In The City Trucker Cap Blueprint",
          "Nuclear Blast Trucker Cap Blueprint",
          "HOF Trucker Cap Blueprint",
          "NOOB Trucker Cap Blueprint",
          "UBER Trucker Cap Blueprint",
          "Birdie Trucker Cap Blueprint",
          "High Five Trucker Cap Blueprint",
          "Pawz Trucker Cap Blueprint",
          "Ninety Six Trucker Cap Blueprint",
          "Stylus 1 Trucker Cap Blueprint",
          "Stylus 2 Trucker Cap Blueprint",
          "Stylus 3 Trucker Cap Blueprint",
          "Stylus 4 Trucker Cap Blueprint",
          "Stylus 5 Trucker Cap Blueprint",
          "Butterfly Trucker Cap Blueprint",
          "Anarchy Trucker Cap Blueprint",
          "Peace Trucker Cap Blueprint",
          "Smiley Trucker Cap Blueprint",
          "Space Dude Trucker Cap Blueprint",
          "Heart This Trucker Cap Blueprint",
          "Superstar Trucker Cap Blueprint",
          "Poison Trucker Cap Blueprint",
          "Medic Trucker Cap Blueprint",
          "Shark Hunter Trucker Cap Blueprint",
          "Zombies Trucker Cap Blueprint",
          "Trucker Cap Blueprint",
          "I Am My Avatar Trucker Cap Blueprint",
          "B.A.M.F Trucker Cap Blueprint",
          "Machine Gun Trucker Cap Blueprint",
          "Grenade Trucker Cap Blueprint",
          "Proud 2 PK Trucker Cap Blueprint",
          "Global Trucker Cap Blueprint",
          "Camo Trucker Cap Blueprint",
          "AFK Trucker Cap Blueprint",
          "Buying Trucker Cap Blueprint",
          "Selling Trucker Cap Blueprint",
          "Winning Trucker Cap Blueprint (L)",
          "ROCKtropia Pilots Federation Trucker Cap Blueprint (L)",
          "BUSEY Trucker Cap Blueprint (L)",
          "Camo Shorts Blueprint",
          "La Fleur Sexy Top Blueprint",
          "Motorhead Sexy Top Blueprint",
          "Space Sexy Top Blueprint",
          "Heavy Metal Sexy Top Blueprint",
          "Hot Sexy Top Blueprint",
          "Anarchy Sexy Top Blueprint",
          "Distorted Peace Sexy Top Blueprint",
          "Up Here Sexy Top Blueprint",
          "Butterfly Sexy Top Blueprint",
          "Skully Sexy Top Blueprint",
          "Star Sexy Top Blueprint",
          "Superstar Sexy Top Blueprint",
          "Angelic Sexy Top Blueprint",
          "Sweety Sexy Top Blueprint",
          "Locked & Loaded Sexy Top Blueprint",
          "Camo Sexy Top Blueprint",
          "Vampire Sexy Top Blueprint",
          "Angelic ROCK T-Shirt Blueprint",
          "Superstar ROCK T-Shirt Blueprint",
          "Skully ROCK T-Shirt Blueprint",
          "Smiley ROCK T-Shirt Blueprint",
          "Anarchy ROCK T-Shirt Blueprint",
          "Distorted Peace ROCK T-Shirt Blueprint",
          "Space Dude ROCK T-Shirt Blueprint",
          "Fire Truck ROCK T-Shirt Blueprint",
          "Heavy Metal ROCK T-Shirt Blueprint",
          "Sacred Guitar ROCK T-Shirt Blueprint",
          "Microphone Master ROCK T-Shirt Blueprint",
          "Motorhead ROCK T-Shirt Blueprint",
          "Nuclear Blast ROCK T-Shirt Blueprint",
          "Skully II ROCK T-Shirt Blueprint",
          "Nuclear Blast Sexy Top Blueprint",
          "Sweety Pie ROCK T-Shirt Blueprint",
          "Hyperplex Combat Truck Blueprint (L)",
          "Hyperplex Combat Helicopter Blueprint (L)",
          "Scout Helmet Blueprint",
          "Scout Harness Blueprint",
          "Scout Arm Guards Blueprint",
          "Scout Gloves Blueprint",
          "Scout Boots Blueprint",
          "Scout Shin Guards Blueprint",
          "Scout Thigh Guards Blueprint",
          "Light Power Cell Blueprint",
          "Medium Power Cell Blueprint",
          "Heavy Power Cell Blueprint",
          "Lysterium Power Container Blueprint",
          "Bonding Liquid Blueprint",
          "Protective Coating Blueprint",
          "Suspended Life Essence Blueprint",
          "Material Softener Blueprint",
          "Anti-Glare Spray Blueprint",
          "Blemish Remover Blueprint",
          "Acid Protective Coating Blueprint",
          "Reflective Coating Blueprint",
          "Heat Protective Coating Blueprint",
          "Cold Protective Coating Blueprint",
          "Lancer v1 (L) Blueprint",
          "Spear MK. III (L) Blueprint",
          "Spear MK. IV (L) Blueprint (L)",
          "A.R.C. Ranger Shin Guards Blueprint (L)",
          "A.R.C. Ranger Thigh Guards Blueprint (L)",
          "A.R.C. Scorpion AP1 (L) Blueprint (L)",
          "A.R.C. Scorpion AP2 (L) Blueprint (L)",
          "A.R.C. XT1 (L) Blueprint (L)",
          "A.R.C. XT2 (L) Blueprint (L)",
          "A.R.C. HK Scout (L) Blueprint (L)",
          "A.R.C. Fire Starter (L) Blueprint (L)",
          "A.R.C. P.I.G.V. Mk. II (L) Blueprint (L)",
          "O.S. F.A.P. M1 (L) Blueprint (L)",
          "H.E.A.R.T. M1 (L) Blueprint (L)",
          "O.S. F.A.P. M7 (L) Blueprint (L)",
          "H.E.A.R.T. M7 (L) Blueprint (L)",
          "Ferguson's All Purpose Lube Blueprint (L)",
          "Robotics Enhancing Gel Blueprint (L)",
          "Ferguson's Amalgam Blueprint (L)",
          "Ferguson's Refined Amalgam Blueprint (L)",
          "A.R.C. Wire Harness Blueprint (L)",
          "A.R.C. Ranger Helmet Blueprint (L)",
          "A.R.C. Ranger Harness Blueprint (L)",
          "A.R.C. Ranger Arm Guards Blueprint (L)",
          "A.R.C. Ranger Hand Guards Blueprint (L)",
          "A.R.C. Ranger Foot Guards Blueprint (L)",
          "Enkidd Red-Back (L) Blueprint (L)",
          "Xent Tech Light Amplification Vine (L) Blueprint (L)",
          "Enkidd Dismalites (L) Blueprint (L)",
          "Hawk 1k (L) Blueprint (L)",
          "Spear MK. II (L) Blueprint (L)",
          "Dragonfly v1 (L) Blueprint (L)",
          "Enkidd Howler S.4 Blueprint (L)",
          "I.D.A. 004 (L) Blueprint (L)",
          "Ripper Hide Armor Plate (L) Blueprint (L)",
          "Reforged Zyn Smasher Blueprint (L)",
          "Imperium Detectonator X2 (L) Blueprint (L)",
          "Bonding Liquid Blueprint (L)",
          "B.E. A.R.C. Pilot Gloves Blueprint (L)",
          "B.E. A.R.C. Pilot Boots Blueprint (L)",
          "B.E. A.R.C. Pilot Arm Guards Blueprint (L)",
          "B.E. A.R.C. Pilot Shin Guards Blueprint (L)",
          "B.E. A.R.C. Pilot Leg Guards Blueprint (L)",
          "B.E. A.R.C. Pilot Helmet Blueprint (L)",
          "B.E. A.R.C. Pilot Harness Blueprint (L)",
          "B.E. Zekkonian Claw (L) Blueprint (L)",
          "B.E. Zekkonian Longblade (L) Blueprint (L)",
          "B.E. Zekkonian Short Sword (L) Blueprint (L)",
          "B.E. Zekkonian Shortblade (L) Blueprint (L)",
          "B.E. Redstar Smasher (L) Blueprint (L)",
          "B.E. Pilot Pistol (L) Blueprint (L)",
          "B.E. Imperium Carbine (L) Blueprint (L)",
          "Imperium Resource Refiner B1 Blueprint (L)",
          "Enkidd Dire S1 (L) Blueprint",
          "Enkidd Dire S2 (L) Blueprint (L)",
          "Enkidd Dire S3 (L) Blueprint (L)",
          "Enkidd Dire S4 (L) Blueprint (L)",
          "Enkidd Dire S6 (L) Blueprint (L)",
          "Enkidd Dire S7 (L) Blueprint (L)",
          "Enkidd Dire S9 (L) Blueprint (L)",
          "Enkidd Dire S10 (L) Blueprint (L)",
          "Enkidd Dire S11 (L) Blueprint (L)",
          "Enkidd Dire S12 (L) Blueprint (L)",
          "Enkidd Fang S1 (L) Blueprint",
          "Enkidd Fang S3 (L) Blueprint (L)",
          "Enkidd Fang S4 (L) Blueprint (L)",
          "Enkidd Fang S5 (L) Blueprint (L)",
          "Enkidd Fang S7 (L) Blueprint (L)",
          "Enkidd Fang S8 (L) Blueprint (L)",
          "Enkidd Fang S9 (L) Blueprint (L)",
          "Enkidd Fang S10 (L) Blueprint (L)",
          "Enkidd Fang S11 (L) Blueprint (L)",
          "Enkidd Fang S12 (L) Blueprint (L)",
          "Pilot Scorpion Rank 4 (L) Blueprint",
          "Pilot Scorpion Rank 5 (L) Blueprint (L)",
          "Pilot Scorpion Rank 7 (L) Blueprint (L)",
          "Pilot Scorpion Rank 8 (L) Blueprint (L)",
          "Pilot Scorpion Rank 11 (L) Blueprint (L)",
          "Pilot Scorpion Rank 13 (L) Blueprint (L)",
          "Pilot Scorpion Rank 16 (L) Blueprint (L)",
          "Pilot Scorpion Rank 19 (L) Blueprint (L)",
          "Pilot Scorpion Rank 24 (L) Blueprint (L)",
          "Pilot Scorpion Rank 27 (L) Blueprint (L)",
          "Imperium Issue 400 (L) Blueprint",
          "Imperium Issue 500 (L) Blueprint (L)",
          "Imperium Issue 720 (L) Blueprint (L)",
          "Imperium Issue 1100 (L) Blueprint (L)",
          "Imperium Issue 1300 (L) Blueprint (L)",
          "Imperium Issue 1700 (L) Blueprint (L)",
          "Imperium Issue 2000 (L) Blueprint (L)",
          "Imperium Issue 2300 (L) Blueprint (L)",
          "Imperium Issue 2900 (L) Blueprint (L)",
          "Imperium Issue 3300 (L) Blueprint (L)",
          "Enkidd Howler S.1 (L) Blueprint (L)",
          "Enkidd Howler S.2 (L) Blueprint (L)",
          "Enkidd Howler S.3 (L) Blueprint (L)",
          "A.R.C. Special Ops Shin Guards (L) Blueprint (L)",
          "A.R.C. Special Ops Thigh Guards (L) Blueprint (L)",
          "A.R.C. Special Ops Helmet (L) Blueprint (L)",
          "A.R.C. Special Ops Harness (L) Blueprint (L)",
          "A.R.C. Special Ops Arm Guards (L) Blueprint (L)",
          "A.R.C. Special Ops Gloves (L) Blueprint (L)",
          "A.R.C. Special Ops Foot Guards (L) Blueprint (L)",
          "Turrelion Silverstich Shin Guards Blueprint (L)",
          "Turrelion Silverstich Thigh Guards Blueprint (L)",
          "Turrelion Silverstich Mask Blueprint (L)",
          "Turrelion Silverstich Harness Blueprint (L)",
          "Turrelion Silverstich Arm Guards Blueprint (L)",
          "Turrelion Silverstich Gloves Blueprint (L)",
          "Turrelion Silverstich Boots Blueprint (L)",
          "Turrelion Goldenweave Shin Guards (L) Blueprint (L)",
          "Turrelion Goldenweave Thigh Guards (L) Blueprint (L)",
          "Turrelion Goldenweave Mask (L) Blueprint (L)",
          "Turrelion Goldenweave Harness (L) Blueprint (L)",
          "Turrelion Goldenweave Arm Guards (L) Blueprint (L)",
          "Turrelion Goldenweave Gloves (L) Blueprint (L)",
          "Turrelion Goldenweave Boots (L) Blueprint (L)",
          "Mang Chang Hide Penetration Blocker (L) Blueprint (L)",
          "Rhino Hide Impact Protection Plate (L) Blueprint (L)",
          "Patterned Shirt Series 1(L,C) Blueprint",
          "Patterned Shirt Series 2(L,C) Blueprint (L)",
          "Patterned Shirt Series 3(L,C) Blueprint (L)",
          "Patterned Shirt Series 4(L,C) Blueprint (L)",
          "Patterned Shirt Series 5(L,C) Blueprint (L)",
          "Patterned Shirt Series 6(L,C) Blueprint (L)",
          "Patterned Shirt Series 7(L,C) Blueprint (L)",
          "Patterned Shirt Series 8(L,C) Blueprint (L)",
          "Patterned Shirt Series 9(L,C) Blueprint (L)",
          "Patterned Shirt Series 10(L,C) Blueprint (L)",
          "Patterned Pants Series 1(L,C) Blueprint (L)",
          "Patterned Pants Series 2(L,C) Blueprint (L)",
          "Patterned Shoes Design 1(L,C) Blueprint (L)",
          "Patterned Shoes Series 2(L,C) Blueprint (L)",
          "Imperium Spec Lancer (L) Blueprint (L)",
          "Imperium Cube Component 1 Blueprint",
          "Imperium Cube Component 2 Blueprint",
          "Imperium Cube Component 3 Blueprint",
          "Imperium Cube Component 4 Blueprint",
          "Imperium Cube Component 5 Blueprint",
          "Imperium Key Cube Blueprint",
          "Imperium Bearings Blueprint (L)",
          "Imperium Servo Blueprint (L)",
          "Imperium Compression Unit Blueprint (L)",
          "Imperium Control Sensor Blueprint (L)",
          "Enkidd Series A-32 (L) Blueprint (L)",
          "Enkidd Series A-41 (L) Blueprint (L)",
          "Enkidd Series A-45 (L) Blueprint (L)",
          "Enkidd Series A-50 (L) Blueprint (L)",
          "Enkidd Series A-55 (L) Blueprint (L)",
          "Level II Finder Amplifer 'Athena' (L) Blueprint (L)",
          "Level II Finder Amplifer 'Athena' (L) Blueprint",
          "HK Series S-43 (L) Blueprint (L)",
          "HK Series S-50 (L) Blueprint (L)",
          "HK Series S-54 (L) Blueprint (L)",
          "HK Series S-57 (L) Blueprint (L)",
          "HK Series S-62 (L) Blueprint (L)",
          "Crystal Pede Leather Texture Blueprint",
          "Jellyworm Leather Texture Blueprint",
          "Tree Dragon Leather Texture Blueprint",
          "Sea Wraith Leather Texture Blueprint",
          "Paneleon Leather Texture Blueprint",
          "Living Vortex Leather Texture Blueprint",
          "Empis Leather Texture Blueprint",
          "Flesh Ripper Leather Texture Blueprint",
          "Mang Chang Leather Texture Blueprint",
          "Rhino Beetle Leather Texture Blueprint",
          "Zeladoth Leather Texture Blueprint",
          "Ozpyn Cold Armor Plate (L) Blueprint",
          "Ozpyn Chang Arm Guards Blueprint (L)",
          "Ozpyn Chang Foot Guards Blueprint (L)",
          "Ozpyn Chang Hand Guards Blueprint (L)",
          "Ozpyn Chang Chest Guard Blueprint (L)",
          "Ozpyn Chang Head Guard Blueprint (L)",
          "Ozpyn Chang Shin Guards Blueprint (L)",
          "Ozpyn Chang Thigh Guards Blueprint (L)",
          "Ozpyn Filters Blueprint",
          "Ozpyn Matrix Blueprint",
          "Ozpyn Lever Blueprint",
          "Ozpyn BP S1X1 Blueprint",
          "Ozpyn LR S1X1 Blueprint",
          "Ozpyn LR S1X2 Blueprint",
          "Ozpyn Chon Blueprint",
          "Ozpyn Ying S1X1 (L) Blueprint",
          "Ozpyn Launcher S1X1 (L) Blueprint",
          "Paradigm Pants Series 1 Blueprint",
          "Paradigm Pants Series 2 Blueprint",
          "Paradigm Shoes Series 1 Blueprint",
          "Paradigm Shoes Series 2 Blueprint",
          "Paradigm Shirt Series 1 Blueprint",
          "Paradigm Shirt Series 2 Blueprint",
          "Paradigm Shirt Series 3 Blueprint",
          "Paradigm Shirt Series 4 Blueprint",
          "Paradigm Shirt Series 5 Blueprint",
          "Paradigm Shirt Series 6 Blueprint",
          "Paradigm Shirt Series 7 Blueprint",
          "Paradigm Shirt Series 8 Blueprint",
          "Paradigm Shirt Series 9 Blueprint",
          "Imperium Noble Shirt Blueprint",
          "Imperium Common Shirt Blueprint",
          "Imperium Noble Pants Blueprint",
          "Imperium Common Pants Blueprint",
          "Imperium Noble Shoes Blueprint",
          "Imperium Common Shoes Blueprint",
          "Swamp Lurker Leather Texture Blueprint",
          "Imperium Common Shirt Blueprint (L)",
          "Ozpyn Chon Blueprint (L)",
          "Ozpyn Cold Armor Plate (L) Blueprint (L)",
          "Yellow Crystal Texture Blueprint",
          "Blue Crystal Texture Blueprint",
          "Green Crystal Texture Blueprint",
          "Orange Crystal Texture Blueprint",
          "Purple Crystal Texture Blueprint",
          "Clear Crystal Texture Blueprint",
          "Rainbow Crystal Texture Blueprint",
          "Blue Icy Crystal Texture Blueprint",
          "Red Molten Crystal Texture Blueprint",
          "Hazy Crystal Texture Blueprint",
          "Compressed Plastic Spacers Blueprint",
          "Compouned Plastic Seal Blueprint",
          "Plastic Convector Panel Blueprint",
          "Rubberized Grommit Blueprint",
          "Plastic Injection Mold Blueprint",
          "Ozpyn Factoral F.A.P. CE (L) Blueprint (L)",
          "Ozpyn Regenorator F.A.P. CE (L) Blueprint (L)",
          "Cyrene Collectible A.R.C. Soldier Blueprint",
          "Cyrene Collectible Drill Bot Blueprint",
          "Cyrene Collectible Duster Bandit Blueprint",
          "Cyrene Collectible Empis Wasp Blueprint",
          "Cyrene Collectible Fenris Wolf Blueprint",
          "Cyrene Collectible Imperium Grunt Blueprint",
          "Cyrene Collectible Imperium Officer Blueprint",
          "Cyrene Collectible Imperium Pilot Blueprint",
          "Cyrene Collectible Jellyworm Blueprint",
          "Cyrene Collectible Mang Chang Blueprint",
          "Cyrene Collectible Merfolken Scout Blueprint",
          "Cyrene Collectible Merfolken Gladiator Blueprint",
          "Cyrene Collectible Molten Golem Blueprint",
          "Cyrene Collectible Paneleon Blueprint",
          "Cyrene Collectible Protocore Blueprint",
          "Cyrene Collectible Rhino Beetle Blueprint",
          "Cyrene Collectible Scout Bot Blueprint",
          "Cyrene Collectible Sky Shatter Blueprint",
          "Cyrene Collectible Stalker Gen 1 Blueprint",
          "Cyrene Collectible Swamp Lurker Blueprint",
          "Cyrene Collectible Tide Claw Blueprint",
          "Cyrene Collectible Tree Dragon Ridge Blueprint",
          "Cyrene Collectible Turrelion Trader Blueprint",
          "Cyrene Collectible Zyn'Dos Blueprint",
          "Zekkonian Replica Wings Blueprint",
          "Zekkonian Replica Antenna Blueprint",
          "A.R.C. Lancer (L) Blueprint (L)",
          "Zorn Star Texture Blueprint",
          "Kaisenite Texture Blueprint",
          "Iridium Texture Blueprint",
          "Olerin Texture Blueprint",
          "Nosi Texture Blueprint",
          "Sothorite Texture Blueprint",
          "Leethiz Texture Blueprint",
          "Ycyan Texture Blueprint",
          "Cyrenium Texture Blueprint",
          "Wiley Texture Blueprint",
          "Cube Infused Hormone Blueprint",
          "Cube Empowered Lube Blueprint",
          "Cube Enhanced Metal Blueprint",
          "Cube Fortified Motherboard Blueprint",
          "Cube Infused Calcium Blueprint",
          "C.L.R. 107 Blueprint (L)",
          "C.B.R. 107 Blueprint (L)",
          "Embossed Cyrene Shirt Blueprint",
          "Cyrene Basic Finder Columbidae Blueprint (L)",
          "Cyrene Basic Mining Amp Ascella Blueprint (L)",
          "C.A.P. 111 Blueprint (L)",
          "C.L.R. 111 Blueprint (L)",
          "C.B.P. 111 Blueprint (L)",
          "C.B.R. 111 Blueprint (L)",
          "C.A.P. 117 Blueprint (L)",
          "C.L.R. 117 Blueprint (L)",
          "C.B.P. 117 Blueprint (L)",
          "C.B.R. 117 Blueprint (L)",
          "C.A.P. 131 Blueprint (L)",
          "C.L.R. 131 Blueprint (L)",
          "C.B.P. 131 Blueprint (L)",
          "C.B.R. 131 Blueprint (L)",
          "Cyrene Acid Armor Plate (L) Blueprint",
          "Trojan Breastplate Blueprint",
          "Tropical Shades Blueprint (L)",
          "Hoplite Greaves (C) Blueprint (L)",
          "Hoplite Armbands (C) Blueprint (L)",
          "Hoplite Helmet (C) Blueprint (L)",
          "Hoplite Thigh Armor (C) Blueprint (L)",
          "Hoplite Breastplate (C) Blueprint (L)",
          "Philosopher's Sword Blueprint",
          "Hero's Sword Blueprint",
          "Archon's Sword Blueprint",
          "Hoplite Gloves (C) Blueprint (L)",
          "Hoplite Sandals (C) Blueprint (L)",
          "HyperSense Spectacles Blueprint (L)",
          "Island Wood Plank 1x4 Blueprint (L)",
          "Island Wood Plank 2x4 Blueprint (L)",
          "Island Wood Plank 2x8 Blueprint (L)",
          "Island Wood Plank 2x12 Blueprint (L)",
          "Island Wood Plank 3x12 Blueprint (L)",
          "Island Wood Plank 4x16 Blueprint (L)",
          "Island Hut Frame Blueprint (L)",
          "Island Hut Door Blueprint (L)",
          "Gorilla Rope Blueprint (L)",
          "Island Hut Roof Blueprint (L)",
          "Kraka (L) Blueprint (L)",
          "Strider MK.II (L) Blueprint (L)",
          "Next Island Rattan Chair Blue Blueprint (L)",
          "Next Island Rattan Chair Red Blueprint (L)",
          "Next Island Rattan Otterman Red Blueprint (L)",
          "Next Island Rattan Coffee Table Blueprint (L)",
          "Next Island Rattan sofa 2 Seater blue Blueprint (L)",
          "Next Island Rattan Sofa 2 Seater Red Blueprint (L)",
          "Next Island Rattan Sofa 3 Seater Red Blueprint (L)",
          "Next Island Bamboo Oval Table Blueprint (L)",
          "Next Island Bamboo Round Table Blueprint (L)",
          "Next Island Table Lamp Blueprint (L)",
          "Haruspex Banner Blueprint (L)",
          "Loyalist Banner Blueprint (L)",
          "NEO Banner Blueprint (L)",
          "Resa Banner Blueprint (L)",
          "Stel Banner Blueprint (L)",
          "Haruspex Holographic Unit Blueprint (L)",
          "Loyalist Holographic Unit Blueprint (L)",
          "Neo Holographic Unit Blueprint (L)",
          "Small Resa Holographic Projector Blueprint (L)",
          "Stel Holographic Unit Blueprint (L)",
          "Large Haruspex Holographic Projector Blueprint (L)",
          "Large Loyalist Holographic Projector Blueprint (L)",
          "Large NEO Holographic Projector Blueprint (L)",
          "Large Resa Holographic Projector Blueprint (L)",
          "Large Stel Holographic Projector Blueprint (L)",
          "Armor Plate Acid (L) Blueprint (L)",
          "Armor Plate Arctic (L) Blueprint (L)",
          "Armor Plate Ignis (L) Blueprint (L)",
          "Armor Plate Tempest (L) Blueprint (L)",
          "Aegis Arm Guards (L) Blueprint (L)",
          "Aegis Harness (L) Blueprint (L)",
          "Aegis Gloves (L) Blueprint (L)",
          "Aegis Foot Guards (L) Blueprint (L)",
          "Aegis Helmet (L) Blueprint (L)",
          "Aegis Shin Guards (L) Blueprint (L)",
          "Aegis Thigh Guards (L) Blueprint (L)",
          "Arcticus Arm Guards (L) Blueprint (L)",
          "Arcticus Harness (L) Blueprint (L)",
          "Arcticus Foot Guards (L) Blueprint (L)",
          "Arcticus Gloves (L) Blueprint (L)",
          "Arcticus Helmet (L) Blueprint (L)",
          "Arcticus Thigh Guards (L) Blueprint (L)",
          "Arcticus Shin Guards (L) Blueprint (L)",
          "Apocalypse Arm Guards (L) Blueprint (L)",
          "Apocalypse Harness (L) Blueprint (L)",
          "Apocalypse Foot Guards (L) Blueprint (L)",
          "Apocalypse Gloves (L) Blueprint (L)",
          "Apocalypse Helmet (L) Blueprint (L)",
          "Apocalypse Thigh Guards (L) Blueprint (L)",
          "Apocalypse Shin Guards (L) Blueprint (L)",
          "Marble Brick Blueprint",
          "Mortar Blueprint",
          "Marble Block Blueprint",
          "Marble Cylinder Blueprint",
          "Stoa Blueprint (L)",
          "Erechtheion Blueprint (L)",
          "Areopagus Blueprint (L)",
          "Miletus Blueprint (L)",
          "Didyma Blueprint (L)",
          "Tholos Building Blueprint (L)",
          "Tholos Delphi Blueprint (L)",
          "Small Fountain Blueprint (L)",
          "Large Fountain Blueprint (L)",
          "Luxurious Fountain Blueprint",
          "Athena Statue Medium Blueprint",
          "Athena Statue Small Blueprint",
          "Decorative Column Small Blueprint",
          "Decorative Column Medium Blueprint",
          "Decorative Column Large Blueprint",
          "Decorative Column Huge Blueprint",
          "Rusty Knife (L) Blueprint (L)",
          "Tarnished Knife (L) Blueprint (L)",
          "Newlander Knife (L) Blueprint (L)",
          "Jungle Knife (L) Blueprint (L)",
          "Helen's Knife (L) Blueprint (L)",
          "Researchers' Knife (L) Blueprint (L)",
          "Sharp Knife (L) Blueprint (L)",
          "Ceremonial Knife (L) Blueprint (L)",
          "Shawmans Knife (L) Blueprint (L)",
          "Blueprint-Weapon-Melee-022-Sacred-Knife (L)",
          "Functional Slicer (L) Blueprint (L)",
          "Traditional Slicer (L) Blueprint (L)",
          "Island Slicer (L) Blueprint (L)",
          "Demra Slicer (L) Blueprint (L)",
          "Defensive Slicer (L) Blueprint (L)",
          "Sword of Wisdom (L) Blueprint (L)",
          "Sword of Prudence (L) Blueprint (L)",
          "Sword of Justice (L) Blueprint (L)",
          "Sword of Fortitude (L) Blueprint (L)",
          "Sword of Courage (L) Blueprint (L)",
          "Miranda Violet Blueprint (L)",
          "Kylon's Blue Blueprint (L)",
          "Optimus Prime Helmet Blueprint",
          "Athenian Tunic (C) Blueprint",
          "Athenian Head Scarf (F,C) Blueprint",
          "Elysian Power Sphere Blueprint",
          "Carefully Falsified Displacement Readings Blueprint",
          "NIP P1 (L) Blueprint (L)",
          "NIP P2 (L) Blueprint (L)",
          "NIP P3 (L) Blueprint (L)",
          "NIP P4 (L) Blueprint (L)",
          "NIP P5 (L) Blueprint (L)",
          "Philosopher's Sword Blueprint (L)",
          "Hero's Sword Blueprint (L)",
          "Archon's Sword Blueprint (L)",
          "Elysians’ Tropical Top (C) Blueprint",
          "Island Shirt (C) Blueprint",
          "Jungle Shorts (C) Blueprint",
          "Lesser Elysia Blueprint",
          "Campbell's Basic Framework Blueprint",
          "Helen Venture's Walking Stick Blueprint",
          "Dark Lysterium Cogs Blueprint",
          "System Stabilizer Blueprint",
          "Chrysoberyl Fasteners Blueprint",
          "Fine Lens Blueprint",
          "Tropical Hat (C) Blueprint",
          "Lab Coat (C) Blueprint",
          "Jungle Wellies (C) Blueprint",
          "Coconut Bikini (F) Blueprint",
          "Tiki Dress (F,C) Blueprint",
          "Theban Shirt (C) Blueprint",
          "Island Feast Blueprint (L)",
          "Island Research Blueprint (L)",
          "Haruspex Forest Corset (F) Blueprint (L)",
          "Haruspex Forest Corset (F,C) Blueprint (L)",
          "Haruspex Sprite Leggings (F) Blueprint (L)",
          "Haruspex Sprite Leggings (F,C) Blueprint (L)",
          "Haruspex Voodoo Boots (M) Blueprint (L)",
          "Haruspex Voodoo Boots (M,C) Blueprint (L)",
          "Haruspex Belfry Hat Blueprint (L)",
          "Haruspex Belfry Hat (C) Blueprint (L)",
          "Haruspex Voodoo Bracers (F) Blueprint (L)",
          "Haruspex Voodoo Bracers (F,C) Blueprint (L)",
          "Dark Lysterium Texture Blueprint",
          "Ammolite Texture Blueprint",
          "Praetonium Texture Blueprint",
          "Purpite texture Blueprint",
          "Daudaormur Texture Blueprint",
          "Mankini (M) Blueprint (L)",
          "Mankini (M,C) Blueprint",
          "Haruspex Voodoo Vest (M) Blueprint (L)",
          "Haruspex Voodoo Vest (M,C) Blueprint (L)",
          "Haruspex Sleek Pants (M) Blueprint (L)",
          "Haruspex Sleek Pants (M,C) Blueprint (L)",
          "Rinoa Bikini (F) Blueprint (L)",
          "Rinoa Bikini (F,C) Blueprint",
          "Liberator (L) Blueprint",
          "Herman ASI-0 (L) Blueprint",
          "Herman ARK-0 (L) Blueprint",
          "Herman ARK-11 (L) Blueprint",
          "Herman ARK-11 (L) Blueprint (L)",
          "Herman ARK-27 (L) Blueprint",
          "Herman ARK-27 (L) Blueprint (L)",
          "Herman ARK-46 (L) Blueprint",
          "Herman ARK-46 (L) Blueprint (L)",
          "Herman ARK-65 (L) Blueprint",
          "Herman ARK-65 (L) Blueprint (L)",
          "Herman ARK-5 Desert (L) Blueprint",
          "Herman ARK-5 Desert (L) Blueprint (L)",
          "Herman ARK-21 Desert (L) Blueprint",
          "Herman ARK-21 Desert (L) Blueprint (L)",
          "Herman ARK-34 Desert (L) Blueprint",
          "Herman ARK-34 Desert (L) Blueprint (L)",
          "Herman ARK-54 Desert (L) Blueprint",
          "Herman ARK-54 Desert (L) Blueprint (L)",
          "Herman ARK-70 Desert (L) Blueprint",
          "Herman ARK-70 Desert (L) Blueprint (L)",
          "Herman ARK-6 Jungle (L) Blueprint",
          "Herman ARK-6 Jungle (L) Blueprint (L)",
          "Herman ARK-23 Jungle (L) Blueprint",
          "Herman ARK-23 Jungle (L) Blueprint (L)",
          "Herman ARK-38 Jungle (L) Blueprint",
          "Herman ARK-38 Jungle (L) Blueprint (L)",
          "Herman ARK-60 Jungle (L) Blueprint",
          "Herman ARK-60 Jungle (L) Blueprint (L)",
          "Herman ARK-77 Jungle (L) Blueprint",
          "Herman ARK-77 Jungle (L) Blueprint (L)",
          "Herman ARK-6 Arctic (L) Blueprint",
          "Herman ARK-6 Arctic (L) Blueprint (L)",
          "Herman ARK-22 Arctic (L) Blueprint",
          "Herman ARK-22 Arctic (L) Blueprint (L)",
          "Herman ARK-36 Arctic (L) Blueprint",
          "Herman ARK-36 Arctic (L) Blueprint (L)",
          "Herman ARK-50 Arctic (L) Blueprint",
          "Herman ARK-50 Arctic (L) Blueprint (L)",
          "Herman ARK-75 Arctic (L) Blueprint",
          "Herman ARK-75 Arctic (L) Blueprint (L)",
          "Herman ASI-11 (L) Blueprint",
          "Herman ASI-11 (L) Blueprint (L)",
          "Herman ASI-24 (L) Blueprint",
          "Herman ASI-24 (L) Blueprint (L)",
          "Herman ASI-37 (L) Blueprint",
          "Herman ASI-37 (L) Blueprint (L)",
          "Herman ASI-63 (L) Blueprint",
          "Herman ASI-63 (L) Blueprint (L)",
          "Herman ASI-7 Desert (L) Blueprint",
          "Herman ASI-7 Desert (L) Blueprint (L)",
          "Herman ASI-21 Desert (L) Blueprint",
          "Herman ASI-21 Desert (L) Blueprint (L)",
          "Herman ASI-32 Desert (L) Blueprint",
          "Herman ASI-32 Desert (L) Blueprint (L)",
          "Herman ASI-42 Desert (L) Blueprint",
          "Herman ASI-42 Desert (L) Blueprint (L)",
          "Herman ASI-70 Desert (L) Blueprint",
          "Herman ASI-70 Desert (L) Blueprint (L)",
          "Herman ASI-7 Jungle (L) Blueprint",
          "Herman ASI-7 Jungle (L) Blueprint (L)",
          "Herman ASI-21 Jungle (L) Blueprint",
          "Herman ASI-21 Jungle (L) Blueprint (L)",
          "Herman ASI-33 Jungle (L) Blueprint",
          "Herman ASI-33 Jungle (L) Blueprint (L)",
          "Herman ASI-44 Jungle (L) Blueprint",
          "Herman ASI-44 Jungle (L) Blueprint (L)",
          "Herman ASI-72 Jungle (L) Blueprint",
          "Herman ASI-72 Jungle (L) Blueprint (L)",
          "Herman ASI-7 Arctic (L) Blueprint",
          "Herman ASI-7 Arctic (L) Blueprint (L)",
          "Herman ASI-21 Arctic (L) Blueprint",
          "Herman ASI-21 Arctic (L) Blueprint (L)",
          "Herman ASI-33 Arctic (L) Blueprint",
          "Herman ASI-33 Arctic (L) Blueprint (L)",
          "Herman ASI-44 Arctic (L) Blueprint",
          "Herman ASI-44 Arctic (L) Blueprint (L)",
          "Herman ASI-72 Arctic (L) Blueprint",
          "Herman ASI-72 Arctic (L) Blueprint (L)",
          "Herman LAW-0 (L) Blueprint",
          "Herman LAW-13 (L) Blueprint",
          "Herman LAW-13 (L) Blueprint (L)",
          "Herman LAW-27 (L) Blueprint",
          "Herman LAW-27 (L) Blueprint (L)",
          "Herman LAW-50 (L) Blueprint",
          "Herman LAW-50 (L) Blueprint (L)",
          "Herman LAW-66 (L) Blueprint",
          "Herman LAW-66 (L) Blueprint (L)",
          "Herman LAW-5 Desert (L) Blueprint",
          "Herman LAW-5 Desert (L) Blueprint (L)",
          "Herman LAW-21 Desert (L) Blueprint",
          "Herman LAW-21 Desert (L) Blueprint (L)",
          "Herman LAW-42 Desert (L) Blueprint",
          "Herman LAW-42 Desert (L) Blueprint (L)",
          "Herman LAW-56 Desert (L) Blueprint",
          "Herman LAW-56 Desert (L) Blueprint (L)",
          "Herman LAW-71 Desert (L) Blueprint",
          "Herman LAW-71 Desert (L) Blueprint (L)",
          "Herman LAW-6 Jungle (L) Blueprint",
          "Herman LAW-6 Jungle (L) Blueprint (L)",
          "Herman LAW-23 Jungle (L) Blueprint",
          "Herman LAW-23 Jungle (L) Blueprint (L)",
          "Herman LAW-46 Jungle (L) Blueprint",
          "Herman LAW-46 Jungle (L) Blueprint (L)",
          "Herman LAW-60 Jungle (L) Blueprint",
          "Herman LAW-60 Jungle (L) Blueprint (L)",
          "Herman LAW-77 Jungle (L) Blueprint",
          "Herman LAW-77 Jungle (L) Blueprint (L)",
          "Herman LAW-5 Arctic (L) Blueprint",
          "Herman LAW-5 Arctic (L) Blueprint (L)",
          "Herman LAW-22 Arctic (L) Blueprint",
          "Herman LAW-22 Arctic (L) Blueprint (L)",
          "Herman LAW-44 Arctic (L) Blueprint",
          "Herman LAW-44 Arctic (L) Blueprint (L)",
          "Herman LAW-58 Arctic (L) Blueprint",
          "Herman LAW-58 Arctic (L) Blueprint (L)",
          "Herman LAW-75 Arctic (L) Blueprint",
          "Herman LAW-75 Arctic (L) Blueprint (L)",
          "Herman CAP-0 (L) Blueprint",
          "Herman CAP-12 (L) Blueprint",
          "Herman CAP-12 (L) Blueprint (L)",
          "Herman CAP-25 (L) Blueprint",
          "Herman CAP-25 (L) Blueprint (L)",
          "Herman CAP-37 (L) Blueprint",
          "Herman CAP-37 (L) Blueprint (L)",
          "Herman CAP-56 (L) Blueprint",
          "Herman CAP-56 (L) Blueprint (L)",
          "Herman CAP-7 Desert (L) Blueprint",
          "Herman CAP-7 Desert (L) Blueprint (L)",
          "Herman CAP-20 Desert (L) Blueprint",
          "Herman CAP-20 Desert (L) Blueprint (L)",
          "Herman CAP-32 Desert (L) Blueprint",
          "Herman CAP-32 Desert (L) Blueprint (L)",
          "Herman CAP-43 Desert (L) Blueprint",
          "Herman CAP-43 Desert (L) Blueprint (L)",
          "Herman CAP-62 Desert (L) Blueprint",
          "Herman CAP-62 Desert (L) Blueprint (L)",
          "Herman CAP-7 Jungle (L) Blueprint",
          "Herman CAP-7 Jungle (L) Blueprint (L)",
          "Herman CAP-21 Jungle (L) Blueprint",
          "Herman CAP-21 Jungle (L) Blueprint (L)",
          "Herman CAP-34 Jungle (L) Blueprint",
          "Herman CAP-34 Jungle (L) Blueprint (L)",
          "Herman CAP-45 Jungle (L) Blueprint",
          "Herman CAP-45 Jungle (L) Blueprint (L)",
          "Herman CAP-64 Jungle (L) Blueprint",
          "Herman CAP-64 Jungle (L) Blueprint (L)",
          "Herman CAP-7 Arctic (L) Blueprint",
          "Herman CAP-7 Arctic (L) Blueprint (L)",
          "Herman CAP-22 Arctic (L) Blueprint",
          "Herman CAP-22 Arctic (L) Blueprint (L)",
          "Herman CAP-33 Arctic (L) Blueprint",
          "Herman CAP-33 Arctic (L) Blueprint (L)",
          "Herman CAP-44 Arctic (L) Blueprint",
          "Herman CAP-44 Arctic (L) Blueprint (L)",
          "Herman CAP-65 Arctic (L) Blueprint",
          "Herman CAP-65 Arctic (L) Blueprint (L)",
          "MAKO FAL-1 (L) Blueprint",
          "MAKO FAL-2 (L) Blueprint",
          "MAKO FAL-2 (L) Blueprint (L)",
          "MAKO FAL-3 (L) Blueprint",
          "MAKO FAL-3 (L) Blueprint (L)",
          "MAKO FAL-4 (L) Blueprint",
          "MAKO FAL-4 (L) Blueprint (L)",
          "MAKO FAL-5 (L) Blueprint",
          "MAKO FAL-5 (L) Blueprint (L)",
          "MANTA K-1 (L) Blueprint",
          "MANTA K-2 (L) Blueprint",
          "MANTA K-2 (L) Blueprint (L)",
          "MANTA K-3 (L) Blueprint",
          "MANTA K-3 (L) Blueprint (L)",
          "MANTA K-4 (L) Blueprint",
          "MANTA K-4 (L) Blueprint (L)",
          "MANTA K-5 (L) Blueprint",
          "MANTA K-5 (L) Blueprint (L)",
          "Musca Arm Guards (L) Blueprint",
          "Musca Foot Guards (L) Blueprint",
          "Musca Gloves (L) Blueprint",
          "Musca Harness (L) Blueprint",
          "Musca Helmet (L) Blueprint",
          "Musca Shin Guards (L) Blueprint",
          "Musca Thigh Guards (L) Blueprint",
          "Pulsar Armour Plate 1 (L) Blueprint",
          "Pulsar Armour Plate 1 (L) Blueprint (L)",
          "Corvus Arm Guards (L) Blueprint",
          "Corvus Arm Guards (L) Blueprint (L)",
          "Corvus Foot Guards (L) Blueprint",
          "Corvus Foot Guards (L) Blueprint (L)",
          "Corvus Gloves (L) Blueprint",
          "Corvus Gloves (L) Blueprint (L)",
          "Corvus Harness (L) Blueprint",
          "Corvus Harness (L) Blueprint (L)",
          "Corvus Helmet (L) Blueprint",
          "Corvus Helmet (L) Blueprint (L)",
          "Corvus Shin Guards (L) Blueprint",
          "Corvus Shin Guards (L) Blueprint (L)",
          "Corvus Thigh Guards (L) Blueprint",
          "Corvus Thigh Guards (L) Blueprint (L)",
          "Pulsar Armour Plate 2 (L) Blueprint",
          "Pulsar Armour Plate 2 (L) Blueprint (L)",
          "Canis Arm Guards (L) Blueprint",
          "Canis Arm Guards (L) Blueprint (L)",
          "Canis Foot Guards (L) Blueprint",
          "Canis Foot Guards (L) Blueprint (L)",
          "Canis Gloves (L) Blueprint",
          "Canis Gloves (L) Blueprint (L)",
          "Canis Harness (L) Blueprint",
          "Canis Harness (L) Blueprint (L)",
          "Canis Helmet (L) Blueprint",
          "Canis Helmet (L) Blueprint (L)",
          "Canis Shin Guards (L) Blueprint",
          "Canis Shin Guards (L) Blueprint (L)",
          "Canis Thigh Guards (L) Blueprint",
          "Canis Thigh Guards (L) Blueprint (L)",
          "Pulsar Armour Plate 3 (L) Blueprint",
          "Pulsar Armour Plate 3 (L) Blueprint (L)",
          "Lupus Arm Guards (L) Blueprint",
          "Lupus Arm Guards (L) Blueprint (L)",
          "Lupus Foot Guards (L) Blueprint",
          "Lupus Foot Guards (L) Blueprint (L)",
          "Lupus Gloves (L) Blueprint",
          "Lupus Gloves (L) Blueprint (L)",
          "Lupus Harness (L) Blueprint",
          "Lupus Harness (L) Blueprint (L)",
          "Lupus Helmet (L) Blueprint",
          "Lupus Helmet (L) Blueprint (L)",
          "Lupus Shin Guards (L) Blueprint",
          "Lupus Shin Guards (L) Blueprint (L)",
          "Lupus Thigh Guards (L) Blueprint",
          "Lupus Thigh Guards (L) Blueprint (L)",
          "Pulsar Armour Plate 4 (L) Blueprint",
          "Pulsar Armour Plate 4 (L) Blueprint (L)",
          "Hydra Arm Guards (L) Blueprint",
          "Hydra Arm Guards (L) Blueprint (L)",
          "Hydra Foot Guards (L) Blueprint",
          "Hydra Foot Guards (L) Blueprint (L)",
          "Hydra Gloves (L) Blueprint",
          "Hydra Gloves (L) Blueprint (L)",
          "Hydra Harness (L) Blueprint",
          "Hydra Harness (L) Blueprint (L)",
          "Hydra Helmet (L) Blueprint",
          "Hydra Helmet (L) Blueprint (L)",
          "Hydra Shin Guards (L) Blueprint",
          "Hydra Shin Guards (L) Blueprint (L)",
          "Hydra Thigh Guards (L) Blueprint",
          "Hydra Thigh Guards (L) Blueprint (L)",
          "Pulsar Armour Plate 5 (L) Blueprint",
          "Pulsar Armour Plate 5 (L) Blueprint (L)",
          "Ursa Arm Guards (L) Blueprint",
          "Ursa Arm Guards (L) Blueprint (L)",
          "Ursa Foot Guards (L) Blueprint",
          "Ursa Foot Guards (L) Blueprint (L)",
          "Ursa Gloves (L) Blueprint",
          "Ursa Gloves (L) Blueprint (L)",
          "Ursa Harness (L) Blueprint",
          "Ursa Harness (L) Blueprint (L)",
          "Ursa Helmet (L) Blueprint",
          "Ursa Helmet (L) Blueprint (L)",
          "Ursa Shin Guards (L) Blueprint",
          "Ursa Shin Guards (L) Blueprint (L)",
          "Ursa Thigh Guards (L) Blueprint",
          "Ursa Thigh Guards (L) Blueprint (L)",
          "Pulsar Armour Plate 6 (L) Blueprint",
          "Pulsar Armour Plate 6 (L) Blueprint (L)",
          "Cetus Arm Guards (L) Blueprint",
          "Cetus Arm Guards (L) Blueprint (L)",
          "Cetus Foot Guards (L) Blueprint",
          "Cetus Foot Guards (L) Blueprint (L)",
          "Cetus Gloves (L) Blueprint",
          "Cetus Gloves (L) Blueprint (L)",
          "Cetus Harness (L) Blueprint",
          "Cetus Harness (L) Blueprint (L)",
          "Cetus Helmet (L) Blueprint",
          "Cetus Helmet (L) Blueprint (L)",
          "Cetus Shin Guards (L) Blueprint",
          "Cetus Shin Guards (L) Blueprint (L)",
          "Cetus Thigh Guards (L) Blueprint",
          "Cetus Thigh Guards (L) Blueprint (L)",
          "Pulsar Armour Plate 7 (L) Blueprint",
          "Pulsar Armour Plate 7 (L) Blueprint (L)",
          "Aquila Arm Guards (L) Blueprint",
          "Aquila Arm Guards (L) Blueprint (L)",
          "Aquila Foot Guards (L) Blueprint",
          "Aquila Foot Guards (L) Blueprint (L)",
          "Aquila Gloves (L) Blueprint",
          "Aquila Gloves (L) Blueprint (L)",
          "Aquila Harness (L) Blueprint",
          "Aquila Harness (L) Blueprint (L)",
          "Aquila Helmet (L) Blueprint",
          "Aquila Helmet (L) Blueprint (L)",
          "Aquila Shin Guards (L) Blueprint",
          "Aquila Shin Guards (L) Blueprint (L)",
          "Aquila Thigh Guards (L) Blueprint",
          "Aquila Thigh Guards (L) Blueprint (L)",
          "Pulsar Armour Plate 8 (L) Blueprint",
          "Pulsar Armour Plate 8 (L) Blueprint (L)",
          "Pegasus Arm Guards (L) Blueprint",
          "Pegasus Arm Guards (L) Blueprint (L)",
          "Pegasus Foot Guards (L) Blueprint",
          "Pegasus Foot Guards (L) Blueprint (L)",
          "Pegasus Gloves (L) Blueprint",
          "Pegasus Gloves (L) Blueprint (L)",
          "Pegasus Harness (L) Blueprint",
          "Pegasus Harness (L) Blueprint (L)",
          "Pegasus Helmet (L) Blueprint",
          "Pegasus Helmet (L) Blueprint (L)",
          "Pegasus Shin Guards (L) Blueprint",
          "Pegasus Shin Guards (L) Blueprint (L)",
          "Pegasus Thigh Guards (L) Blueprint",
          "Pegasus Thigh Guards (L) Blueprint (L)",
          "Pulsar Armour Plate 9 (L) Blueprint",
          "Pulsar Armour Plate 9 (L) Blueprint (L)",
          "Perseus Arm Guards (L) Blueprint",
          "Perseus Arm Guards (L) Blueprint (L)",
          "Perseus Foot Guards (L) Blueprint",
          "Perseus Foot Guards (L) Blueprint (L)",
          "Perseus Gloves (L) Blueprint",
          "Perseus Gloves (L) Blueprint (L)",
          "Perseus Harness (L) Blueprint",
          "Perseus Harness (L) Blueprint (L)",
          "Perseus Helmet (L) Blueprint",
          "Perseus Helmet (L) Blueprint (L)",
          "Perseus Shin Guards (L) Blueprint",
          "Perseus Shin Guards (L) Blueprint (L)",
          "Perseus Thigh Guards (L) Blueprint",
          "Perseus Thigh Guards (L) Blueprint (L)",
          "Pulsar Armour Plate 10 (L) Blueprint",
          "Pulsar Armour Plate 10 (L) Blueprint (L)",
          "GYRO FAP-2 (L) Blueprint",
          "GYRO FAP-6 (L) Blueprint",
          "GYRO FAP-6 (L) Blueprint (L)",
          "GYRO FAP-10 (L) Blueprint",
          "GYRO FAP-10 (L) Blueprint (L)",
          "GYRO FAP-14 (L) Blueprint",
          "GYRO FAP-14 (L) Blueprint (L)",
          "GYRO FAP-18 (L) Blueprint",
          "GYRO FAP-18 (L) Blueprint (L)",
          "GYRO FAP-22 (L) Blueprint",
          "GYRO FAP-22 (L) Blueprint (L)",
          "GYRO FAP-26 (L) Blueprint",
          "GYRO FAP-26 (L) Blueprint (L)",
          "GYRO FAP-30 (L) Blueprint",
          "GYRO FAP-30 (L) Blueprint (L)",
          "GYRO FAP-35 (L) Blueprint",
          "GYRO FAP-35 (L) Blueprint (L)",
          "GYRO FAP-40 (L) Blueprint",
          "GYRO FAP-40 (L) Blueprint (L)",
          "GYRO FAP-45 (L) Blueprint",
          "GYRO FAP-45 (L) Blueprint (L)",
          "GYRO FAP-50 (L) Blueprint",
          "GYRO FAP-50 (L) Blueprint (L)",
          "GYRO FAP-55 (L) Blueprint",
          "GYRO FAP-55 (L) Blueprint (L)",
          "GYRO FAP-60 (L) Blueprint",
          "GYRO FAP-60 (L) Blueprint (L)",
          "GYRO FAP-65 (L) Blueprint",
          "GYRO FAP-65 (L) Blueprint (L)",
          "GYRO Combat FAP-2 (L) Blueprint",
          "GYRO Combat FAP-2 (L) Blueprint (L)",
          "GYRO Combat FAP-6 (L) Blueprint",
          "GYRO Combat FAP-6 (L) Blueprint (L)",
          "GYRO Combat FAP-10 (L) Blueprint",
          "GYRO Combat FAP-10 (L) Blueprint (L)",
          "GYRO Combat FAP-14 (L) Blueprint",
          "GYRO Combat FAP-14 (L) Blueprint (L)",
          "GYRO Combat FAP-18 (L) Blueprint",
          "GYRO Combat FAP-18 (L) Blueprint (L)",
          "GYRO Combat FAP-22 (L) Blueprint",
          "GYRO Combat FAP-22 (L) Blueprint (L)",
          "GYRO Combat FAP-26 (L) Blueprint",
          "GYRO Combat FAP-26 (L) Blueprint (L)",
          "GYRO Combat FAP-30 (L) Blueprint",
          "GYRO Combat FAP-30 (L) Blueprint (L)",
          "GYRO Combat FAP-35 (L) Blueprint",
          "GYRO Combat FAP-35 (L) Blueprint (L)",
          "GYRO Combat FAP-40 (L) Blueprint",
          "GYRO Combat FAP-40 (L) Blueprint (L)",
          "GYRO Combat FAP-45 (L) Blueprint",
          "GYRO Combat FAP-45 (L) Blueprint (L)",
          "GYRO Combat FAP-50 (L) Blueprint",
          "GYRO Combat FAP-50 (L) Blueprint (L)",
          "GYRO Combat FAP-55 (L) Blueprint",
          "GYRO Combat FAP-55 (L) Blueprint (L)",
          "GYRO Combat FAP-60 (L) Blueprint",
          "GYRO Combat FAP-60 (L) Blueprint (L)",
          "GYRO Combat FAP-65 (L) Blueprint",
          "GYRO Combat FAP-65 (L) Blueprint (L)",
          "Headshot 1 Blueprint",
          "Headshot 2 Blueprint",
          "Headshot 2 Blueprint (L)",
          "Headshot 3 Blueprint",
          "Headshot 3 Blueprint (L)",
          "Headshot 4 Blueprint",
          "Headshot 4 Blueprint (L)",
          "Longreach 1 Blueprint",
          "Longreach 1 Blueprint (L)",
          "Longreach 2 Blueprint",
          "Longreach 2 Blueprint (L)",
          "Longreach 3 Blueprint",
          "Longreach 3 Blueprint (L)",
          "Longreach 4 Blueprint",
          "Longreach 4 Blueprint (L)",
          "Bullseye 1 Blueprint",
          "Bullseye 2 Blueprint",
          "Bullseye 2 Blueprint (L)",
          "Bullseye 3 Blueprint",
          "Bullseye 3 Blueprint (L)",
          "Bullseye 4 Blueprint",
          "Bullseye 4 Blueprint (L)",
          "Bullseye 5 Blueprint",
          "Bullseye 5 Blueprint (L)",
          "Bullseye 6 Blueprint",
          "Bullseye 6 Blueprint (L)",
          "Bullseye 7 Blueprint",
          "Bullseye 7 Blueprint (L)",
          "Bullseye 8 Blueprint",
          "Bullseye 8 Blueprint (L)",
          "Rage 5 (L) Blueprint",
          "Rage 10 (L) Blueprint",
          "Rage 10 (L) Blueprint (L)",
          "Rage 15 (L) Blueprint",
          "Rage 15 (L) Blueprint (L)",
          "Rage 20 (L) Blueprint",
          "Rage 20 (L) Blueprint (L)",
          "Rage 25 (L) Blueprint",
          "Rage 25 (L) Blueprint (L)",
          "Rage 30 (L) Blueprint",
          "Rage 30 (L) Blueprint (L)",
          "Rage 35 (L) Blueprint",
          "Rage 35 (L) Blueprint (L)",
          "Rage 40 (L) Blueprint",
          "Rage 40 (L) Blueprint (L)",
          "Rage 45 (L) Blueprint",
          "Rage 45 (L) Blueprint (L)",
          "Rage 50 (L) Blueprint",
          "Rage 50 (L) Blueprint (L)",
          "Hotfoot 5 (L) Blueprint",
          "Hotfoot 10 (L) Blueprint",
          "Hotfoot 10 (L) Blueprint (L)",
          "Hotfoot 15 (L) Blueprint",
          "Hotfoot 15 (L) Blueprint (L)",
          "Hotfoot 20 (L) Blueprint",
          "Hotfoot 20 (L) Blueprint (L)",
          "Hotfoot 25 (L) Blueprint",
          "Hotfoot 25 (L) Blueprint (L)",
          "Hotfoot 30 (L) Blueprint",
          "Hotfoot 30 (L) Blueprint (L)",
          "Hotfoot 35 (L) Blueprint",
          "Hotfoot 35 (L) Blueprint (L)",
          "Hotfoot 40 (L) Blueprint",
          "Hotfoot 40 (L) Blueprint (L)",
          "Hotfoot 45 (L) Blueprint",
          "Hotfoot 45 (L) Blueprint (L)",
          "Hotfoot 50 (L) Blueprint",
          "Hotfoot 50 (L) Blueprint (L)",
          "Tension Straps Blueprint",
          "O Rings Blueprint",
          "Gas Plug Blueprint",
          "Propellant Supercharger Blueprint",
          "Propellant Booster Blueprint",
          "Gas Module Blueprint",
          "Recoil Stabiliser Blueprint",
          "Extended Breech Blueprint",
          "Extended Bolt Carriage Blueprint",
          "Flash Suppressor Blueprint",
          "Fuel Cells Blueprint",
          "Insulators Blueprint",
          "Focusing Lens Blueprint",
          "Energy Chamber Blueprint",
          "Projector Housing Blueprint",
          "Feedback Coupling Blueprint",
          "Stimulation Modulator Blueprint",
          "Power Regulator Blueprint",
          "Intensity Amplifier Blueprint",
          "Discharge Module Blueprint",
          "Ball Bearings Blueprint",
          "Long Screws Blueprint",
          "Weak Magnets Blueprint",
          "Weld filament Blueprint",
          "Standard Magnets Blueprint",
          "Gimbals Blueprint",
          "Heat Shields Blueprint",
          "Strong Magnets Blueprint",
          "Oiled Miluca Boards Blueprint",
          "Oiled Arkace Boards Blueprint",
          "Oiled Hekia Boards Blueprint",
          "Oiled Corria Boards Blueprint",
          "Patio Chair (C) Blueprint",
          "Dining Table (C) Blueprint",
          "Retail Partition High (C) Blueprint",
          "Retail Counter 1.2 (C) Blueprint",
          "Retail Counter 1.8 (C) Blueprint",
          "Retail Counter 2.4 (C) Blueprint",
          "Corner Retail Counter (C) Blueprint",
          "Tall Corner Retail Counter (C) Blueprint",
          "Retail Display Table (C) Blueprint",
          "Coffee Table (C) Blueprint",
          "Curved Retail Counter (C) Blueprint",
          "Retail Shelf (C) Blueprint",
          "Niko Ceiling Lamp Blueprint",
          "Niko Desk Lamp (C) Blueprint",
          "Niko Tall Lamp (C) Blueprint",
          "Weapon Cabinet Blueprint",
          "Ospra Texture Blueprint",
          "Kaz Texture Blueprint",
          "Veda Texture Blueprint",
          "Banite Texture Blueprint",
          "Telfium Texture Blueprint",
          "Wenrex Texture Blueprint",
          "Hebredite Texture Blueprint",
          "Yulerium Texture Blueprint",
          "Zulax Texture Blueprint",
          "Lidacon Texture Blueprint",
          "Miluca Texture Blueprint",
          "Arkace Texture Blueprint",
          "Hekia Texture Blueprint",
          "Corria Texture Blueprint",
          "Carabok Leather Texture Blueprint",
          "Jori Leather Texture Blueprint",
          "Halix Leather Texture Blueprint",
          "Feran Leather Texture Blueprint",
          "Oro Leather Texture Blueprint",
          "Zadul Leather Texture Blueprint",
          "Tiarak Leather Texture Blueprint",
          "Hadraada Leather Texture Blueprint",
          "Bokol Leather Texture Blueprint",
          "Madana Leather Texture Blueprint",
          "Oweko Leather Texture Blueprint",
          "Kiana Leather Texture Blueprint",
          "Otorugi Leather Texture Blueprint",
          "Kadra Leather Texture Blueprint",
          "Huon Leather Texture Blueprint",
          "Beladoth Leather Texture Blueprint",
          "Korwil Leather Texture Blueprint",
          "Teladon Leather Texture Blueprint",
          "Kamaldon Leather Texture Blueprint",
          "Yuka Leather Texture Blueprint",
          "Terra Amp 1 (L) Blueprint",
          "Terra Amp 1 (L) Blueprint (L)",
          "Terra Amp 2 (L) Blueprint",
          "Terra Amp 2 (L) Blueprint (L)",
          "Terra Amp 3 (L) Blueprint",
          "Terra Amp 3 (L) Blueprint (L)",
          "Terra Amp 4 (L) Blueprint",
          "Terra Amp 4 (L) Blueprint (L)",
          "Terra Amp 5 (L) Blueprint",
          "Terra Amp 5 (L) Blueprint (L)",
          "Terra Amp 6 (L) Blueprint",
          "Terra Amp 6 (L) Blueprint (L)",
          "Terra Amp 7 (L) Blueprint",
          "Terra Amp 7 (L) Blueprint (L)",
          "Terra Amp 8 (L) Blueprint",
          "Terra Amp 8 (L) Blueprint (L)",
          "Terra Amp 9 (L) Blueprint",
          "Terra Amp 9 (L) Blueprint (L)",
          "Terra Amp 10 (L) Blueprint",
          "Terra Amp 10 (L) Blueprint (L)",
          "TerraMaster 1 (L) Blueprint",
          "TerraMaster 2 (L) Blueprint",
          "TerraMaster 2 (L) Blueprint (L)",
          "TerraMaster 3 (L) Blueprint",
          "TerraMaster 3 (L) Blueprint (L)",
          "TerraMaster 4 (L) Blueprint",
          "TerraMaster 4 (L) Blueprint (L)",
          "TerraMaster 5 (L) Blueprint",
          "TerraMaster 5 (L) Blueprint (L)",
          "TerraMaster 6 (L) Blueprint",
          "TerraMaster 6 (L) Blueprint (L)",
          "TerraMaster 7 (L) Blueprint",
          "TerraMaster 7 (L) Blueprint (L)",
          "TerraMaster 8 (L) Blueprint",
          "TerraMaster 8 (L) Blueprint (L)",
          "Rock Ripper 1 (L) Blueprint",
          "Rock Ripper 1 (L) Blueprint (L)",
          "Rock Ripper 2 (L) Blueprint",
          "Rock Ripper 2 (L) Blueprint (L)",
          "Rock Ripper 3 (L) Blueprint",
          "Rock Ripper 3 (L) Blueprint (L)",
          "Rock Ripper 4 (L) Blueprint",
          "Rock Ripper 4 (L) Blueprint (L)",
          "Rock Ripper 5 (L) Blueprint",
          "Rock Ripper 5 (L) Blueprint (L)",
          "Rock Ripper 6 (L) Blueprint",
          "Rock Ripper 6 (L) Blueprint (L)",
          "Rock Ripper 7 (L) Blueprint",
          "Rock Ripper 7 (L) Blueprint (L)",
          "Rock Ripper 8 (L) Blueprint",
          "Rock Ripper 8 (L) Blueprint (L)",
          "PTech Refiner 2 Blueprint",
          "PTech Refiner 2 Blueprint (L)",
          "PTech Refiner 3 Blueprint",
          "PTech Refiner 3 Blueprint (L)",
          "Ostelok Leather Texture Blueprint",
          "Scoria Leather Texture Blueprint",
          "Nusul Leather Texture Blueprint",
          "Hoverpod Mk1 (C,L) Blueprint (L)",
          "Hoverpod Mk2 (C,L) Blueprint (L)",
          "Hoverpod Mk3 (C,L) Blueprint (L)",
          "Hoverpod Mk1 (C,L) Blueprint",
          "Hoverpod Mk2 (C,L) Blueprint",
          "Hoverpod Mk3 (C,L) Blueprint",
          "Ankitus Arm Guards Blueprint",
          "Ankitus Arm Guards Blueprint (L)",
          "Ankitus Foot Guards Blueprint",
          "Ankitus Foot Guards Blueprint (L)",
          "Ankitus Gloves Blueprint",
          "Ankitus Gloves Blueprint (L)",
          "Ankitus Harness Blueprint",
          "Ankitus Harness Blueprint (L)",
          "Ankitus Helmet Blueprint",
          "Ankitus Helmet Blueprint (L)",
          "Ankitus Shin Guards Blueprint",
          "Ankitus Shin Guards Blueprint (L)",
          "Ankitus Thigh Guards Blueprint",
          "Ankitus Thigh Guards Blueprint (L)",
          "Koroma Arm Guards Blueprint",
          "Koroma Arm Guards Blueprint (L)",
          "Koroma Foot Guards Blueprint",
          "Koroma Foot Guards Blueprint (L)",
          "Koroma Gloves Blueprint",
          "Koroma Gloves Blueprint (L)",
          "Koroma Harness Blueprint",
          "Koroma Harness Blueprint (L)",
          "Koroma Helmet Blueprint",
          "Koroma Helmet Blueprint (L)",
          "Koroma Shin Guards Blueprint",
          "Koroma Shin Guards Blueprint (L)",
          "Koroma Thigh Guards Blueprint",
          "Koroma Thigh Guards Blueprint (L)",
          "Polymer Rail Blueprint",
          "Alloy Hinge Blueprint",
          "Conduit Blueprint",
          "Adaptor Blueprint",
          "Poly-Alloy Strap Blueprint",
          "Alloy Plate Blueprint",
          "Outdoor Wicker Table Blueprint",
          "Outdoor Wicker Chair Blueprint",
          "Outdoor Wicker Couch Blueprint",
          "Striped Curtain Closed (C) Blueprint",
          "Striped Curtain Open (C) Blueprint",
          "Outdoor Dining Table Blueprint",
          "Outdoor Dining Chair Blueprint",
          "Spotted Curtain Closed (C) Blueprint",
          "Spotted Curtain Open (C) Blueprint",
          "Polkadot Curtain Closed (C) Blueprint",
          "Polkadot Curtain Open (C) Blueprint",
          "Zig-Zag Curtain Closed (C) Blueprint",
          "Zig-Zag Curtain Open (C) Blueprint",
          "Modern Curtain Closed (C) Blueprint",
          "Modern Curtain Open (C) Blueprint",
          "Rectangular Downlight Blueprint",
          "Standard Ceiling Light Blueprint",
          "Elegant Chandelier Blueprint",
          "Traditional Chandelier Blueprint",
          "Retro Chandelier Blueprint",
          "Pergola Blueprint",
          "Barbecue Blueprint",
          "Aakas Texture Blueprint",
          "Khorum Texture Blueprint",
          "Songkra Texture Blueprint",
          "Aarkan Texture Blueprint",
          "Khorudoul Texture Blueprint",
          "Vedacore Texture Blueprint",
          "Trailblazer Boots Blueprint",
          "ACA/AS Civilian Uniform Jungle Cap Blueprint",
          "ACA/AS Civilian Uniform Arctic Cap Blueprint",
          "ACA/AS Civilian Uniform Desert Cap Blueprint",
          "IFN Combat Uniform Jungle Cap Blueprint",
          "IFN Combat Uniform Arctic Cap Blueprint",
          "IFN Combat Uniform Desert Cap Blueprint",
          "Trailblazer Long Boots (F) Blueprint",
          "ACA/AS Civilian Uniform Jungle Singlet Blueprint",
          "ACA/AS Civilian Uniform Arctic Singlet Blueprint",
          "ACA/AS Civilian Uniform Desert Singlet Blueprint",
          "IFN Combat Uniform Jungle Singlet Blueprint",
          "IFN Combat Uniform Arctic Singlet Blueprint",
          "IFN Combat Uniform Desert Singlet Blueprint",
          "ACA/AS Civilian Uniform Jungle Shirt Blueprint",
          "ACA/AS Civilian Uniform Arctic Shirt Blueprint",
          "ACA/AS Civilian Uniform Desert Shirt Blueprint",
          "IFN Combat Uniform Jungle Shirt Blueprint",
          "IFN Combat Uniform Arctic Shirt Blueprint",
          "IFN Combat Uniform Desert Shirt Blueprint",
          "ACA/AS Civilian Uniform Jungle Pants Blueprint",
          "ACA/AS Civilian Uniform Arctic Pants Blueprint",
          "ACA/AS Civilian Uniform Desert Pants Blueprint",
          "IFN Combat Uniform Jungle Pants Blueprint",
          "IFN Combat Uniform Arctic Pants Blueprint",
          "IFN Combat Uniform Desert Pants Blueprint",
          "ACA/AS Civilian Uniform Jungle Glasses Blueprint",
          "ACA/AS Civilian Uniform Arctic Glasses Blueprint",
          "ACA/AS Civilian Uniform Desert Glasses Blueprint",
          "Carapace Blue Boots Blueprint",
          "Carapace White Boots Blueprint",
          "Carapace Black Boots Blueprint",
          "Carapace Red Boots Blueprint",
          "Arkadian Key 1 Blueprint",
          "Arkadian Key 2 Blueprint",
          "Arkadian Key 3 Blueprint",
          "Arkadian Key 4 Blueprint",
          "Arkadian Key 5 Blueprint",
          "Arkadian Key 6 Blueprint",
          "Arkadian Key 7 Blueprint",
          "Arkadian Key 8 Blueprint",
          "Arkadian Key 9 Blueprint",
          "Arkadian Key 10 Blueprint",
          "ACA/AS Civilian Uniform Custom Cap (C) Blueprint",
          "IFN Combat Uniform Custom Cap (C) Blueprint",
          "ACA/AS Civilian Uniform Custom Singlet (C) Blueprint",
          "IFN Combat Uniform Custom Singlet (C) Blueprint",
          "ACA/AS Civilian Uniform Custom Shirt (C) Blueprint",
          "IFN Combat Uniform Custom Shirt (C) Blueprint",
          "ACA/AS Civilian Uniform Custom Pants (C) Blueprint",
          "IFN Combat Uniform Custom Pants (C) Blueprint",
          "Riptor Leather Texture Blueprint",
          "Arkadian Golden Key Blueprint",
          "Arkadian Golden Key Blueprint (L)",
          "Party Lights Blueprint",
          "IFN - Medical Partition Blueprint",
          "Modern Coffee Table Blueprint",
          "Table Lamp Blueprint",
          "Filing Cabinet Blueprint",
          "Allure Leather Armchair Blueprint",
          "Allure Leather Sofa Blueprint",
          "IFN - Medical Vitruvian Hologram Blueprint",
          "IFN - Medical Bed Blueprint",
          "IFN - Medical Refrigerator Blueprint",
          "IFN - Medical Cubicle Blueprint",
          "Herman ARK-16 (L) Blueprint (L)",
          "Herman ARK-31 Desert (L) Blueprint (L)",
          "Herman ARK-41 (L) Blueprint (L)",
          "Herman ARK-55 Jungle (L) Blueprint (L)",
          "Herman ASI-5 Arctic (L) Blueprint (L)",
          "Herman ASI-16 Arctic (L) Blueprint (L)",
          "Herman ASI-27 Arctic (L) Blueprint (L)",
          "Herman ASI-48 Desert (L) Blueprint (L)",
          "Herman ASI-53 Desert (L) Blueprint (L)",
          "Herman ASI-58 Desert (L) Blueprint (L)",
          "Herman LAW-10 (L) Blueprint (L)",
          "Herman LAW-16 Arctic (L) Blueprint (L)",
          "Herman LAW-32 (L) Blueprint (L)",
          "Herman LAW-37 Arctic (L) Blueprint (L)",
          "Herman LAW-51 Jungle (L) Blueprint (L)",
          "Herman CAP-28 Arctic (L) Blueprint (L)",
          "Herman CAP-4 Desert (L) Blueprint (L)",
          "Herman CAP-40 Desert (L) Blueprint (L)",
          "Herman CAP-52 (L) Blueprint (L)",
          "Herman CAP-48 (L) Blueprint (L)",
          "Terra Amp I 'Athena' (L) Blueprint",
          "Terra Amp I 'Athena' (L) Blueprint (L)",
          "Terra Amp IV 'Athena' (L) Blueprint",
          "Terra Amp IV 'Athena' (L) Blueprint (L)",
          "Terra Amp VI 'Athena' (L) Blueprint",
          "Terra Amp VI 'Athena' (L) Blueprint (L)",
          "Gallard Leather Texture Blueprint",
          "Resonation Amplifier 1 Blueprint (L)",
          "Resonation Amplifier 2 Blueprint (L)",
          "Resonation Amplifier 3 Blueprint (L)",
          "Resonation Amplifier 4 Blueprint (L)",
          "Resonation Amplifier 5 Blueprint (L)",
          "Resonation Amplifier 6 Blueprint (L)",
          "Resonation Amplifier 7 Blueprint (L)",
          "Resonation Amplifier 8 Blueprint (L)",
          "Resonation Amplifier 9 Blueprint (L)",
          "Screenshot light 1 Blueprint (L)",
          "Screenshot light 2 Blueprint (L)",
          "Directors chair Blueprint (L)",
          "Wombana Leather Texture Blueprint",
          "Togolossi Leather Texture Blueprint",
          "Navi Leather Texture Blueprint",
          "Pandi Leather Texture Blueprint",
          "Arkadian Hornet Leather Texture Blueprint",
          "Dromia Leather Texture Blueprint",
          "Monura Male Leather Texture Blueprint",
          "Monura Female Leather Texture Blueprint",
          "TEST Payn-Inc Rookie Implant Inserter (L) Blueprint",
          "Modern Leather Armchair Blueprint",
          "Modern Leather Sofa Blueprint",
          "Elegant Coffee Table Blueprint",
          "Melatinum Texture Blueprint",
          "Bismuth Texture Blueprint",
          "Sandrunner MKI (C,L) Blueprint",
          "Sandrunner MKII (C,L) Blueprint",
          "Sandrunner MKIII (C,L) Blueprint",
          "Sandrunner MKI (C,L) Blueprint (L)",
          "Sandrunner MKII (C,L) Blueprint (L)",
          "Sandrunner MKIII (C,L) Blueprint (L)",
          "Sandrunner MKI (L) Blueprint (L)",
          "Sandrunner MKII (L) Blueprint (L)",
          "Sandrunner MKIII (L) Blueprint (L)",
          "Sandrunner Fuel Cells Blueprint",
          "Staff Shirt (F) Blueprint (L)",
          "Travellers Robe (M) Blueprint (L)",
          "Flora Short Dress (F) Blueprint (L)",
          "Flora Short Dress (F,C) Blueprint (L)",
          "Ark Formal Tuxedo - Gray (M) Blueprint (L)",
          "Ark Formal Pants - Gray (M) Blueprint (L)",
          "Ark Formal Shoes (M) Blueprint (L)",
          "Ark Formal Tuxedo - Blue (M) Blueprint (L)",
          "Ark Formal Pants - Blue (M) Blueprint (L)",
          "Ark Formal Tuxedo - Black (M) Blueprint (L)",
          "Ark Formal Pants - Black (M) Blueprint (L)",
          "Travellers Hood (M) Blueprint (L)",
          "Dark Travellers Robe (M) Blueprint (L)",
          "Dark Travellers Hood (M) Blueprint (L)",
          "Guardian Nurse Dress (F) Blueprint (L)",
          "Guardian Nurse Tiara (F) Blueprint (L)",
          "Guardian Nurse Boots (F) Blueprint (L)",
          "Guardian Nurse Gloves (F) Blueprint (L)",
          "Else Table - Alpha Blueprint",
          "Else Table - Bravo Blueprint",
          "Else Table - Alpha (C) Blueprint",
          "Else Table - Bravo (C) Blueprint",
          "Else Chair - Alpha Blueprint",
          "Else Chair - Alpha (C) Blueprint",
          "Else Chair - Bravo Blueprint",
          "Else Chair - Bravo (C) Blueprint",
          "Else Light - Alpha Blueprint",
          "Else Light - Bravo Blueprint",
          "Else Light - Charlie Blueprint",
          "Else Light - Delta Blueprint",
          "Else Light - Echo Blueprint",
          "Else Light - Alpha (C) Blueprint",
          "Else Light - Bravo (C) Blueprint",
          "Else Light - Charlie (C) Blueprint",
          "Else Light - Delta (C) Blueprint",
          "Else Light - Echo (C) Blueprint",
          "GMC Gamma Leather Texture Blueprint",
          "Oompa Warhound Leather Texture Blueprint",
          "Oompa Leather Texture Blueprint",
          "Sicarius Leather Texture Blueprint",
          "Sicarius Brute Leather Texture Blueprint",
          "Sicarius Commander Leather Texture Blueprint",
          "Sahra MK2 (L) Blueprint",
          "Sahra MK3 (L) Blueprint (L)",
          "Sahra MK4 (L) Blueprint (L)",
          "Hojoom G2 (L) Blueprint",
          "Hojoom G3 (L) Blueprint (L)",
          "Hojoom G4 (L) Blueprint (L)",
          "Fanoos Medical V2 (L) Blueprint",
          "Fanoos Medical V3 (L) Blueprint (L)",
          "Fanoos Medical V4 (L) Blueprint (L)",
          "Fanoos Medical V5 (L) Blueprint (L)",
          "Sabad Finder M2 (L) Blueprint",
          "Sabad Finder M3 (L) Blueprint (L)",
          "Sabad Finder M4 (L) Blueprint (L)",
          "Sabad Finder M5 (L) Blueprint (L)",
          "ARD Excavator M2 (L) Blueprint",
          "ARD Excavator M3 (L) Blueprint (L)",
          "ARD Excavator M4 (L) Blueprint (L)",
          "ARD Excavator M5 (L) Blueprint (L)",
          "Tabtab Texture Blueprint",
          "Qaffaz Texture Blueprint",
          "Khaffash Texture Blueprint",
          "Sunjoq Texture Blueprint",
          "Thawr Texture Blueprint",
          "Arabesque Texture Blueprint",
          "Nahar Mist Texture Blueprint",
          "Sweet Glow Texture Blueprint",
          "Aqeeq Texture Blueprint",
          "Lulu Texture Blueprint",
          "Bahri Texture Blueprints",
          "Samar Shoe (C) Blueprint",
          "Labibah Coat(F,C) Blueprint",
          "Jadees Pants (F,C) Blueprint",
          "Bakery Fayza (F,C) Blueprint",
          "Sahari Pleat (F,C) Blueprint",
          "Liqa Shirt (C) Blueprint",
          "Caboria Texture Blueprints",
          "Delia Shirt (F,C) Blueprint",
          "Layah Fashion (F,C) Blueprint",
          "Nadain Fashion (F,C) Blueprint",
          "Adrees Shoes (F,C) Blueprint",
          "Darzeh Pants (M,C) Blueprint",
          "Jaish Boots (M,C) Blueprint",
          "Elder Coat (M,C) Blueprint",
          "Innkeeper Jacket (M,C) Blueprint",
          "Faris Jeans (M,C) Blueprint",
          "Wazir Pleat (M,C) Blueprint",
          "Fisherman Shorts (M,C) Blueprint",
          "Nada Shirt (F,C) Blueprint",
          "Liqa Pants (C) Blueprint",
          "Dahhar Texture Blueprints",
          "Motamared Amamah (M,C) Blueprint",
          "Motamared Shoe (M,C) Blueprint",
          "Motamared Shirt (M,C) Blueprint",
          "Motamared Pants (M,C) Blueprint",
          "Jassem Headwear (M,C) Blueprint",
          "Jassem Coat (M,C) Blueprint",
          "Jassem Pants (M,C) Blueprint",
          "Jassem Boots (M,C) Blueprint",
          "Jeef Zajer Texture Blueprint",
          "Samm Twin Edge (L) Blueprint",
          "Samm Twin Fate (L) Blueprint",
          "Samm Twin Poison (L) Blueprint",
          "Asl Crash (L) Blueprint",
          "Asl Dash (L) Blueprint",
          "Asl Smash (L) Blueprint",
          "Thaqafa Blade M1 (L) Blueprint",
          "Thaqafa Blade M2 (L) Blueprint",
          "Thaqafa Blade M3 (L) Blueprint",
          "Turath Blade M1 (L) Blueprint",
          "Turath Blade M2 (L) Blueprint",
          "Turath Blade M3 (L) Blueprint",
          "Habkeh Blueprint",
          "Zir Blueprint",
          "Mismar Blueprint",
          "Mosannan Blueprint",
          "Qataal PayBack (L) Blueprint",
          "Qataal SlayWay (L) Blueprint",
          "BirdOfPrey Jareh (L) Blueprint",
          "BirdOfPrey Kaser (L) Blueprint",
          "BirdOfPrey Tayer (L) Blueprint",
          "Hojoom G5 (L) Blueprint (L)",
          "Sahra MK5 (L) Blueprint (L)",
          "Salafa G4 (L) Blueprint (L)",
          "Sunburst Texture Blueprint",
          "Yashib Texture Blueprint",
          "Borghee Blueprint",
          "Ibreh Blueprint",
          "Malkat Blueprint",
          "Copchaih Blueprint",
          "Zeraf Armor Helmet Blueprint",
          "Zeraf Armor Thigh Guards Blueprint",
          "Mawlood Training Armor Harness (L) Blueprint (L)",
          "Tibbi Medical V7 (L) Blueprint (L)",
          "Tibbi Medical V8 (L) Blueprint (L)",
          "CUHOF 01 Key Blueprint",
          "CUHOF 02 Key Blueprint",
          "CUHOF 03 Key Blueprint",
          "CUHOF 04 Key Blueprint",
          "CUHOF 05 Key Blueprint",
          "Megingjord Light Turret Mk. 1 (C,L) Blueprint (L)",
          "V-Neck Mesh Tanktop (C) Blueprint (L)",
          "Space Thruster (L) Blueprint (L)",
          "Welding Wire Blueprint (L)",
          "Welding Wire Blueprint",
          "Quad-Wing Interceptor (L) Blueprint (L)",
          "Kismet Light Laser (L) Blueprint (L)",
          "Sub Warp Drive 1 (L) Blueprint (L)",
          "Sub Warp Drive 2 (L) Blueprint (L)",
          "Sub Warp Drive 3 (L) Blueprint (L)",
          "Sub Warp Drive 4 (L) Blueprint (L)",
          "Sub Warp Drive 5 (L) Blueprint (L)",
          "Armament Device 1 (L) Blueprint (L)",
          "Armament Device 2 (L) Blueprint (L)",
          "Armament Device 3 (L) Blueprint (L)",
          "Armament Device 4 (L) Blueprint (L)",
          "Armament Device 5 (L) Blueprint (L)",
          "Energy Source (L) Blueprint (L)",
          "Warp Drive 1 (L) Blueprint (L)",
          "Warp Drive 2 (L) Blueprint (L)",
          "Warp Drive 3 (L) Blueprint (L)",
          "Warp Drive 4 (L) Blueprint (L)",
          "Warp Drive 5 (L) Blueprint (L)",
          "Warp Mine Mk. 1 Blueprint (L)",
          "Warp Mine Mk. 2 Blueprint (L)",
          "Warp Mine Mk. 3 Blueprint (L)",
          "Warp Mine Mk. 4 Blueprint (L)",
          "Warp Mine Mk. 5 Blueprint (L)",
          "Naglfar Mk. 1 (C,L) Blueprint (L)",
          "Naglfar Mk. 2 (C,L) Blueprint (L)",
          "Naglfar Mk. 3 (C,L) Blueprint (L)",
          "Naglfar Mk. 4 (C,L) Blueprint (L)",
          "Megingjord Mk. 1 (C,L) Blueprint (L)",
          "Megingjord Mk. 2 (C,L) Blueprint (L)",
          "Megingjord Mk. 3 (C,L) Blueprint (L)",
          "Megingjord Mk. 4 (C,L) Blueprint (L)",
          "Gungnir Mk. 1 (C,L) Blueprint (L)",
          "Gungnir Mk. 2 (C,L) Blueprint (L)",
          "Gungnir Mk. 3 (C,L) Blueprint (L)",
          "Gungnir Mk. 4 (C,L) Blueprint (L)",
          "Naglfar Anti Air Cannon Mk. 1 (L) Blueprint (L)",
          "Naglfar Turret Mk. 1 (C,L) Blueprint (L)",
          "Megingjord Turret Mk. 1 (C,L) Blueprint (L)",
          "Heavy Porcupine HMAP-52 (L) Blueprint (L)",
          "Helicopter MMB AS-41 (L) Blueprint (L)",
          "Fire Of Hel (L) Blueprint (L)",
          "Valkyrie V2 Mk. 1 (L) Blueprint (L)",
          "Valkyrie V2 Mk. 2 (L) Blueprint (L)",
          "Saehrimnir V2 Mk. 1 (L) Blueprint (L)",
          "Saehrimnir V2 Mk. 2 (L) Blueprint (L)",
          "Jormungand V2 Mk. 1 (L) Blueprint (L)",
          "Jormungand V2 Mk. 2 (L) Blueprint (L)",
          "Sleipnir V2 Mk. 1 (L) Blueprint (L)",
          "Sleipnir V2 Mk. 2 (L) Blueprint (L)",
          "Hovercraft CC V2 Mk. 1 (L) Blueprint (L)",
          "Hovercraft CC V2 Mk. 2 (L) Blueprint (L)",
          "VTOL MMB AS-35 (L) Blueprint (L)",
          "Level 1 Finder Amplifier 'Achilles' (L) Blueprint (L)",
          "Level 2 Finder Amplifier 'Achilles' (L) Blueprint (L)",
          "Level 3 Finder Amplifier 'Achilles' (L) Blueprint (L)",
          "Level 7 Finder Amplifier 'Athena' (L) Blueprint (L)",
          "Level 8 Finder Amplifier 'Athena' (L) Blueprint (L)",
          "Portable TT Unit (L) Blueprint (L)",
          "Portable Repair Unit (L) Blueprint (L)",
          "Dominax Original Garter (L) Blueprint (L)",
          "Dominax Original Moccasin (L) Blueprint (L)",
          "Dominax Original Habu (L) Blueprint (L)",
          "Dominax Original Mamushi (L) Blueprint (L)",
          "Dominax Original Boiga (L) Blueprint (L)",
          "Melee Durability Amplifier 92 (L) Blueprint (L)",
          "Melee Durability Amplifier 94 (L) Blueprint (L)",
          "Melee Durability Amplifier 96 (L) Blueprint (L)",
          "ArMatrix LR-10 (L) Blueprint (L)",
          "ArMatrix LR-15 (L) Blueprint (L)",
          "ArMatrix LR-20 (L) Blueprint (L)",
          "ArMatrix LR-25 (L) Blueprint (L)",
          "ArMatrix LR-30 (L) Blueprint (L)",
          "ArMatrix LR-35 (L) Blueprint (L)",
          "ArMatrix LR-40 (L) Blueprint (L)",
          "ArMatrix LR-45 (L) Blueprint (L)",
          "ArMatrix LR-50 (L) Blueprint (L)",
          "ArMatrix LR-55 (L) Blueprint (L)",
          "ArMatrix LR-60 (L) Blueprint (L)",
          "ArMatrix LR-65 (L) Blueprint (L)",
          "ArMatrix LR-70 (L) Blueprint (L)",
          "ArMatrix LR-75 (L) Blueprint (L)",
          "ArMatrix LR-80 (L) Blueprint (L)",
          "ArMatrix LR-85 (L) Blueprint (L)",
          "ArMatrix LR-90 (L) Blueprint (L)",
          "ArMatrix LR-95 (L) Blueprint (L)",
          "ArMatrix LR-100 (L) Blueprint (L)",
          "ArMatrix LR-105 (L) Blueprint (L)",
          "Component Widget 1 Blueprint",
          "Component Widget 2 Blueprint",
          "Component Widget 3 Blueprint",
          "Component Widget 4 Blueprint",
          "Component Widget 5 Blueprint",
          "Component Widget 6 Blueprint",
          "Component Widget 7 Blueprint",
          "Component Widget 8 Blueprint",
          "Weapon Tech Gizmo 1 Blueprint",
          "Weapon Tech Gizmo 2 Blueprint",
          "Weapon Tech Gizmo 3 Blueprint",
          "Weapon Tech Gizmo 4 Blueprint",
          "Weapon Tech Gizmo 5 Blueprint",
          "Weapon Tech Gizmo 6 Blueprint",
          "Weapon Tech Gizmo 7 Blueprint",
          "Weapon Tech Gizmo 8 Blueprint",
          "Tool Tech Gizmo 1 Blueprint",
          "Tool Tech Gizmo 2 Blueprint",
          "Tool Tech Gizmo 3 Blueprint",
          "Tool Tech Gizmo 4 Blueprint",
          "Tool Tech Gizmo 5 Blueprint",
          "Tool Tech Gizmo 6 Blueprint",
          "Tool Tech Gizmo 7 Blueprint",
          "Tool Tech Gizmo 8 Blueprint",
          "Attachment Tech Gizmo 1 Blueprint",
          "Attachment Tech Gizmo 2 Blueprint",
          "Attachment Tech Gizmo 3 Blueprint",
          "Attachment Tech Gizmo 4 Blueprint",
          "Attachment Tech Gizmo 5 Blueprint",
          "Attachment Tech Gizmo 6 Blueprint",
          "Attachment Tech Gizmo 7 Blueprint",
          "Attachment Tech Gizmo 8 Blueprint",
          "Tech Gizmo Recycle 1 Blueprint (L)",
          "Tech Gizmo Recycle 2 Blueprint (L)",
          "Tech Gizmo Recycle 3 Blueprint (L)",
          "ArMatrix BP-10 (L) Blueprint (L)",
          "ArMatrix BP-15 (L) Blueprint (L)",
          "ArMatrix BP-20 (L) Blueprint (L)",
          "ArMatrix BP-25 (L) Blueprint (L)",
          "ArMatrix BP-30 (L) Blueprint (L)",
          "ArMatrix BP-35 (L) Blueprint (L)",
          "ArMatrix BP-40 (L) Blueprint (L)",
          "ArMatrix BP-45 (L) Blueprint (L)",
          "ArMatrix BP-50 (L) Blueprint (L)",
          "ArMatrix BP-55 (L) Blueprint (L)",
          "ArMatrix BP-60 (L) Blueprint (L)",
          "ArMatrix BP-65 (L) Blueprint (L)",
          "ArMatrix BP-70 (L) Blueprint (L)",
          "ArMatrix BP-75 (L) Blueprint (L)",
          "ArMatrix BP-80 (L) Blueprint (L)",
          "ArMatrix BP-85 (L) Blueprint (L)",
          "ArMatrix BP-90 (L) Blueprint (L)",
          "ArMatrix BP-95 (L) Blueprint (L)",
          "ArMatrix BP-100 (L) Blueprint (L)",
          "ArMatrix BP-105 (L) Blueprint (L)",
          "NeoPsion Kinetic Amplifier 1 (L) Blueprint (L)",
          "NeoPsion Kinetic Amplifier 2 (L) Blueprint (L)",
          "NeoPsion Kinetic Amplifier 3 (L) Blueprint (L)",
          "NeoPsion Kinetic Amplifier 4 (L) Blueprint (L)",
          "NeoPsion Kinetic Amplifier 5 (L) Blueprint (L)",
          "NeoPsion Kinetic Amplifier 6 (L) Blueprint (L)",
          "NeoPsion Kinetic Amplifier 7 (L) Blueprint (L)",
          "ArMatrix LP-10 (L) Blueprint (L)",
          "ArMatrix LP-15 (L) Blueprint (L)",
          "ArMatrix LP-20 (L) Blueprint (L)",
          "ArMatrix LP-25 (L) Blueprint (L)",
          "ArMatrix LP-30 (L) Blueprint (L)",
          "ArMatrix LP-35 (L) Blueprint (L)",
          "ArMatrix LP-40 (L) Blueprint (L)",
          "ArMatrix LP-45 (L) Blueprint (L)",
          "ArMatrix LP-50 (L) Blueprint (L)",
          "ArMatrix LP-55 (L) Blueprint (L)",
          "ArMatrix LP-60 (L) Blueprint (L)",
          "ArMatrix LP-65 (L) Blueprint (L)",
          "ArMatrix LP-70 (L) Blueprint (L)",
          "ArMatrix LP-75 (L) Blueprint (L)",
          "ArMatrix LP-80 (L) Blueprint (L)",
          "ArMatrix LP-85 (L) Blueprint (L)",
          "ArMatrix LP-90 (L) Blueprint (L)",
          "ArMatrix LP-95 (L) Blueprint (L)",
          "ArMatrix LP-100 (L) Blueprint (L)",
          "ArMatrix LP-105 (L) Blueprint (L)",
          "ArMatrix BC-10 (L) Blueprint (L)",
          "ArMatrix BC-15 (L) Blueprint (L)",
          "ArMatrix BC-20 (L) Blueprint (L)",
          "ArMatrix BC-25 (L) Blueprint (L)",
          "ArMatrix BC-30 (L) Blueprint (L)",
          "ArMatrix BC-35 (L) Blueprint (L)",
          "ArMatrix BC-40 (L) Blueprint (L)",
          "ArMatrix BC-45 (L) Blueprint (L)",
          "ArMatrix BC-50 (L) Blueprint (L)",
          "ArMatrix BC-55 (L) Blueprint (L)",
          "ArMatrix BC-60 (L) Blueprint (L)",
          "ArMatrix BC-65 (L) Blueprint (L)",
          "ArMatrix BC-70 (L) Blueprint (L)",
          "ArMatrix BC-75 (L) Blueprint (L)",
          "ArMatrix BC-80 (L) Blueprint (L)",
          "ArMatrix BC-85 (L) Blueprint (L)",
          "ArMatrix BC-90 (L) Blueprint (L)",
          "ArMatrix BC-95 (L) Blueprint (L)",
          "ArMatrix BC-100 (L) Blueprint (L)",
          "ArMatrix BC-105 (L) Blueprint (L)",
          "ArMatrix SB-10 (L) Blueprint (L)",
          "ArMatrix SB-15 (L) Blueprint (L)",
          "ArMatrix SB-20 (L) Blueprint (L)",
          "ArMatrix SB-25 (L) Blueprint (L)",
          "ArMatrix SB-30 (L) Blueprint (L)",
          "ArMatrix SB-35 (L) Blueprint (L)",
          "ArMatrix SB-40 (L) Blueprint (L)",
          "ArMatrix SB-45 (L) Blueprint (L)",
          "ArMatrix SB-50 (L) Blueprint (L)",
          "ArMatrix SB-55 (L) Blueprint (L)",
          "ArMatrix SB-60 (L) Blueprint (L)",
          "ArMatrix SB-65 (L) Blueprint (L)",
          "ArMatrix SB-70 (L) Blueprint (L)",
          "ArMatrix SB-75 (L) Blueprint (L)",
          "ArMatrix SB-80 (L) Blueprint (L)",
          "ArMatrix SB-85 (L) Blueprint (L)",
          "ArMatrix SB-90 (L) Blueprint (L)",
          "ArMatrix SB-95 (L) Blueprint (L)",
          "ArMatrix SB-100 (L) Blueprint (L)",
          "ArMatrix SB-105 (L) Blueprint (L)",
          "ArMatrix LB-10 (L) Blueprint (L)",
          "ArMatrix LB-15 (L) Blueprint (L)",
          "ArMatrix LB-20 (L) Blueprint (L)",
          "ArMatrix LB-25 (L) Blueprint (L)",
          "ArMatrix LB-30 (L) Blueprint (L)",
          "ArMatrix LB-35 (L) Blueprint (L)",
          "ArMatrix LB-40 (L) Blueprint (L)",
          "ArMatrix LB-45 (L) Blueprint (L)",
          "ArMatrix LB-50 (L) Blueprint (L)",
          "ArMatrix LB-55 (L) Blueprint (L)",
          "ArMatrix LB-60 (L) Blueprint (L)",
          "ArMatrix LB-65 (L) Blueprint (L)",
          "ArMatrix LB-70 (L) Blueprint (L)",
          "ArMatrix LB-75 (L) Blueprint (L)",
          "ArMatrix LB-80 (L) Blueprint (L)",
          "ArMatrix LB-85 (L) Blueprint (L)",
          "ArMatrix LB-90 (L) Blueprint (L)",
          "ArMatrix LB-95 (L) Blueprint (L)",
          "ArMatrix LB-100 (L) Blueprint (L)",
          "ArMatrix LB-105 (L) Blueprint (L)",
          "Dominax Original Moccasin, E.L.M. Edition (L) Blueprint (L)",
          "ArMatrix Extender P10 (L) Blueprint (L)",
          "ArMatrix Extender P15 (L) Blueprint (L)",
          "ArMatrix Extender P20 (L) Blueprint (L)",
          "AP-6 Impact (L) Blueprint (L)",
          "AP-12 Impact (L) Blueprint (L)",
          "AP-18 Impact (L) Blueprint (L)",
          "AP-24 Impact (L) Blueprint (L)",
          "AP-30 Impact (L) Blueprint (L)",
          "AP-36 Impact (L) Blueprint (L)",
          "AP-42 Impact (L) Blueprint (L)",
          "AP-48 Impact (L) Blueprint (L)",
          "AP-54 Impact (L) Blueprint (L)",
          "AP-60 Impact (L) Blueprint (L)",
          "AP-66 Impact (L) Blueprint (L)",
          "Armor Tech Gizmo 1 Blueprint",
          "Armor Tech Gizmo 2 Blueprint",
          "Armor Tech Gizmo 3 Blueprint",
          "Armor Tech Gizmo 4 Blueprint",
          "Armor Tech Gizmo 5 Blueprint",
          "Armor Tech Gizmo 6 Blueprint",
          "Armor Tech Gizmo 7 Blueprint",
          "Armor Tech Gizmo 8 Blueprint",
          "Explosive Projectiles Blueprint 1",
          "Explosive Projectiles Blueprint 2",
          "Explosive Projectiles Blueprint 3",
          "Explosive Projectiles Blueprint 4",
          "AP-6 Cut (L) Blueprint (L)",
          "AP-12 Cut (L) Blueprint (L)",
          "AP-18 Cut (L) Blueprint (L)",
          "AP-24 Cut (L) Blueprint (L)",
          "AP-30 Cut (L) Blueprint (L)",
          "AP-36 Cut (L) Blueprint (L)",
          "AP-42 Cut (L) Blueprint (L)",
          "AP-48 Cut (L) Blueprint (L)",
          "AP-54 Cut (L) Blueprint (L)",
          "AP-60 Cut (L) Blueprint (L)",
          "AP-66 Cut (L) Blueprint (L)",
          "AP-6 Stab (L) Blueprint (L)",
          "AP-12 Stab (L) Blueprint (L)",
          "AP-18 Stab (L) Blueprint (L)",
          "AP-24 Stab (L) Blueprint (L)",
          "AP-30 Stab (L) Blueprint (L)",
          "AP-36 Stab (L) Blueprint (L)",
          "AP-42 Stab (L) Blueprint (L)",
          "AP-48 Stab (L) Blueprint (L)",
          "AP-54 Stab (L) Blueprint (L)",
          "AP-60 Stab (L) Blueprint (L)",
          "AP-66 Stab (L) Blueprint (L)",
          "AP-6 Burn (L) Blueprint (L)",
          "AP-12 Burn (L) Blueprint (L)",
          "AP-18 Burn (L) Blueprint (L)",
          "AP-24 Burn (L) Blueprint (L)",
          "AP-30 Burn (L) Blueprint (L)",
          "AP-36 Burn (L) Blueprint (L)",
          "AP-42 Burn (L) Blueprint (L)",
          "AP-48 Burn (L) Blueprint (L)",
          "AP-54 Burn (L) Blueprint (L)",
          "AP-60 Burn (L) Blueprint (L)",
          "AP-66 Burn (L) Blueprint (L)",
          "AP-6 Acid (L) Blueprint (L)",
          "AP-12 Acid (L) Blueprint (L)",
          "AP-18 Acid (L) Blueprint (L)",
          "AP-24 Acid (L) Blueprint (L)",
          "AP-30 Acid (L) Blueprint (L)",
          "AP-36 Acid (L) Blueprint (L)",
          "AP-42 Acid (L) Blueprint (L)",
          "AP-48 Acid (L) Blueprint (L)",
          "AP-54 Acid (L) Blueprint (L)",
          "AP-60 Acid (L) Blueprint (L)",
          "AP-66 Acid (L) Blueprint (L)",
          "AP-6 Electric (L) Blueprint (L)",
          "AP-12 Electric (L) Blueprint (L)",
          "AP-18 Electric (L) Blueprint (L)",
          "AP-24 Electric (L) Blueprint (L)",
          "AP-30 Electric (L) Blueprint (L)",
          "AP-36 Electric (L) Blueprint (L)",
          "AP-42 Electric (L) Blueprint (L)",
          "AP-48 Electric (L) Blueprint (L)",
          "AP-54 Electric (L) Blueprint (L)",
          "AP-60 Electric (L) Blueprint (L)",
          "AP-66 Electric (L) Blueprint (L)",
          "AP-6 Cold (L) Blueprint (L)",
          "AP-12 Cold (L) Blueprint (L)",
          "AP-18 Cold (L) Blueprint (L)",
          "AP-24 Cold (L) Blueprint (L)",
          "AP-30 Cold (L) Blueprint (L)",
          "AP-36 Cold (L) Blueprint (L)",
          "AP-42 Cold (L) Blueprint (L)",
          "AP-48 Cold (L) Blueprint (L)",
          "AP-54 Cold (L) Blueprint (L)",
          "AP-60 Cold (L) Blueprint (L)",
          "AP-66 Cold (L) Blueprint (L)",
          "AP-6 Penetration (L) Blueprint (L)",
          "AP-12 Penetration (L) Blueprint (L)",
          "AP-18 Penetration (L) Blueprint (L)",
          "AP-24 Penetration (L) Blueprint (L)",
          "AP-30 Penetration (L) Blueprint (L)",
          "AP-36 Penetration (L) Blueprint (L)",
          "AP-42 Penetration (L) Blueprint (L)",
          "AP-48 Penetration (L) Blueprint (L)",
          "AP-54 Penetration (L) Blueprint (L)",
          "AP-60 Penetration (L) Blueprint (L)",
          "AP-66 Penetration (L) Blueprint (L)",
          "AP-6 Shrapnel (L) Blueprint (L)",
          "AP-12 Shrapnel (L) Blueprint (L)",
          "AP-18 Shrapnel (L) Blueprint (L)",
          "AP-24 Shrapnel (L) Blueprint (L)",
          "AP-30 Shrapnel (L) Blueprint (L)",
          "AP-36 Shrapnel (L) Blueprint (L)",
          "AP-42 Shrapnel (L) Blueprint (L)",
          "AP-48 Shrapnel (L) Blueprint (L)",
          "AP-54 Shrapnel (L) Blueprint (L)",
          "AP-60 Shrapnel (L) Blueprint (L)",
          "AP-66 Shrapnel (L) Blueprint (L)",
          "Explosive Projectiles Recycle 1 Blueprint (L)",
          "Explosive Projectiles Recycle 2 Blueprint (L)",
          "Explosive Projectiles Recycle 3 Blueprint (L)",
          "Explosive Projectiles Recycle 4 Blueprint (L)",
          "ArMatrix L-Amplifier 4B (L) Blueprint (L)",
          "ArMatrix L-Amplifier 6B (L) Blueprint (L)",
          "ArMatrix L-Amplifier 8B (L) Blueprint (L)",
          "ArMatrix L-Amplifier 10B (L) Blueprint (L)",
          "ArMatrix L-Amplifier 13B (L) Blueprint (L)",
          "ArMatrix L-Amplifier 17B (L) Blueprint (L)",
          "ArMatrix L-Amplifier 20B (L) Blueprint (L)",
          "ArMatrix L-Amplifier 23B (L) Blueprint (L)",
          "ArMatrix L-Amplifier 25B (L) Blueprint (L)",
          "ArMatrix L-Amplifier 28B (L) Blueprint (L)",
          "ArMatrix L-Amplifier 33B (L) Blueprint (L)",
          "ArMatrix L-Amplifier 37B (L) Blueprint (L)",
          "ArMatrix L-Amplifier 42B (L) Blueprint (L)",
          "ArMatrix L-Amplifier 45B (L) Blueprint (L)",
          "ArMatrix L-Amplifier 50B (L) Blueprint (L)",
          "ArMatrix L-Amplifier 55B (L) Blueprint (L)",
          "ArMatrix L-Amplifier 60B (L) Blueprint (L)",
          "ArMatrix L-Amplifier 65B (L) Blueprint (L)",
          "ArMatrix L-Amplifier 70B (L) Blueprint (L)",
          "ArMatrix L-Amplifier 75B (L) Blueprint (L)",
          "ArMatrix B-Amplifier 4P (L) Blueprint (L)",
          "ArMatrix B-Amplifier 6P (L) Blueprint (L)",
          "ArMatrix B-Amplifier 8P (L) Blueprint (L)",
          "ArMatrix B-Amplifier 10P (L) Blueprint (L)",
          "ArMatrix B-Amplifier 13P (L) Blueprint (L)",
          "ArMatrix B-Amplifier 17P (L) Blueprint (L)",
          "ArMatrix B-Amplifier 20P (L) Blueprint (L)",
          "ArMatrix B-Amplifier 23P (L) Blueprint (L)",
          "ArMatrix B-Amplifier 25P (L) Blueprint (L)",
          "ArMatrix B-Amplifier 28P (L) Blueprint (L)",
          "ArMatrix B-Amplifier 33P (L) Blueprint (L)",
          "ArMatrix B-Amplifier 37P (L) Blueprint (L)",
          "ArMatrix B-Amplifier 42P (L) Blueprint (L)",
          "ArMatrix B-Amplifier 45P (L) Blueprint (L)",
          "ArMatrix B-Amplifier 50P (L) Blueprint (L)",
          "ArMatrix B-Amplifier 55P (L) Blueprint (L)",
          "ArMatrix B-Amplifier 60P (L) Blueprint (L)",
          "ArMatrix B-Amplifier 65P (L) Blueprint (L)",
          "ArMatrix B-Amplifier 70P (L) Blueprint (L)",
          "ArMatrix B-Amplifier 75P (L) Blueprint (L)",
          "Combobulator Blueprint (L)",
          "Composite Plank Blueprint",
          "Terratech PH-2 (L) Blueprint (L)",
          "Terratech PH-3 (L) Blueprint (L)",
          "Terratech PH-3 Blueprint (L)",
          "Terratech PH-4 (L) Blueprint (L)",
          "Mann MPH Blueprint",
          "Mann MPH DLx Blueprint",
          "Mann MPH DLxE Blueprint",
          "Plasma Kyller Blueprint",
          "Shriek Basic Blueprint",
          "Shriek Covert Ops Blueprint",
          "Maddox 1 Blueprint",
          "Jashonich MP Blueprint",
          "Maddox 2 Blueprint",
          "Shriek Street Blueprint",
          "Jashonich AP Blueprint",
          "Mann MPH DLxEFi Blueprint",
          "Mann MPH DLxEGrd Blueprint",
          "Plasma Kyller Zwei Blueprint",
          "Shriek Combat Blueprint",
          "Shriek Back Alley Blueprint",
          "Jashonich FP Blueprint",
          "True Faith Blueprint",
          "Maddox 4 Blueprint",
          "Shriek Offensive Blueprint",
          "Karma Killer Blueprint",
          "Maddox 3 Blueprint",
          "Jester D-1 Blueprint",
          "Jester D-2 Blueprint",
          "Mar-Peeker Davidov Blueprint",
          "L/Murdand Groover Blueprint",
          "Jester D-3 Blueprint",
          "Mar-Spark Davidov Blueprint",
          "Lichter Carbine Blueprint",
          "Lichter Hunting Carbine Blueprint",
          "L/Murdand Styler Blueprint",
          "Mar-Lighter Davidov Blueprint",
          "Killian Sword Blueprint",
          "Killian Sword G2 Blueprint",
          "Killian Longsword Blueprint",
          "Killian Longsword G2 Blueprint",
          "Killian Longsword G3 Blueprint",
          "Killian Broadsword Blueprint",
          "Killian Broadsword G2 Blueprint",
          "ClericDagger 1A Blueprint",
          "ClericDagger 1B Blueprint",
          "ClericDagger 1C Blueprint",
          "ClericDagger 2A Blueprint",
          "ClericDagger 2B Blueprint",
          "ClericDagger 2C Blueprint",
          "ClericDagger 3A Blueprint",
          "ClericDagger 3B Blueprint",
          "ClericDagger 3C Blueprint",
          "Mir-1 EnergyGlove Blueprint",
          "Mir-2 EnergyGlove Blueprint",
          "Mux-1 EnergyGlove Blueprint",
          "Mux-2 EnergyGlove Blueprint",
          "Mez-1 EnergyGlove Blueprint",
          "Thor Blueprint",
          "Thor Hammer Blueprint",
          "Odin Blueprint",
          "Odin Eye Blueprint",
          "Ull Blueprint",
          "Ull Justice Blueprint",
          "Hel Blueprint",
          "Hel Death Blueprint",
          "Loki Blueprint",
          "Loki Traitor Blueprint",
          "Freyr Blueprint",
          "Freyr Sun Blueprint",
          "Heimdall Blueprint",
          "Heimdall Watcher Blueprint",
          "Fusil Arabesque Blueprint",
          "Fusil Charade Blueprint",
          "Ice-ir Blueprint",
          "Cold-ir Blueprint",
          "Sturmkarabiner SK-18 Blueprint",
          "Sturmkarabiner SK-19 Blueprint",
          "Holm Blueprint",
          "Holm Deus Blueprint",
          "Magma Beamer Blueprint",
          "Genuine Design Clone GDC-97 Blueprint",
          "Genuine Design Clone GDC-117 Blueprint",
          "Jimman Suite Blueprint",
          "Jimman Suite 2ed Blueprint",
          "Malc-US Design Blueprint",
          "Malc-US Design Rv Blueprint",
          "Malc-US Rv.2 Blueprint",
          "Opportunity Blueprint",
          "Rent Blueprint",
          "Katsuichi Honor Blueprint",
          "Katsuichi Valor Blueprint",
          "Katsuichi Pride Blueprint",
          "Katsuichi Determination Blueprint",
          "Force Mace Assail (L) Blueprint",
          "Force Mace Basher (L) Blueprint",
          "Force Mace Clobber (L) Blueprint",
          "Kriegerum G.1 Gauss Rifle (L) Blueprint",
          "Kriegerum G.2 Gauss Rifle (L) Blueprint",
          "Nano Katana (L) Blueprint",
          "Nano Dai-Katana (L) Blueprint",
          "Montgomery Anabolic (L) Blueprint (L)",
          "Montgomery Diabolic (L) Blueprint (L)",
          "Montgomery Anabolic (L) Blueprint",
          "Montgomery Diabolic (L) Blueprint",
          "Nano Katana (L) Blueprint (L)",
          "Nano Dai-Katana (L) Blueprint (L)",
          "Kriegerum G.1 Gauss Rifle (L) Blueprint (L)",
          "Kriegerum G.2 Gauss Rifle (L) Blueprint (L)",
          "Kriegerum G.2 Gauss Rifle, Customized (L) Blueprint (L)",
          "Montgomery Anabolic, Adapted (L) Blueprint (L)",
          "Force Mace Basher, Adapted (L) Blueprint (L)",
          "Dominax Original Viper (L) Blueprint",
          "Dominax Original Mamba (L) Blueprint",
          "Dominax Original Viper (L) Blueprint (L)",
          "Dominax Original Mamba (L) Blueprint (L)",
          "Force Mace Assail (L) Blueprint (L)",
          "Force Mace Basher (L) Blueprint (L)",
          "Force Mace Clobber (L) Blueprint (L)",
          "Breer M1a (L) Blueprint (L)",
          "Breer M2a (L) Blueprint (L)",
          "Breer P1a (L) Blueprint (L)",
          "Loughlin Smacker One (L) Blueprint (L)",
          "Loughlin Smacker Two (L) Blueprint (L)",
          "Loughlin Smacker Three (L) Blueprint (L)",
          "Loughlin Cutter One (L) Blueprint (L)",
          "Loughlin Cutter Two (L) Blueprint (L)",
          "Loughlin Scratcher One (L) Blueprint (L)",
          "Loughlin Scratcher Two (L) Blueprint (L)",
          "Loughlin Masher One (L) Blueprint (L)",
          "Loughlin Masher Two (L) Blueprint (L)",
          "Breer M1a (L) Blueprint",
          "Breer M2a (L) Blueprint",
          "Breer P2a (L) Blueprint (L)",
          "Breer P3a (L) Blueprint (L)",
          "Willard Heatray A (L) Blueprint (L)",
          "Willard Heatray B (L) Blueprint (L)",
          "Breer P1a (L) Blueprint",
          "Breer P2a (L) Blueprint",
          "Breer P3a (L) Blueprint",
          "Breer P4a (L) Blueprint (L)",
          "Breer P5a (L) Blueprint (L)",
          "Loughlin Cutter Three (L) Blueprint (L)",
          "Svempa S40 (L) Blueprint (L)",
          "Svempa S60 (L) Blueprint (L)",
          "Svempa T5 (L) Blueprint (L)",
          "Svempa T15 (L) Blueprint (L)",
          "Svempa X1 (L) Blueprint (L)",
          "Svempa XT (L) Blueprint (L)",
          "Prosecutor M15 (L) Blueprint (L)",
          "Prosecutor M35 (L) Blueprint (L)",
          "Prosecutor M45 (L) Blueprint (L)",
          "Svempa S40 (L) Blueprint",
          "Svempa S60 (L) Blueprint",
          "Breer P4a (L) Blueprint",
          "Breer P5a (L) Blueprint",
          "Breer M3a (L) Blueprint (L)",
          "Breer M3a (L) Blueprint",
          "Breer M4a (L) Blueprint (L)",
          "Breer M4a (L) Blueprint",
          "GeoTrek AL15 Taurus (L) Blueprint (L)",
          "GeoTrek LP120 Niloticus (L) Blueprint (L)",
          "GeoTrek H21 Scrof (L) Blueprint (L)",
          "GeoTrek H23 Crista (L) Blueprint (L)",
          "GeoTrek H41 Mina (L) Blueprint (L)",
          "GeoTrek H45 Ortso (L) Blueprint (L)",
          "Kesmek Slo (L) Blueprint (L)",
          "Kesmek Bik (L) Blueprint (L)",
          "Kesmek Vass (L) Blueprint (L)",
          "Kesmek Bett (L) Blueprint (L)",
          "Rutic Slo (L) Blueprint (L)",
          "Rutic Kil (L) Blueprint (L)",
          "Rutic Blix (L) Blueprint (L)",
          "Rutic Bett (L) Blueprint (L)",
          "Breer M1a Blueprint (L)",
          "Breer M2a Blueprint (L)",
          "Breer M3a Blueprint (L)",
          "Breer M4a Blueprint (L)",
          "Loughlin Scratcher One Blueprint (L)",
          "Loughlin Scratcher Two Blueprint (L)",
          "Loughlin Cutter One Blueprint (L)",
          "Loughlin Cutter Two Blueprint (L)",
          "Loughlin Cutter Three Blueprint (L)",
          "Breer P1a Blueprint (L)",
          "Breer P2a Blueprint (L)",
          "Breer P3a Blueprint (L)",
          "Willard Heatray A Blueprint (L)",
          "Willard Heatray B Blueprint (L)",
          "Breer P4a Blueprint (L)",
          "Breer P5a Blueprint (L)",
          "Svempa S40 Blueprint (L)",
          "Svempa S60 Blueprint (L)",
          "Svempa T5 Blueprint (L)",
          "Svempa T15 Blueprint (L)",
          "Svempa X1 Blueprint (L)",
          "Svempa XT Blueprint (L)",
          "Loughlin Smacker One Blueprint (L)",
          "Loughlin Smacker Two Blueprint (L)",
          "Loughlin Smacker Three Blueprint (L)",
          "Prosecutor M15 Blueprint (L)",
          "Prosecutor M35 Blueprint (L)",
          "Prosecutor M45 Blueprint (L)",
          "Montgomery Anabolic Blueprint (L)",
          "Montgomery Diabolic Blueprint (L)",
          "Montgomery Anabolic, Adapted Blueprint (L)",
          "Nano Katana Blueprint (L)",
          "Nano Dai-Katana Blueprint (L)",
          "Kriegerum G.1 Gauss Rifle Blueprint (L)",
          "Kriegerum G.2 Gauss Rifle Blueprint (L)",
          "Kriegerum G.2 Gauss Rifle, Customized Blueprint (L)",
          "Dominax Original Viper Blueprint (L)",
          "Dominax Original Mamba Blueprint (L)",
          "Force Mace Assail Blueprint (L)",
          "Force Mace Basher Blueprint (L)",
          "Force Mace Clobber Blueprint (L)",
          "Force Mace Basher, Adapted Blueprint (L)",
          "Loughlin Masher One Blueprint (L)",
          "Loughlin Masher Two Blueprint (L)",
          "GeoTrek AL15 Taurus Blueprint (L)",
          "GeoTrek LP120 Niloticus Blueprint (L)",
          "GeoTrek H21 Scrof Blueprint (L)",
          "GeoTrek H23 Crista Blueprint (L)",
          "GeoTrek H41 Mina Blueprint (L)",
          "GeoTrek H45 Ortso Blueprint (L)",
          "Kesmek Slo Blueprint (L)",
          "Kesmek Bik Blueprint (L)",
          "Kesmek Vass Blueprint (L)",
          "Kesmek Bett Blueprint (L)",
          "Rutic Slo Blueprint (L)",
          "Rutic Kil Blueprint (L)",
          "Rutic Blix Blueprint (L)",
          "Rutic Bett Blueprint (L)",
          "Eraktor Es 10 (L) Blueprint (L)",
          "Eraktor Es 20 (L) Blueprint (L)",
          "Eraktor Ekk 100 (L) Blueprint (L)",
          "Eraktor Ekk 200 (L) Blueprint (L)",
          "Eraktor Force (L) Blueprint (L)",
          "Eraktor Impact (L) Blueprint (L)",
          "DetPil Rv 50 (L) Blueprint (L)",
          "DetPil Rv 100 (L) Blueprint (L)",
          "DetPil V-Rex 1000 (L) Blueprint (L)",
          "DetPil V-Rex 2000 (L) Blueprint (L)",
          "DetPil Python (L) Blueprint (L)",
          "GeoTrek AL17 Auriga (L) Blueprint (L)",
          "GeoTrek AL21 Canis (L) Blueprint (L)",
          "GeoTrek LP470 Manis (L) Blueprint (L)",
          "GeoTrek LP175 Sphyra (L) Blueprint (L)",
          "GeoTrek H25 Mikus (L) Blueprint (L)",
          "GeoTrek H26 Elima (L) Blueprint (L)",
          "GeoTrek H27 Vilitus (L) Blueprint (L)",
          "GeoTrek H46 Menes (L) Blueprint (L)",
          "GeoTrek H49 Poros (L) Blueprint (L)",
          "Loughlin Scratcher One (L) Blueprint",
          "Loughlin Scratcher Two (L) Blueprint",
          "Loughlin Cutter One (L) Blueprint",
          "Loughlin Cutter Two (L) Blueprint",
          "Loughlin Cutter Three (L) Blueprint",
          "Willard Heatray A (L) Blueprint",
          "Willard Heatray B (L) Blueprint",
          "Svempa T5 (L) Blueprint",
          "Svempa T15 (L) Blueprint",
          "Svempa X1 (L) Blueprint",
          "Svempa XT (L) Blueprint",
          "Loughlin Smacker One (L) Blueprint",
          "Loughlin Smacker Two (L) Blueprint",
          "Loughlin Smacker Three (L) Blueprint",
          "Prosecutor M15 (L) Blueprint",
          "Prosecutor M35 (L) Blueprint",
          "Prosecutor M45 (L) Blueprint",
          "Montgomery Anabolic, Adapted (L) Blueprint",
          "Kriegerum G.2 Gauss Rifle, Customized (L) Blueprint",
          "Force Mace Basher, Adapted (L) Blueprint",
          "Loughlin Masher One (L) Blueprint",
          "Loughlin Masher Two (L) Blueprint",
          "GeoTrek AL15 Taurus (L) Blueprint",
          "GeoTrek AL17 Auriga (L) Blueprint",
          "GeoTrek AL21 Canis (L) Blueprint",
          "GeoTrek LP120 Niloticus (L) Blueprint",
          "GeoTrek LP470 Manis (L) Blueprint",
          "GeoTrek LP175 Sphyra (L) Blueprint",
          "GeoTrek H21 Scrof (L) Blueprint",
          "GeoTrek H23 Crista (L) Blueprint",
          "GeoTrek H25 Mikus (L) Blueprint",
          "GeoTrek H26 Elima (L) Blueprint",
          "GeoTrek H27 Vilitus (L) Blueprint",
          "GeoTrek H41 Mina (L) Blueprint",
          "GeoTrek H45 Ortso (L) Blueprint",
          "GeoTrek H46 Menes (L) Blueprint",
          "GeoTrek H49 Poros (L) Blueprint",
          "Kesmek Slo (L) Blueprint",
          "Kesmek Bik (L) Blueprint",
          "Kesmek Vass (L) Blueprint",
          "Kesmek Bett (L) Blueprint",
          "Rutic Slo (L) Blueprint",
          "Rutic Kil (L) Blueprint",
          "Rutic Blix (L) Blueprint",
          "Rutic Bett (L) Blueprint",
          "GeoTrek AL22 Lupus (L) Blueprint (L)",
          "GeoTrek AL24 Scorpius (L) Blueprint (L)",
          "GeoTrek LP485 Apis (L) Blueprint (L)",
          "GeoTrek H28 Hokipus (L) Blueprint (L)",
          "GeoTrek H40 Brody (L) Blueprint (L)",
          "Star Mercury Anti-Materiel Rifle, Prototype (L) Blueprint (L)",
          "Omegaton Sunstorm (L) Blueprint (L)",
          "Omegaton Caus Tik (L) Blueprint (L)",
          "Omegaton Jupiter (L) Blueprint (L)",
          "Omegaton Frostbite (L) Blueprint (L)",
          "Omegaton Full Spectrum Sword (L) Blueprint (L)",
          "Omegaton Flashfire (L) Blueprint (L)",
          "Omegaton Bur Ning (L) Blueprint (L)",
          "Omegaton Lighting Dagger (L) Blueprint (L)",
          "Omegaton Chillwind (L) Blueprint (L)",
          "Omegaton Kaleidoscopic Nightmare (L) Blueprint (L)",
          "GeoTrek AL26 Serpentis (L) Blueprint (L)",
          "GeoTrek AL29 Felis (L) Blueprint (L)",
          "GeoTrek LP510 Huo (L) Blueprint (L)",
          "GeoTrek LP525 Geke (L) Blueprint (L)",
          "GeoTrek LP540 Tau (L) Blueprint (L)",
          "GeoTrek H30 Illum (L) Blueprint (L)",
          "GeoTrek H33 Uti (L) Blueprint (L)",
          "GeoTrek H36 Saou (L) Blueprint (L)",
          "GeoTrek H1051 Kisf (L) Blueprint (L)",
          "GeoTrek H1071 Otk (L) Blueprint (L)",
          "Eraktor Maximus (L) Blueprint (L)",
          "Eraktor Abomination (L) Blueprint (L)",
          "DetPil Mamba (L) Blueprint (L)",
          "DetPil Boa (L) Blueprint (L)",
          "GeoTrek AL17 Auriga Blueprint (L)",
          "GeoTrek AL21 Canis Blueprint (L)",
          "GeoTrek AL22 Lupus Blueprint (L)",
          "GeoTrek AL24 Scorpius Blueprint (L)",
          "GeoTrek AL26 Serpentis Blueprint (L)",
          "GeoTrek AL29 Felis Blueprint (L)",
          "GeoTrek LP485 Apis Blueprint (L)",
          "GeoTrek LP510 Huo Blueprint (L)",
          "GeoTrek LP525 Geke Blueprint (L)",
          "GeoTrek LP540 Tau Blueprint (L)",
          "GeoTrek H28 Hokipus Blueprint (L)",
          "GeoTrek H30 Illum Blueprint (L)",
          "GeoTrek H33 Uti Blueprint (L)",
          "GeoTrek H36 Saou Blueprint (L)",
          "GeoTrek H40 Brody Blueprint (L)",
          "GeoTrek H1051 Kisf Blueprint (L)",
          "GeoTrek H1071 Otk Blueprint (L)",
          "Omegaton Sunstorm Blueprint (L)",
          "Omegaton Caus Tik Blueprint (L)",
          "Omegaton Jupiter Blueprint (L)",
          "Omegaton Frostbite Blueprint (L)",
          "Omegaton Full Spectrum Sword Blueprint (L)",
          "Omegaton Flashfire Blueprint (L)",
          "Omegaton Bur Ning Blueprint (L)",
          "Omegaton Lighting Dagger Blueprint (L)",
          "Omegaton Chillwind Blueprint (L)",
          "Omegaton Kaleidoscopic Nightmare Blueprint (L)",
          "GeoTrek AL22 Lupus (L) Blueprint",
          "GeoTrek AL24 Scorpius (L) Blueprint",
          "GeoTrek AL26 Serpentis (L) Blueprint",
          "GeoTrek AL29 Felis (L) Blueprint",
          "GeoTrek LP485 Apis (L) Blueprint",
          "GeoTrek LP510 Huo (L) Blueprint",
          "GeoTrek LP525 Geke (L) Blueprint",
          "GeoTrek LP540 Tau (L) Blueprint",
          "GeoTrek H28 Hokipus (L) Blueprint",
          "GeoTrek H30 Illum (L) Blueprint",
          "GeoTrek H33 Uti (L) Blueprint",
          "GeoTrek H36 Saou (L) Blueprint",
          "GeoTrek H40 Brody (L) Blueprint",
          "GeoTrek H1051 Kisf (L) Blueprint",
          "GeoTrek H1071 Otk (L) Blueprint",
          "Omegaton Sunstorm (L) Blueprint",
          "Omegaton Caus Tik (L) Blueprint",
          "Omegaton Jupiter (L) Blueprint",
          "Omegaton Frostbite (L) Blueprint",
          "Omegaton Full Spectrum Sword (L) Blueprint",
          "Omegaton Flashfire (L) Blueprint",
          "Omegaton Bur Ning (L) Blueprint",
          "Omegaton Lighting Dagger (L) Blueprint",
          "Omegaton Chillwind (L) Blueprint",
          "Omegaton Kaleidoscopic Nightmare (L) Blueprint",
          "Genesis Power Claw Mk. 1 (L) Blueprint (L)",
          "Genesis Power Claw Mk. 2 (L) Blueprint (L)",
          "Genesis Power Claw Mk. 3 (L) Blueprint (L)",
          "Genesis Power Claw Mk. 4 (L) Blueprint (L)",
          "Genesis Power Claw Mk. 5 (L) Blueprint (L)",
          "Genesis Power Claw Mk. 6 (L) Blueprint (L)",
          "Prototype Rocket Launcher XXX (L) Blueprint (L)",
          "Loughlin Masher One, SGA Edition (L) Blueprint (L)",
          "Omegaton Flashfire, SGA Edition (L) Blueprint (L)",
          "GeoTrek LP485 Apis, SGA Edition (L) Blueprint (L)",
          "GeoTrek LP510 Huo, SGA Edition (L) Blueprint (L)",
          "Nano Dai-Katana, SGA Edition Blueprint (L)",
          "Katsuichi Determination, SGA Edition Blueprint (L)",
          "DetPil V-Rex 2000, SGA Edition Blueprint (L)",
          "MRL AV30 (L) Blueprint (L)",
          "MRL AV55 (L) Blueprint (L)",
          "MRL AV90 (L) Blueprint (L)",
          "Ozutsu Ichi (L) Blueprint (L)",
          "Ozutsu Shi (L) Blueprint (L)",
          "Ozutsu Kyuu (L) Blueprint (L)",
          "Porcupine MAP-13 (L) Blueprint (L)",
          "Porcupine MAP-23 (L) Blueprint (L)",
          "Porcupine MAP-31 (L) Blueprint (L)",
          "Cadet Jacket (C) Blueprint",
          "Cadet Pants (C) Blueprint",
          "Private Jacket (C) Blueprint",
          "Private Pants (C) Blueprint",
          "Navy Officer Jacket (C) Blueprint",
          "Foxy High Stiletto Boots (F,C) Blueprint",
          "Basic Pattern Pants (C) Blueprint",
          "Basic Pattern Shirt (C) Blueprint",
          "Urban Pattern Pants (C) Blueprint",
          "Urban Pattern Shirt (C) Blueprint",
          "Street Pattern Shirt (C) Blueprint",
          "Street Pattern Pants (C) Blueprint",
          "Flame Pattern Pants (C) Blueprint",
          "Flame Pattern Shirt (C) Blueprint",
          "Work Pattern Shirt (C) Blueprint",
          "Work Pattern Pants (C) Blueprint",
          "Luna Pattern Pants (C) Blueprint",
          "Luna Pattern Shirt (C) Blueprint",
          "Multi Pattern Shirt (C) Blueprint",
          "Multi Pattern Pants (C) Blueprint",
          "Nifty Pattern Pants (C) Blueprint",
          "Nifty Pattern Shirt (C) Blueprint",
          "Seduce Miniskirt (F,C) Blueprint",
          "Direct Miniskirt (F,C) Blueprint",
          "Master Coat (C) Blueprint",
          "Cognac Coat (C) Blueprint",
          "Dominator Coat (C) Blueprint",
          "Radar Jacket (C) Blueprint",
          "Paris Jacket (C) Blueprint",
          "Berlin Jacket (C) Blueprint",
          "Mannell Shoes (C) Blueprint",
          "Dino Shoes (C) Blueprint",
          "Catre Shoes (C) Blueprint",
          "Reilly Boots (C) Blueprint",
          "Fresher Boots (C) Blueprint",
          "Mallic Boots (C) Blueprint",
          "Linestrip Shades (C) Blueprint",
          "Bono Shades (C) Blueprint",
          "Racer Shades (C) Blueprint",
          "Rancher Hat (C) Blueprint",
          "Sun Cap (C) Blueprint",
          "Techno Pants (C) Blueprint",
          "Rage Pants (C) Blueprint",
          "Zone Shirt (C) Blueprint",
          "Techno Shirt (C) Blueprint",
          "Zone Pants (C) Blueprint",
          "Rage Shirt (C) Blueprint",
          "Rexely Mesh Tanktop (C) Blueprint",
          "Hobb Bomberjacket (C) Blueprint",
          "Trix Stiletto Heels (F,C) Blueprint",
          "Enigma Bra (F,C) Blueprint",
          "Lodod Tanktop (C) Blueprint",
          "Pub Bowler Hat (C) Blueprint",
          "Havok Thong (F,C) Blueprint",
          "Rex Top Hat (C) Blueprint",
          "Tiger Stockings (F,C) Blueprint",
          "Queen Stiletto Boots (F,C) Blueprint",
          "Feodora (C) Blueprint",
          "Gem Bustier (F,C) Blueprint",
          "Leaf Beret (C) Blueprint",
          "Chili Sombrero (C) Blueprint",
          "Bustier (F,C) Blueprint",
          "Beach Shorts (C) Blueprint",
          "Sunset Shorts (C) Blueprint",
          "Flash Pants (C) Blueprint",
          "Flash Shirt (C) Blueprint",
          "Stripe Pants (C) Blueprint",
          "Holestripe Shirt (C) Blueprint",
          "Spotty Pants (C) Blueprint",
          "Musique Pants (C) Blueprint",
          "Flower Boheme Pants (C) Blueprint",
          "Flower Boheme Shirt (C) Blueprint",
          "Squared Pants (C) Blueprint",
          "Febe Evening Gown (F,C) Blueprint",
          "Tuxedo (M,C) Blueprint",
          "Nicole Ladies Handbag (C) Blueprint (L)",
          "Nicole Ladies Handbag (C) Blueprint",
          "Skam Ladies Handbag (C) Blueprint (L)",
          "Ninja Hood Jacket Stripes (C) Blueprint (L)",
          "Ninja High Jacket Stripes (C) Blueprint (L)",
          "Cold Fabric Blueprint (L)",
          "Cold Fabric Blueprint",
          "Ultra Cold Fabric Blueprint (L)",
          "Long Bristol Curtain Blueprint (L)",
          "Medium Bristol Curtain Blueprint (L)",
          "Short Bristol Curtain Blueprint (L)",
          "Long Tied Bristol Curtain Blueprint (L)",
          "Medium Tied Bristol Curtain Blueprint (L)",
          "Short Tied Bristol Curtain Blueprint (L)",
          "Medium Bristol Valance Blueprint (L)",
          "Short Bristol Valance Blueprint (L)",
          "Long Harlequin Curtain Blueprint (L)",
          "Medium Harlequin Curtain Blueprint (L)",
          "Short Harlequin Curtain Blueprint (L)",
          "Long Tied Harlequin Curtain Blueprint (L)",
          "Medium Tied Harlequin Curtain Blueprint (L)",
          "Short Tied Harlequin Curtain Blueprint (L)",
          "Medium Harlequin Valance Blueprint (L)",
          "Short Harlequin Valance Blueprint (L)",
          "Long Abbey Curtain Blueprint (L)",
          "Medium Abbey Curtain Blueprint (L)",
          "Short Abbey Curtain Blueprint (L)",
          "Long Tied Abbey Curtain Blueprint (L)",
          "Medium Tied Abbey Curtain Blueprint (L)",
          "Short Tied Abbey Curtain Blueprint (L)",
          "Medium Abbey Valance Blueprint (L)",
          "Short Abbey Valance Blueprint (L)",
          "Long Bailey Curtain Blueprint (L)",
          "Medium Bailey Curtain Blueprint (L)",
          "Short Bailey Curtain Blueprint (L)",
          "Long Tied Bailey Curtain Blueprint (L)",
          "Medium Tied Bailey Curtain Blueprint (L)",
          "Short Tied Bailey Curtain Blueprint (L)",
          "Medium Bailey Valance Blueprint (L)",
          "Short Bailey Valance Blueprint (L)",
          "Long Katu Curtain (C) Blueprint (L)",
          "Long Polka Curtain (C) Blueprint (L)",
          "Long Insignia Curtain (C) Blueprint (L)",
          "Long Lina Curtain (C) Blueprint (L)",
          "Long Royal Katu Curtain (C) Blueprint (L)",
          "Medium Katu Curtain (C) Blueprint (L)",
          "Medium Polka Curtain (C) Blueprint (L)",
          "Medium Insignia Curtain (C) Blueprint (L)",
          "Medium Lina Curtain (C) Blueprint (L)",
          "Medium Royal Katu Curtain (C) Blueprint (L)",
          "Short Katu Curtain (C) Blueprint (L)",
          "Short Polka Curtain (C) Blueprint (L)",
          "Short Insignia Curtain (C) Blueprint (L)",
          "Short Lina Curtain (C) Blueprint (L)",
          "Short Royal Katu Curtain (C) Blueprint (L)",
          "Long Tied Katu Curtain (C) Blueprint (L)",
          "Long Tied Polka Curtain (C) Blueprint (L)",
          "Long Tied Insignia Curtain (C) Blueprint (L)",
          "Long Tied Lina Curtain (C) Blueprint (L)",
          "Long Tied Royal Katu Curtain (C) Blueprint (L)",
          "Medium Tied Katu Curtain (C) Blueprint (L)",
          "Medium Tied Polka Curtain (C) Blueprint (L)",
          "Medium Tied Insignia Curtain (C) Blueprint (L)",
          "Medium Tied Lina Curtain (C) Blueprint (L)",
          "Medium Tied Royal Katu Curtain (C) Blueprint (L)",
          "Short Tied Katu Curtain (C) Blueprint (L)",
          "Short Tied Polka Curtain (C) Blueprint (L)",
          "Short Tied Insignia Curtain (C) Blueprint (L)",
          "Short Tied Lina Curtain (C) Blueprint (L)",
          "Short Tied Royal Katu Curtain (C) Blueprint (L)",
          "Medium Katu Valance (C) Blueprint (L)",
          "Medium Polka Valance (C) Blueprint (L)",
          "Medium Insignia Valance (C) Blueprint (L)",
          "Medium Lina Valance (C) Blueprint (L)",
          "Medium Royal Katu Valance (C) Blueprint (L)",
          "Short Katu Valance (C) Blueprint (L)",
          "Short Polka Valance (C) Blueprint (L)",
          "Short Insignia Valance (C) Blueprint (L)",
          "Short Lina Valance (C) Blueprint (L)",
          "Short Royal Katu Valance (C) Blueprint (L)",
          "Storm Jeans Blueprint (L)",
          "Storm Kolor Jeans (C) Blueprint (L)",
          "Omegaton Chasers (C) Blueprint (L)",
          "Omegaton Sports (C) Blueprint (L)",
          "Omegaton Pops Blueprint (L)",
          "Omegaton Desert Walkers Blueprint (L)",
          "Omegaton Arctic Walkers Blueprint (L)",
          "Omegaton Jungle Walkers Blueprint (L)",
          "Droplet Skirt (F,C) Blueprint (L)",
          "Leather Duster Coat (M) Blueprint (L)",
          "Fluffens Golf Pants (C) Blueprint (L)",
          "Dominator Coat (C) Blueprint (L)",
          "Racer Shades (C) Blueprint (L)",
          "Lodod Tanktop (C) Blueprint (L)",
          "McTiger Golf Pants (C) Blueprint (L)",
          "Stum Shirt (C) Blueprint (L)",
          "Cadet Cowboy Boots (C) Blueprint (L)",
          "Navy Officer Pants (C) Blueprint (L)",
          "Desert Trenchers (M) Blueprint (L)",
          "Jungle Trenchers (M) Blueprint (L)",
          "Arctic Trenchers (M) Blueprint (L)",
          "Makeup Mask, Small (L) Blueprint (L)",
          "Makeup Mask, Medium (L) Blueprint (L)",
          "Makeup Mask, Large (L) Blueprint (L)",
          "Mittens (C) Blueprint (L)",
          "Striped Sport Shirt (C) Blueprint (L)",
          "Travellers Sport Shirt (C) Blueprint (L)",
          "Angel Micro Skirt (F,C) Blueprint (L)",
          "Eden Micro Skirt (F,C) Blueprint (L)",
          "Large Animal Carpet (C) Blueprint (L)",
          "Large Striped Carpet (C) Blueprint (L)",
          "Striped Carpet (C) Blueprint (L)",
          "Essi Evening Gown (F,C) Blueprint (L)",
          "1 Over The Knee Socks (F,C) Blueprint (L)",
          "Striped Over The Knee Socks (F,C) Blueprint (L)",
          "Striped 1 Over The Knee Socks (F,C) Blueprint (L)",
          "Over The Knee Socks (F,C) Blueprint (L)",
          "Short Pleated Skirt (F,C) Blueprint (L)",
          "Evelyn Cocktail Dress (F,C) Blueprint (L)",
          "Ellen Evening Gown (F,C) Blueprint (L)",
          "Spectacular Spectacles (C) Blueprint (L)",
          "Pilot Goggles Blueprint (L)",
          "Welding Goggles Blueprint (L)",
          "Towel (C) Blueprint (L)",
          "Theater Mask (C) Blueprint (L)",
          "Hero Mask (C) Blueprint (L)",
          "Mad Clown Mask (M) Blueprint (L)",
          "Tight Shirt (F,C) Blueprint (L)",
          "Tight Pants (F,C) Blueprint (L)",
          "Berserker Arm Guards Blueprint",
          "Berserker Face Guard Blueprint",
          "Berserker Gloves Blueprint",
          "Berserker Harness Blueprint",
          "Berserker Shin Guards Blueprint",
          "Berserker Thigh Guards Blueprint",
          "BodyGuard Arm Guards Blueprint",
          "Dragon Arm Guards Blueprint",
          "Dragon Face Guard Blueprint",
          "Dragon Gloves Blueprint",
          "Dragon Harness Blueprint",
          "Dragon Shin Guards Blueprint",
          "Dragon Thigh Guards Blueprint",
          "Expedition Arm Guards Blueprint",
          "BodyGuard Face Guard Blueprint",
          "Expedition Gloves Blueprint",
          "Expedition Harness Blueprint",
          "Expedition Helmet Blueprint",
          "Expedition Shin Guards Blueprint",
          "BodyGuard Gloves Blueprint",
          "Expedition Thigh Guards Blueprint",
          "Explorer Arm Guards Blueprint",
          "Explorer Face Guard Blueprint",
          "BodyGuard Harness Blueprint",
          "Explorer Gloves Blueprint",
          "Explorer Harness Blueprint",
          "Explorer Shin Guards Blueprint",
          "Explorer Thigh Guards Blueprint",
          "Renegade Arm Guards Blueprint",
          "BodyGuard Shin Guards Blueprint",
          "Renegade Face Guard Blueprint",
          "Renegade Gloves Blueprint",
          "Renegade Harness Blueprint",
          "BodyGuard Thigh Guards Blueprint",
          "Renegade Shin Guards Blueprint",
          "Renegade Thigh Guards Blueprint",
          "Samurai Arm Guards Blueprint",
          "Samurai Face Guard Blueprint",
          "Samurai Gloves Blueprint",
          "Samurai Harness Blueprint",
          "Samurai Shin Guards Blueprint",
          "Samurai Thigh Guards Blueprint",
          "Guardian Arm Guards Blueprint",
          "Trooper Arm Guards Blueprint",
          "Guardian Face Guard Blueprint",
          "Trooper Gloves Blueprint",
          "Trooper Harness Blueprint",
          "Trooper Helmet Blueprint",
          "Trooper Shin Guards Blueprint",
          "Trooper Thigh Guards Blueprint",
          "Guardian Gloves Blueprint",
          "Valiant Arm Guards Blueprint",
          "Guardian Harness Blueprint",
          "Guardian Shin Guards Blueprint",
          "Valiant Face Guard Blueprint",
          "Valiant Gloves Blueprint",
          "Valiant Harness Blueprint",
          "Valiant Shin Guards Blueprint",
          "Valiant Thigh Guards Blueprint",
          "Guardian Thigh Guards Blueprint",
          "Vampire Arm Guards Blueprint",
          "Vampire Face Guard Blueprint",
          "Vampire Gloves Blueprint",
          "Vampire Harness Blueprint",
          "Vampire Shin Guards Blueprint",
          "Pioneer Arm Guards Blueprint",
          "Vampire Thigh Guards Blueprint",
          "Vindicator Arm Guards Blueprint",
          "Vindicator Face Guard Blueprint",
          "Pioneer Face Guard Blueprint",
          "Vindicator Gloves Blueprint",
          "Vindicator Harness Blueprint",
          "Vindicator Shin Guards Blueprint",
          "Pioneer Gloves Blueprint",
          "Vindicator Thigh Guards Blueprint",
          "Warrior Thigh Guards Blueprint",
          "Pioneer Harness Blueprint",
          "Warrior Shin Guards Blueprint",
          "Warrior Arm Guards Blueprint",
          "Pioneer Shin Guards Blueprint",
          "Pioneer Thigh Guards Blueprint",
          "Warrior Face Guard Blueprint",
          "Warrior Gloves Blueprint",
          "Warrior Harness Blueprint",
          "Settler Arm Guards Blueprint",
          "Settler Face Guard Blueprint",
          "Settler Gloves Blueprint",
          "Settler Harness Blueprint",
          "Settler Shin Guards Blueprint",
          "Settler Thigh Guards Blueprint",
          "Zombie Arm Guards Blueprint",
          "Zombie Face Guard Blueprint",
          "Zombie Gloves Blueprint",
          "Zombie Harness Blueprint",
          "Zombie Shin Guards Blueprint",
          "Zombie Thigh Guards Blueprint",
          "Ghost Arm Guards Blueprint",
          "Ghost Face Guard Blueprint",
          "Ghost Gloves Blueprint",
          "Ghost Harness Blueprint",
          "Ghost Shin Guards Blueprint",
          "Ghost Thigh Guards Blueprint",
          "Phantom Arm Guards Blueprint",
          "Phantom Face Guard Blueprint",
          "Phantom Gloves Blueprint",
          "Phantom Harness Blueprint",
          "Phantom Shin Guards Blueprint",
          "Phantom Thigh Guards Blueprint",
          "Ghoul Arm Guards Blueprint",
          "Ghoul Face Guard Blueprint",
          "Ghoul Gloves Blueprint",
          "Ghoul Harness Blueprint",
          "Ghoul Shin Guards Blueprint",
          "Ghoul Thigh Guards Blueprint",
          "Spectre Arm Guards (L) Blueprint",
          "Spectre Face Guard (L) Blueprint",
          "Spectre Gloves (L) Blueprint",
          "Spectre Harness (L) Blueprint",
          "Spectre Shin Guards (L) Blueprint",
          "Spectre Thigh Guards (L) Blueprint",
          "Lich Arm Guards (L) Blueprint",
          "Lich Gloves (L) Blueprint",
          "Lich Harness (L) Blueprint",
          "Lich Helmet (L) Blueprint",
          "Lich Shin Guards (L) Blueprint",
          "Lich Thigh Guards (L) Blueprint",
          "Necromancer Arm Guards (L) Blueprint",
          "Necromancer Gloves (L) Blueprint",
          "Necromancer Harness (L) Blueprint",
          "Necromancer Helmet (L) Blueprint",
          "Necromancer Shin Guards (L) Blueprint",
          "Necromancer Thigh Guards (L) Blueprint",
          "Reaper Arm Guards (L) Blueprint",
          "Reaper Gloves (L) Blueprint",
          "Reaper Harness (L) Blueprint",
          "Reaper Helmet (L) Blueprint",
          "Reaper Shin Guards (L) Blueprint",
          "Reaper Thigh Guards (L) Blueprint",
          "Rascal Arm Guards Blueprint",
          "Rascal Face Guard Blueprint",
          "Rascal Gloves Blueprint",
          "Rascal Harness Blueprint",
          "Rascal Shin Guards Blueprint",
          "Rascal Thigh Guards Blueprint",
          "Armor Plating Mk. 1A Blueprint",
          "Armor Plating Mk. 1B Blueprint",
          "Armor Plating Mk. 1C Blueprint",
          "Armor Plating Mk. 2A Blueprint",
          "Armor Plating Mk. 2B Blueprint",
          "Armor Plating Mk. 2C Blueprint",
          "Armor Plating Mk. 3A Blueprint",
          "Armor Plating Mk. 3B Blueprint",
          "Armor Plating Mk. 4A Blueprint",
          "Armor Plating Mk. 4B Blueprint",
          "Armor Plating Mk. 4C Blueprint",
          "Armor Plating Mk. 5A Blueprint",
          "Armor Plating Mk. 5B Blueprint",
          "Armor Plating Mk. 5C Blueprint",
          "Armor Plating Mk. 5D Blueprint",
          "Armor Plating Mk. 6A Blueprint",
          "Armor Plating Mk. 6B Blueprint",
          "Armor Plating Mk. 1D (L) Blueprint",
          "Armor Plating Mk. 2D (L) Blueprint",
          "Armor Plating Mk. 4D (L) Blueprint",
          "Armor Plating Mk. 6C (L) Blueprint",
          "Armor Plating Mk. 7A (L) Blueprint",
          "Armor Plating Mk. 8A (L) Blueprint",
          "Predator Arm Guards (L) Blueprint (L)",
          "Predator Shin Guards (L) Blueprint (L)",
          "Predator Helmet (L) Blueprint (L)",
          "Predator Thigh Guards (L) Blueprint (L)",
          "Predator Harness (L) Blueprint (L)",
          "Orca Arm Guards (L) Blueprint (L)",
          "Orca Shin Guards (L) Blueprint (L)",
          "Orca Helmet (L) Blueprint (L)",
          "Orca Thigh Guards (L) Blueprint (L)",
          "Orca Harness (L) Blueprint (L)",
          "Sema Arm Guards (L) Blueprint (L)",
          "Sema Shin Guards (L) Blueprint (L)",
          "Sema Helmet (L) Blueprint (L)",
          "Sema Thigh Guards (L) Blueprint (L)",
          "Sema Harness (L) Blueprint (L)",
          "Luna Arm Guards (L) Blueprint (L)",
          "Luna Shin Guards (L) Blueprint (L)",
          "Luna Helmet (L) Blueprint (L)",
          "Luna Thigh Guards (L) Blueprint (L)",
          "Luna Harness (L) Blueprint (L)",
          "Serum Arm Guards (L) Blueprint (L)",
          "Serum Shin Guards (L) Blueprint (L)",
          "Serum Helmet (L) Blueprint (L)",
          "Serum Thigh Guards (L) Blueprint (L)",
          "Serum Harness (L) Blueprint (L)",
          "Solir Arm Guards (L) Blueprint (L)",
          "Solir Shin Guards (L) Blueprint (L)",
          "Solir Helmet (L) Blueprint (L)",
          "Solir Thigh Guards (L) Blueprint (L)",
          "Solir Harness (L) Blueprint (L)",
          "Renegade Face Guard (L) Blueprint",
          "Pioneer Face Guard (L) Blueprint",
          "BodyGuard Face Guard (L) Blueprint",
          "BodyGuard Gloves (L) Blueprint",
          "Pioneer Gloves (L) Blueprint",
          "Renegade Gloves (L) Blueprint",
          "BodyGuard Arm Guards (L) Blueprint",
          "Pioneer Arm Guards (L) Blueprint",
          "Renegade Arm Guards (L) Blueprint",
          "BodyGuard Shin Guards (L) Blueprint",
          "Pioneer Shin Guards (L) Blueprint",
          "Renegade Shin Guards (L) Blueprint",
          "BodyGuard Thigh Guards (L) Blueprint",
          "Pioneer Thigh Guards (L) Blueprint",
          "Renegade Thigh Guards (L) Blueprint",
          "BodyGuard Harness (L) Blueprint",
          "Pioneer Harness (L) Blueprint",
          "Renegade Harness (L) Blueprint",
          "Rascal Arm Guards (L) Blueprint",
          "Rascal Face Guard (L) Blueprint",
          "Rascal Gloves (L) Blueprint",
          "Rascal Harness (L) Blueprint",
          "Rascal Shin Guards (L) Blueprint",
          "Rascal Thigh Guards (L) Blueprint",
          "Zombie Arm Guards (L) Blueprint",
          "Zombie Face Guard (L) Blueprint",
          "Zombie Gloves (L) Blueprint",
          "Zombie Harness (L) Blueprint",
          "Zombie Shin Guards (L) Blueprint",
          "Zombie Thigh Guards (L) Blueprint",
          "Ghost Arm Guards (L) Blueprint",
          "Ghost Face Guard (L) Blueprint",
          "Ghost Gloves (L) Blueprint",
          "Ghost Harness (L) Blueprint",
          "Ghost Shin Guards (L) Blueprint",
          "Ghost Thigh Guards (L) Blueprint",
          "Predator Gloves (L) Blueprint (L)",
          "Orca Gloves (L) Blueprint (L)",
          "Sema Gloves (L) Blueprint (L)",
          "Luna Gloves (L) Blueprint (L)",
          "Serum Gloves (L) Blueprint (L)",
          "Solir Gloves (L) Blueprint (L)",
          "Infiltrator Arm Guards (L) Blueprint (L)",
          "Infiltrator Helmet (L) Blueprint (L)",
          "Infiltrator Gloves (L) Blueprint (L)",
          "Infiltrator Harness (L) Blueprint (L)",
          "Infiltrator Shin Guards (L) Blueprint (L)",
          "Infiltrator Thigh Guards (L) Blueprint (L)",
          "Berserker Foot Guards Blueprint (L)",
          "Dragon Foot Guards Blueprint (L)",
          "Expedition Foot Guards Blueprint (L)",
          "BodyGuard Foot Guards Blueprint (L)",
          "Explorer Foot Guards Blueprint (L)",
          "Renegade Foot Guards Blueprint (L)",
          "Samurai Foot Guards Blueprint (L)",
          "Trooper Foot Guards Blueprint (L)",
          "Guardian Foot Guards Blueprint (L)",
          "Valiant Foot Guards Blueprint (L)",
          "Vampire Foot Guards Blueprint (L)",
          "Vindicator Foot Guards Blueprint (L)",
          "Pioneer Foot Guards Blueprint (L)",
          "Warrior Foot Guards Blueprint (L)",
          "Settler Foot Guards Blueprint (L)",
          "Zombie Foot Guards Blueprint (L)",
          "Ghost Foot Guards Blueprint (L)",
          "Phantom Foot Guards Blueprint (L)",
          "Ghoul Foot Guards Blueprint (L)",
          "Spectre Foot Guards (L) Blueprint",
          "Lich Foot Guards (L) Blueprint",
          "Necromancer Foot Guards (L) Blueprint",
          "Rascal Foot Guards Blueprint (L)",
          "BodyGuard Foot Guards (L) Blueprint",
          "Pioneer Foot Guards (L) Blueprint",
          "Renegade Foot Guards (L) Blueprint",
          "Rascal Foot Guards (L) Blueprint",
          "Zombie Foot Guards (L) Blueprint",
          "Ghost Foot Guards (L) Blueprint",
          "Predator Foot Guards (L) Blueprint (L)",
          "Orca Foot Guards (L) Blueprint (L)",
          "Sema Foot Guards (L) Blueprint (L)",
          "Luna Foot Guards (L) Blueprint (L)",
          "Serum Foot Guards (L) Blueprint (L)",
          "Solir Foot Guards (L) Blueprint (L)",
          "Infiltrator Foot Guards (L) Blueprint (L)",
          "Reaper Foot Guards (L) Blueprint",
          "Reaper Arm Guards (L) Blueprint (L)",
          "Reaper Gloves (L) Blueprint (L)",
          "Reaper Harness (L) Blueprint (L)",
          "Reaper Helmet (L) Blueprint (L)",
          "Reaper Shin Guards (L) Blueprint (L)",
          "Reaper Thigh Guards (L) Blueprint (L)",
          "Reaper Foot Guards (L) Blueprint (L)",
          "Lich Arm Guards (L) Blueprint (L)",
          "Lich Gloves (L) Blueprint (L)",
          "Lich Harness (L) Blueprint (L)",
          "Lich Helmet (L) Blueprint (L)",
          "Lich Shin Guards (L) Blueprint (L)",
          "Lich Thigh Guards (L) Blueprint (L)",
          "Lich Foot Guards (L) Blueprint (L)",
          "Necromancer Arm Guards (L) Blueprint (L)",
          "Necromancer Gloves (L) Blueprint (L)",
          "Necromancer Harness (L) Blueprint (L)",
          "Necromancer Helmet (L) Blueprint (L)",
          "Necromancer Shin Guards (L) Blueprint (L)",
          "Necromancer Thigh Guards (L) Blueprint (L)",
          "Necromancer Foot Guards (L) Blueprint (L)",
          "Spectre Arm Guards (L) Blueprint (L)",
          "Spectre Face Guard (L) Blueprint (L)",
          "Spectre Gloves (L) Blueprint (L)",
          "Spectre Harness (L) Blueprint (L)",
          "Spectre Shin Guards (L) Blueprint (L)",
          "Spectre Thigh Guards (L) Blueprint (L)",
          "Spectre Foot Guards (L) Blueprint (L)",
          "Phantom Arm Guards (L) Blueprint (L)",
          "Phantom Face Guard (L) Blueprint (L)",
          "Phantom Gloves (L) Blueprint (L)",
          "Phantom Harness (L) Blueprint (L)",
          "Phantom Shin Guards (L) Blueprint (L)",
          "Phantom Thigh Guards (L) Blueprint (L)",
          "Phantom Foot Guards (L) Blueprint (L)",
          "Ghoul Arm Guards (L) Blueprint (L)",
          "Ghoul Face Guard (L) Blueprint (L)",
          "Ghoul Gloves (L) Blueprint (L)",
          "Ghoul Harness (L) Blueprint (L)",
          "Ghoul Shin Guards (L) Blueprint (L)",
          "Ghoul Thigh Guards (L) Blueprint (L)",
          "Ghoul Foot Guards (L) Blueprint (L)",
          "Armor Plating Mk. 2E (L) Blueprint (L)",
          "Armor Plating Mk. 3E (L) Blueprint (L)",
          "Armor Plating Mk. 4E (L) Blueprint (L)",
          "Armor Plating Mk. 5E (L) Blueprint (L)",
          "eMINE PG/H (L) Blueprint (L)",
          "eMINE PG/T (L) Blueprint (L)",
          "eMINE PG/HG (L) Blueprint (L)",
          "eMINE PG/A (L) Blueprint (L)",
          "eMINE PG/FG (L) Blueprint (L)",
          "eMINE PG/SG (L) Blueprint (L)",
          "eMINE PG/G (L) Blueprint (L)",
          "Predator Arm Guards, SGA Edition Blueprint (L)",
          "Predator Shin Guards, SGA Edition Blueprint (L)",
          "Predator helmet, SGA Edition Blueprint (L)",
          "Predator Thigh Guards, SGA Edition Blueprint (L)",
          "Predator Harness, SGA Edition Blueprint (L)",
          "Predator Gloves, SGA Edition Blueprint (L)",
          "Predator Foot Guards, SGA Edition Blueprint (L)",
          "Advanced Feedback Panel Blueprint",
          "Advanced Matrix Blueprint",
          "Advanced Modulator Blueprint",
          "Advanced Processor Blueprint",
          "Advanced Security Module Blueprint",
          "Advanced VisioMem Blueprint",
          "Basic Auxiliary Socket Blueprint",
          "Basic Power System Blueprint",
          "Basic Processor Blueprint",
          "Basic Relay Blueprint",
          "Basic Sensor Blueprint",
          "Basic Wires Blueprint",
          "Electropositive Capacitor Blueprint",
          "Electropositive Communication Blueprint",
          "Electropositive Connector Blueprint",
          "Electropositive Modulator Blueprint",
          "Electropositive Processor Blueprint",
          "Electropositive Security Module Blueprint",
          "Standard Intelligence Module Blueprint",
          "Standard Matrix Blueprint",
          "Standard VisioMem Blueprint",
          "Standard Feedback Panel Blueprint",
          "Standard Holo Module Blueprint",
          "Standard Transparency Layer Blueprint",
          "Triphased Auxiliary Socket Blueprint",
          "Triphased Holo Module Blueprint",
          "Triphased Intelligence Module Blueprint",
          "Triphased Power Systems Blueprint",
          "Triphased Transmitter Blueprint",
          "Triphased Wires Blueprint",
          "Galaxy S1 Ion Conductors Blueprint",
          "Galaxy S2 Ion Conductors Blueprint",
          "Galaxy S3 Ion Conductors Blueprint",
          "Solar 6V Gel Batteries Blueprint",
          "Solar 8V Gel Batteries Blueprint",
          "Solar 12V Gel Batteries Blueprint",
          "Galaxy 6V Gel Batteries Blueprint",
          "Galaxy 8V Gel Batteries Blueprint",
          "Galaxy 12V Gel Batteries Blueprint",
          "Simple 1 Conductors Blueprint",
          "Simple 2 Conductors Blueprint",
          "Simple 3 Conductors Blueprint",
          "Simple 4 Conductors Blueprint",
          "Solar 14V Gel Batteries Blueprint",
          "Solar 16V Gel Batteries Blueprint",
          "Galaxy 14V Gel Batteries Blueprint",
          "Basic Vehicle Battery Blueprint (L)",
          "Basic Coil Blueprint",
          "Basic Engine Blueprint",
          "Basic Filters Blueprint",
          "Basic Pump Blueprint",
          "Basic Servo Blueprint",
          "Basic Structure Blueprint",
          "Durable Coil Blueprint",
          "Durable Damper Blueprint",
          "Durable Structure Blueprint",
          "Durable Compressor Blueprint",
          "Durable Hood Blueprint",
          "Durable Motor Blueprint",
          "Heavy Duty Core Blueprint",
          "Heavy Duty Coupling Blueprint",
          "Heavy Duty Engine Blueprint",
          "Heavy Duty Filters Blueprint",
          "Heavy Duty Joints Blueprint",
          "Heavy-Duty Seals Blueprint",
          "High Performance Filters Blueprint",
          "High Performance Pump Blueprint",
          "High Performance Vents Blueprint",
          "High Performance Compressor Blueprint",
          "High Performance Coupling Blueprint",
          "High Performance Engine Blueprint",
          "Standard Compressor Blueprint",
          "Standard Core Blueprint",
          "Standard Damper Blueprint",
          "Standard Locks Blueprint",
          "Standard Valve Blueprint",
          "Standard Vents Blueprint",
          "GEC Spur Gears 1K Blueprint",
          "GEC Spur Gears 2K Blueprint",
          "GEC Coil Springs 1M Blueprint",
          "GEC Coil Springs 2M Blueprint",
          "Simple 1 Plastic Springs Blueprint",
          "Simple 2 Plastic Springs Blueprint",
          "Simple 3 Plastic Springs Blueprint",
          "GEC Spur Gears 4k Blueprint",
          "GEC Spur Gears 5k Blueprint",
          "Basic Vehicle Gearbox Blueprint (L)",
          "Basic Vehicle Servo Blueprint (L)",
          "Basic Vehicle Supercharger Blueprint (L)",
          "Basic Vehicle Suspension Blueprint (L)",
          "Metallic Bone Replacement Blueprint",
          "Basic Bearings Blueprint",
          "Basic Nuts Blueprint",
          "Basic Rings Blueprint",
          "Basic Screws Blueprint",
          "Basic Sheet Metal Blueprint",
          "Basic Tube Blueprint",
          "Hardened Alloy Blueprint",
          "Hardened Nuts Blueprint",
          "Hardened Clips Blueprint",
          "Hardened Foil Blueprint",
          "Hardened Pipe Blueprint",
          "Hardened Screws Blueprint",
          "High Grade Alloy Blueprint",
          "High Grade Bearings Blueprint",
          "High Grade Nuts Blueprint",
          "High Grade Plugs Blueprint",
          "High Grade Screws Blueprint",
          "High Grade Wedge Blueprint",
          "Reinforced Bearings Blueprint",
          "Reinforced Nuts Blueprint",
          "Reinforced Hinge Blueprint",
          "Reinforced Plate Blueprint",
          "Reinforced Rod Blueprint",
          "Reinforced Sheet Metal Blueprint",
          "Standard Hinge Blueprint",
          "Standard Rod Blueprint",
          "Standard Springs Blueprint",
          "Standard Lever Blueprint",
          "Standard Plate Blueprint",
          "Standard Wedge Blueprint",
          "Metallic Bone Replacement Blueprint (L)",
          "Metal Plating Blueprint",
          "Hardened Metal Plating Blueprint",
          "Super Alloy Plating Blueprint",
          "Metal Ruds Blueprint",
          "Hardened Metal Ruds Blueprint",
          "Super Alloy Ruds Blueprint",
          "Metal Mountings Blueprint",
          "Hardened Metal Mountings Blueprint",
          "Super Alloy Mountings Blueprint",
          "GeoTrek Buttstock Blueprint",
          "GeoTrek Hardened Buttstock Blueprint",
          "GeoTrek Super Alloy Buttstock Blueprint",
          "GeoTrek Talytic Converters Blueprint",
          "GeoTrek Hardened Talytic Converters Blueprint",
          "GeoTrek Super Alloy Talytic Converters Blueprint",
          "GeoTrek EnBolts Blueprint",
          "GeoTrek Hardened EnBolts Blueprint",
          "GeoTrek Super Alloy EnBolts Blueprint",
          "Simple 1 Plastic Ruds Blueprint",
          "Simple 2 Plastic Ruds Blueprint",
          "Simple 3 Plastic Ruds Blueprint",
          "Advanced Mountings Blueprint",
          "Enhanced Mountings Blueprint",
          "Advanced Talytic Converters Blueprint",
          "Enhanced Talytic Converters Blueprint",
          "High-Tech Talytic Converters Blueprint",
          "Abrer Laser Sight Blueprint",
          "Alekz Precision Scope Blueprint",
          "Beacin Laser Sight Blueprint",
          "Bjornir Precision Scope Blueprint",
          "Cinclar Precision Scope Blueprint",
          "Castar Laser Sight Blueprint",
          "Dynera Laser Sight Blueprint",
          "Dacascos Precision Scope Blueprint",
          "E-Amp 11 Blueprint",
          "E-Amp 12 Blueprint",
          "E-Amp 13 Blueprint",
          "E-Amp 14 Blueprint",
          "E-Amp 15 Blueprint",
          "Elkarr Precision Scope Blueprint",
          "Fi/Ra/Co Angst Blueprint",
          "Fi/Ra/Co Beast Blueprint",
          "Fi/Ra/Co Cause Blueprint",
          "Fi/Ra/Co Dante Blueprint",
          "Fi/Ra/Co Evil Blueprint",
          "Flexur Precision Scope Blueprint",
          "Framur Laser Sight Blueprint",
          "Gargul Laser Sight Blueprint",
          "Grender Precision Scope Blueprint",
          "Hanzor Precision Scope Blueprint",
          "Hunnir Laser Sight Blueprint",
          "Ignaritz Laser Sight Blueprint",
          "Ikamar Precision Scope Blueprint",
          "Jakth Laser Sight Blueprint",
          "Jzar Precision Scope Blueprint",
          "Ecivox Laser Sight Blueprint",
          "Level 2 Finder Amplifier (L) Blueprint",
          "Level 7 Finder Amplifier (L) Blueprint (L)",
          "Level 8 Finder Amplifier (L) Blueprint (L)",
          "Level 9 Finder Amplifier (L) Blueprint (L)",
          "Level 11 Finder Amplifier (L) Blueprint (L)",
          "Level 12 Finder Amplifier (L) Blueprint (L)",
          "Level 3 Finder Amplifier (L) Blueprint",
          "Level 5 Finder Amplifier (L) Blueprint",
          "Level 7 Finder Amplifier (L) Blueprint",
          "Level 4 Finder Amplifier (L) Blueprint (L)",
          "Level 6 Finder Amplifier (L) Blueprint (L)",
          "Level 10 Finder Amplifier (L) Blueprint (L)",
          "Level 1 Finder Amplifier (L) Blueprint",
          "Level 13 Finder Amplifier (L) Blueprint (L)",
          "Level 2 Finder Amplifier (L) Blueprint (L)",
          "Level 3 Finder Amplifier (L) Blueprint (L)",
          "Level 5 Finder Amplifier (L) Blueprint (L)",
          "Level 1 Finder Amplifier (L) Blueprint (L)",
          "Level 8 Finder Amplifier (L) Blueprint",
          "Level 4 Finder Amplifier (L) Blueprint",
          "Shear XR40 (L) Blueprint (L)",
          "Shear XR50 (L) Blueprint (L)",
          "Shear XR70 (L) Blueprint (L)",
          "Shear XR80 (L) Blueprint (L)",
          "Shear Pro600 (L) Blueprint (L)",
          "Shear Pro700 (L) Blueprint (L)",
          "Shear Pro900 (L) Blueprint (L)",
          "Bull Tac10 (L) Blueprint (L)",
          "Bull Tac20 (L) Blueprint (L)",
          "Bull Tac40 (L) Blueprint (L)",
          "Bull Tac50 (L) Blueprint (L)",
          "Bull Tac70 (L) Blueprint (L)",
          "Bull Tac80 (L) Blueprint (L)",
          "Bull TacElite (L) Blueprint (L)",
          "Shear XR40 (L) Blueprint",
          "Shear XR50 (L) Blueprint",
          "Shear XR70 (L) Blueprint",
          "Bull Tac10 (L) Blueprint",
          "Bull Tac20 (L) Blueprint",
          "Bull Tac40 (L) Blueprint",
          "Level 2 Finder Amplifier Light (L) Blueprint",
          "Level 3 Finder Amplifier Light (L) Blueprint (L)",
          "Level 3 Finder Amplifier Light (L) Blueprint",
          "Level 1 Finder Amplifier Light (L) Blueprint",
          "Level 2 Finder Amplifier Light (L) Blueprint (L)",
          "Level 9 Finder Amplifier (L) Blueprint",
          "Level 11 Finder Amplifier (L) Blueprint",
          "Level 12 Finder Amplifier (L) Blueprint",
          "Level 13 Finder Amplifier (L) Blueprint",
          "Level 6 Finder Amplifier (L) Blueprint",
          "Level 10 Finder Amplifier (L) Blueprint",
          "Shear XR55 (L) Blueprint (L)",
          "Shear XR60 (L) Blueprint (L)",
          "Shear XR90 (L) Blueprint (L)",
          "Shear ProM (L) Blueprint (L)",
          "Shear ProMC (L) Blueprint (L)",
          "Bull Tac25 (L) Blueprint (L)",
          "Bull Tac30 (L) Blueprint (L)",
          "Bull Tac60 (L) Blueprint (L)",
          "Bull TacVeteran (L) Blueprint (L)",
          "Bull TacConnoisseur (L) Blueprint (L)",
          "eMINE Amplifier 2 (L) Blueprint (L)",
          "eMINE Amplifier 1 (L) Blueprint (L)",
          "eMINE Amplifier 2 (L) Blueprint",
          "eMINE Amplifier 1 (L) Blueprint",
          "Fi/Ra/Co Beast, SGA Edition Blueprint (L)",
          "Bordea Shelf (C) Blueprint (L)",
          "Lancerona Shelf (C) Blueprint (L)",
          "Eqalisa Shelf (C) Blueprint (L)",
          "Jamora Shelf (C) Blueprint",
          "Pall Stool (C) Blueprint",
          "Kitane Chair (C) Blueprint",
          "Klub Chair (C) Blueprint (L)",
          "Nallo Ceiling Lamp (C) Blueprint",
          "Nallo Wall Lamp (C) Blueprint",
          "Nallo Table Lamp (C) Blueprint (L)",
          "Nallo Floor Lamp (C) Blueprint (L)",
          "Latt Pedestal (C) Blueprint",
          "Rome Pedestal (C) Blueprint (L)",
          "Slimm Pedestal (C) Blueprint (L)",
          "Comfyr Chair (C) Blueprint (L)",
          "Comfyr Sofa (C) Blueprint (L)",
          "Comfyr Large Sofa (C) Blueprint (L)",
          "Eleganto Plane Table (C) Blueprint (L)",
          "Eleganto Coffee Table (C) Blueprint (L)",
          "Eleganto Dining Table (C) Blueprint (L)",
          "Armax Trophy Head Blueprint (L)",
          "Small Storage Box (C) Blueprint (L)",
          "Medium Storage Box (C) Blueprint (L)",
          "Small Storage Box (C) Blueprint",
          "Lykke Chest (C) Blueprint (L)",
          "McCormick Safe (C) Blueprint (L)",
          "Anti-Grav Box, Mk. 1 (C) Blueprint (L)",
          "Anti-Grav Box, Mk. 1 (C) Blueprint",
          "Anti-Grav Box, Mk. 2 (C) Blueprint (L)",
          "Anti-Grav Box, Mk. 2 (C) Blueprint",
          "Anti-Grav Box, Mk. 3 (C) Blueprint (L)",
          "Anti-Grav Box, Mk. 4 (C) Blueprint (L)",
          "Small Red Display Panel (D) Blueprint (L)",
          "Small Red Display Panel (D) Blueprint",
          "Round Red Display Panel (D) Blueprint (L)",
          "Medium Red Display Panel (D) Blueprint (L)",
          "Large Red Display Panel (D) Blueprint (L)",
          "Very Large Red Display Panel (D) Blueprint (L)",
          "Small Green Display Panel (D) Blueprint (L)",
          "Small Green Display Panel (D) Blueprint",
          "Round Green Display Panel (D) Blueprint (L)",
          "Medium Green Display Panel (D) Blueprint (L)",
          "Large Green Display Panel (D) Blueprint (L)",
          "Very Large Green Display Panel (D) Blueprint (L)",
          "Ad Screen Blueprint (L)",
          "Kulneff Armchair (C) Blueprint (L)",
          "Large Plug Blueprint",
          "Small Plugs Blueprint",
          "T-Angle Blueprint",
          "Angle Blueprint",
          "Bend Blueprint",
          "Arc Blueprint",
          "Large Plug Blueprint (L)",
          "Small Plugs Blueprint (L)",
          "T-Angle Blueprint (L)",
          "Angle Blueprint (L)",
          "Bend Blueprint (L)",
          "Arc Blueprint (L)",
          "Aldimon Bed (C) Blueprint (L)",
          "Matalin Single Bed (C) Blueprint (L)",
          "Eldrin Single Bed (C) Blueprint (L)",
          "Eldrin Double Bed (C) Blueprint (L)",
          "Matalin Double Bed (C) Blueprint (L)",
          "Aldimon Chair (C) Blueprint (L)",
          "Matalin Tall Stool (C) Blueprint (L)",
          "Matalin Chair (C) Blueprint (L)",
          "Houteaux Throne (C) Blueprint (L)",
          "Victos Throne (C) Blueprint (L)",
          "Wally Shelving (C) Blueprint (L)",
          "Plunker Display Shelving (C) Blueprint (L)",
          "Tron Display Column (D) Blueprint (L)",
          "L-Quent Side Board (C) Blueprint (L)",
          "Cubcell Shelving (C) Blueprint (L)",
          "Reon-S Sign Blueprint (L)",
          "Xlite-S Sign Blueprint (L)",
          "Reon-W Sign Blueprint (L)",
          "Reon-T Sign Blueprint (L)",
          "Visique Sign Blueprint (L)",
          "Xlite-W Sign Blueprint (L)",
          "Reon-S Screen Blueprint (L)",
          "Xlite-S Screen Blueprint (L)",
          "Reon-W Screen Blueprint (L)",
          "Reon-T Screen Blueprint (L)",
          "Visique Screen Blueprint (L)",
          "Xlite-W Screen Blueprint (L)",
          "Plasma Sign (UGC) Blueprint (L)",
          "Plasma Screen (UGC) Blueprint (L)",
          "Plasma Display (UGC) Blueprint (L)",
          "Xlite-S Display (UGC) Blueprint (L)",
          "Xlite-S Sign (UGC) Blueprint (L)",
          "Xlite-S Screen (UGC) Blueprint (L)",
          "Reon-S Display (UGC) Blueprint (L)",
          "Reon-S Sign (UGC) Blueprint (L)",
          "Reon-S Screen (UGC) Blueprint (L)",
          "Visique Display (UGC) Blueprint (L)",
          "Visique Sign (UGC) Blueprint (L)",
          "Visique Screen (UGC) Blueprint (L)",
          "Xlite-W Display (UGC) Blueprint (L)",
          "Xlite-W Sign (UGC) Blueprint (L)",
          "Xlite-W Screen (UGC) Blueprint (L)",
          "Reon-W Display (UGC) Blueprint (L)",
          "Reon-W Sign (UGC) Blueprint (L)",
          "Reon-W Screen (UGC) Blueprint (L)",
          "Reon-T Display (UGC) Blueprint (L)",
          "Reon-T Sign (UGC) Blueprint (L)",
          "Reon-T Screen (UGC) Blueprint (L)",
          "MegaView Sign Blueprint (L)",
          "MegaView Screen Blueprint (L)",
          "MegaView Sign (UGC) Blueprint (L)",
          "MegaView Screen (UGC) Blueprint (L)",
          "MegaView Display (UGC) Blueprint (L)",
          "Gigantium Sign Blueprint (L)",
          "Gigantium Screen Blueprint (L)",
          "Gigantium Sign (UGC) Blueprint (L)",
          "Gigantium Screen (UGC) Blueprint (L)",
          "Gigantium Display (UGC) Blueprint (L)",
          "Candle Skull Blueprint (L)",
          "Chirpy Statue Blueprint (L)",
          "Daikiba Statue Blueprint (L)",
          "Feffoid Statue Blueprint (L)",
          "Berycled Statue Blueprint (L)",
          "Allophyl Statue Blueprint (L)",
          "Knight With Armor Blueprint (L)",
          "Shoubu Lamp Blueprint (L)",
          "Saisho Lamp Blueprint (L)",
          "Uwasa Lamp Blueprint (L)",
          "Jinsei Lamp Blueprint (L)",
          "Shoji With Door Blueprint (L)",
          "Shoji Blueprint (L)",
          "Pole For Shoji Blueprint (L)",
          "Tatami Blueprint (L)",
          "Kachi Table Blueprint (L)",
          "Hanashi Cupboard Blueprint (L)",
          "Commode Blueprint (L)",
          "Refrigerator - Classic (C) Blueprint (L)",
          "Jewelry Box Blueprint (L)",
          "Omegaton Refrigerator Type C43 (C) Blueprint (L)",
          "Ziplex Refrigerator (C) Blueprint (L)",
          "Kitchen Bar (C) Blueprint (L)",
          "Kitchen Drawer (C) Blueprint (L)",
          "Kitchen Sink (C) Blueprint (L)",
          "Omegaton Stove A-3 (C) Blueprint (L)",
          "Omegaton Stove A-43a (C) Blueprint (L)",
          "Shower Cabin (C) Blueprint (L)",
          "Kitchen Stool (C) Blueprint (L)",
          "Hanging Bookcase (C) Blueprint (L)",
          "Kitchen Cupboard (C) Blueprint (L)",
          "Party Tent (C) Blueprint (L)",
          "Bathroom Sink (C) Blueprint (L)",
          "Opto Sign Blueprint (L)",
          "Opto Screen Blueprint (L)",
          "Opto Sign (UGC) Blueprint (L)",
          "Opto Screen (UGC) Blueprint (L)",
          "Opto Display (UGC) Blueprint (L)",
          "Elique Sign Blueprint (L)",
          "Elique Screen Blueprint (L)",
          "Elique Sign (UGC) Blueprint (L)",
          "Elique Screen (UGC) Blueprint (L)",
          "Elique Display (UGC) Blueprint (L)",
          "BackLite Sign Blueprint (L)",
          "BackLite Screen Blueprint (L)",
          "BackLite Sign (UGC) Blueprint (L)",
          "BackLite Screen (UGC) Blueprint (L)",
          "BackLite Display (UGC) Blueprint (L)",
          "Standing Sign Blueprint (L)",
          "Standing Screen Blueprint (L)",
          "Standing Sign (UGC) Blueprint (L)",
          "Standing Screen (UGC) Blueprint (L)",
          "Standing Display (UGC) Blueprint (L)",
          "Chikara Bakeneko (L) Blueprint (L)",
          "Chikara Mizuchi (L) Blueprint (L)",
          "Chikara Hanyo (L) Blueprint (L)",
          "Chikara Oni (L) Blueprint (L)",
          "Allophyl Leather Texture Blueprint",
          "Generic Leather Texture Blueprint",
          "Armax Leather Texture Blueprint",
          "Daikiba Leather Texture Blueprint",
          "Oculus Leather Texture Blueprint (L)",
          "Tripudion Leather Texture Blueprint (L)",
          "Atrax Leather Texture Blueprint",
          "Atrox Leather Texture Blueprint",
          "Sabakuma Leather Texture Blueprint",
          "Snablesnot Leather Texture Blueprint",
          "Faucervix Leather Texture Blueprint",
          "Fugabarba Leather Texture Blueprint (L)",
          "Longu Leather Texture Blueprint (L)",
          "Aetherex Leather Texture Blueprint",
          "Ambulimax Leather Texture Blueprint (L)",
          "Araneatrox Leather Texture Blueprint",
          "Argonaut Leather Texture Blueprint",
          "Berycled Leather Texture Blueprint (L)",
          "Caudatergus Leather Texture Blueprint",
          "Cersumon Leather Texture Blueprint",
          "Combibo Leather Texture Blueprint (L)",
          "Cornundacauda Leather Texture Blueprint",
          "Cornundos Leather Texture Blueprint",
          "Eomon Leather Texture Blueprint",
          "Exarosaur Leather Texture Blueprint",
          "Formidon Leather Texture Blueprint",
          "Foul Leather Texture Blueprint",
          "Gradivore Leather Texture Blueprint (L)",
          "Itumatrox Leather Texture Blueprint",
          "Mermoth Leather Texture Blueprint",
          "Plumatergus Leather Texture Blueprint (L)",
          "Prancer Leather Texture Blueprint (L)",
          "Mourner Leather Texture Blueprint",
          "Snarksnot Leather Texture Blueprint",
          "Tantardion Leather Texture Blueprint",
          "Tantillion Leather Texture Blueprint (L)",
          "Tezlapod Leather Texture Blueprint (L)",
          "Turp Leather Texture Blueprint (L)",
          "Phasm Leather Texture Blueprint (L)",
          "Nexnecis Leather Texture Blueprint (L)",
          "Frescoquda Leather Texture Blueprint (L)",
          "Chomper Leather Texture Blueprint (L)",
          "Letomie Leather Texture Blueprint",
          "Soft Leather Texture Blueprint",
          "Fine Leather Texture Blueprint",
          "Lysterium Texture Blueprint (L)",
          "Belkar Texture Blueprint",
          "Blausariam Texture Blueprint",
          "Narcanisum Texture Blueprint",
          "Zinc Texture Blueprint (L)",
          "Frigulite Texture Blueprint",
          "Ganganite Texture Blueprint",
          "Iron Texture Blueprint (L)",
          "Himi Texture Blueprint",
          "Cumbriz Texture Blueprint",
          "Copper Texture Blueprint (L)",
          "Caldorite Texture Blueprint",
          "Megan Texture Blueprint",
          "Cobalt Texture Blueprint",
          "Lanorium Texture Blueprint",
          "Gazzurdite Texture Blueprint",
          "Erdorium Texture Blueprint",
          "Quantium Texture Blueprint (L)",
          "Adomasite Texture Blueprint",
          "Niksarium Texture Blueprint",
          "Ignisium Texture Blueprint",
          "Durulium Texture Blueprint",
          "Morpheus Texture Blueprint",
          "Langotz Texture Blueprint",
          "Alferix Texture Blueprint",
          "Gold Texture Blueprint (L)",
          "Maganite Texture Blueprint",
          "Terrudite Texture Blueprint",
          "Azzurdite Texture Blueprint",
          "Dianum Texture Blueprint",
          "Rugaritz Texture Blueprint",
          "Petonium Texture Blueprint",
          "Tridenite Texture Blueprint",
          "Kanerium Texture Blueprint",
          "Platinum Texture Blueprint (L)",
          "Xeremite Texture Blueprint",
          "Kirtz Texture Blueprint",
          "Valurite Texture Blueprint",
          "Diamond Texture Blueprint (L)",
          "Emerald Texture Blueprint (L)",
          "Opal Texture Blueprint (L)",
          "Ruby Texture Blueprint (L)",
          "Midastree Texture Blueprint",
          "Stinktree Texture Blueprint",
          "Firn Texture Blueprint",
          "Bigwig Texture Blueprint",
          "Cbase Plastic Texture Blueprint",
          "Thermodure Plastic Texture Blueprint",
          "Brukite Stone Texture Blueprint",
          "Nissit Stone Texture Blueprint",
          "Kaldon Stone Texture Blueprint",
          "Rutol Stone Texture Blueprint",
          "Sopur Stone Texture Blueprint",
          "Trutun Stone Texture Blueprint",
          "Large Striped Cotton Fabric Texture Blueprint",
          "Denim Fabric Texture Blueprint",
          "Flannel Fabric Texture Blueprint",
          "Fine Hessian Fabric Texture Blueprint (L)",
          "Hessian Fabric Texture Blueprint",
          "Tight Knitted Wool Fabric Texture Blueprint",
          "Ribbed Velvet Fabric Texture Blueprint",
          "Large Ribbed Wool Fabric Texture Blueprint (L)",
          "Large Woven Cotton Fabric Texture Blueprint",
          "Evenweave Cotton Fabric Texture Blueprint",
          "Velvet Fabric Texture Blueprint",
          "Coarse Frieze Fabric Texture Blueprint",
          "Terrycloth Fabric Texture Blueprint",
          "Medium Frieze Fabric Texture Blueprint",
          "Burlap Fabric Texture Blueprint",
          "Fine Frieze Fabric Texture Blueprint (L)",
          "Striped Frote Fabric Texture Blueprint",
          "Coarse Frote Fabric Texture Blueprint",
          "Felt Fabric Texture Blueprint",
          "Fine Silk Fabric Texture Blueprint",
          "Wrinkled Felt Fabric Texture Blueprint",
          "Fine Frote Fabric Texture Blueprint",
          "Canvas Fabric Texture Blueprint (L)",
          "Suede Fabric Texture Blueprint",
          "Satin Fabric Texture Blueprint",
          "Oxidized Lysterium Texture Blueprint",
          "Oxidized Aluminium Texture Blueprint",
          "Oxidized Iron Texture Blueprint",
          "Rough Metal Texture Blueprint",
          "Grooved Metal Texture Blueprint (L)",
          "Brushed Aluminium Texture Blueprint",
          "Hammered Metal Texture Blueprint",
          "Polished Chrome Texture Blueprint (L)",
          "Chrome Texture Blueprint",
          "Grated Metal Texture Blueprint (L)",
          "Armor Defense Enhancer 1 Blueprint",
          "Armor Defense Enhancer 2 Blueprint",
          "Armor Defense Enhancer 3 Blueprint",
          "Armor Defense Enhancer 4 Blueprint",
          "Armor Defense Enhancer 5 Blueprint",
          "Armor Defense Enhancer 6 Blueprint",
          "Armor Defense Enhancer 7 Blueprint",
          "Armor Defense Enhancer 8 Blueprint",
          "Armor Defense Enhancer 9 Blueprint",
          "Armor Defense Enhancer 10 Blueprint",
          "Armor Durability Enhancer 1 Blueprint",
          "Armor Durability Enhancer 2 Blueprint",
          "Armor Durability Enhancer 3 Blueprint",
          "Armor Durability Enhancer 4 Blueprint",
          "Armor Durability Enhancer 5 Blueprint",
          "Armor Durability Enhancer 6 Blueprint",
          "Armor Durability Enhancer 7 Blueprint",
          "Armor Durability Enhancer 8 Blueprint",
          "Armor Durability Enhancer 9 Blueprint",
          "Armor Durability Enhancer 10 Blueprint",
          "Mining Excavator Speed Enhancer 1 Blueprint",
          "Mining Excavator Speed Enhancer 2 Blueprint",
          "Mining Excavator Speed Enhancer 3 Blueprint",
          "Mining Excavator Speed Enhancer 4 Blueprint",
          "Mining Excavator Speed Enhancer 5 Blueprint",
          "Mining Excavator Speed Enhancer 6 Blueprint",
          "Mining Excavator Speed Enhancer 7 Blueprint",
          "Mining Excavator Speed Enhancer 8 Blueprint",
          "Mining Excavator Speed Enhancer 9 Blueprint",
          "Mining Excavator Speed Enhancer 10 Blueprint",
          "Mining Finder Depth Enhancer 1 Blueprint",
          "Mining Finder Depth Enhancer 2 Blueprint",
          "Mining Finder Depth Enhancer 3 Blueprint",
          "Mining Finder Depth Enhancer 4 Blueprint",
          "Mining Finder Depth Enhancer 5 Blueprint",
          "Mining Finder Depth Enhancer 6 Blueprint",
          "Mining Finder Depth Enhancer 7 Blueprint",
          "Mining Finder Depth Enhancer 8 Blueprint",
          "Mining Finder Depth Enhancer 9 Blueprint",
          "Mining Finder Depth Enhancer 10 Blueprint",
          "Mining Finder Range Enhancer 1 Blueprint (L)",
          "Mining Finder Range Enhancer 2 Blueprint (L)",
          "Mining Finder Range Enhancer 3 Blueprint (L)",
          "Mining Finder Range Enhancer 4 Blueprint (L)",
          "Mining Finder Range Enhancer 5 Blueprint (L)",
          "Mining Finder Range Enhancer 6 Blueprint (L)",
          "Mining Finder Range Enhancer 7 Blueprint (L)",
          "Mining Finder Range Enhancer 8 Blueprint (L)",
          "Mining Finder Range Enhancer 9 Blueprint (L)",
          "Mining Finder Range Enhancer 10 Blueprint (L)",
          "Mining Finder Skill Modification Enhancer 1 Blueprint",
          "Mining Finder Skill Modification Enhancer 2 Blueprint",
          "Mining Finder Skill Modification Enhancer 3 Blueprint",
          "Mining Finder Skill Modification Enhancer 4 Blueprint",
          "Mining Finder Skill Modification Enhancer 5 Blueprint",
          "Mining Finder Skill Modification Enhancer 6 Blueprint",
          "Mining Finder Skill Modification Enhancer 7 Blueprint",
          "Mining Finder Skill Modification Enhancer 8 Blueprint",
          "Mining Finder Skill Modification Enhancer 9 Blueprint",
          "Mining Finder Skill Modification Enhancer 10 Blueprint",
          "Weapon Accuracy Enhancer 1 Blueprint",
          "Weapon Accuracy Enhancer 2 Blueprint",
          "Weapon Accuracy Enhancer 3 Blueprint",
          "Weapon Accuracy Enhancer 4 Blueprint",
          "Weapon Accuracy Enhancer 5 Blueprint",
          "Weapon Accuracy Enhancer 6 Blueprint",
          "Weapon Accuracy Enhancer 7 Blueprint",
          "Weapon Accuracy Enhancer 8 Blueprint",
          "Weapon Accuracy Enhancer 9 Blueprint",
          "Weapon Accuracy Enhancer 10 Blueprint",
          "Weapon Damage Enhancer 1 Blueprint",
          "Weapon Damage Enhancer 2 Blueprint",
          "Weapon Damage Enhancer 3 Blueprint",
          "Weapon Damage Enhancer 4 Blueprint",
          "Weapon Damage Enhancer 5 Blueprint",
          "Weapon Damage Enhancer 6 Blueprint",
          "Weapon Damage Enhancer 7 Blueprint",
          "Weapon Damage Enhancer 8 Blueprint",
          "Weapon Damage Enhancer 9 Blueprint",
          "Weapon Damage Enhancer 10 Blueprint",
          "Weapon Economy Enhancer 1 Blueprint (L)",
          "Weapon Economy Enhancer 2 Blueprint (L)",
          "Weapon Economy Enhancer 3 Blueprint (L)",
          "Weapon Economy Enhancer 4 Blueprint (L)",
          "Weapon Economy Enhancer 5 Blueprint (L)",
          "Weapon Economy Enhancer 6 Blueprint (L)",
          "Weapon Economy Enhancer 7 Blueprint (L)",
          "Weapon Economy Enhancer 8 Blueprint (L)",
          "Weapon Economy Enhancer 9 Blueprint (L)",
          "Weapon Economy Enhancer 10 Blueprint (L)",
          "Weapon Range Enhancer 1 Blueprint",
          "Weapon Range Enhancer 2 Blueprint",
          "Weapon Range Enhancer 3 Blueprint",
          "Weapon Range Enhancer 4 Blueprint",
          "Weapon Range Enhancer 5 Blueprint",
          "Weapon Range Enhancer 6 Blueprint",
          "Weapon Range Enhancer 7 Blueprint",
          "Weapon Range Enhancer 8 Blueprint",
          "Weapon Range Enhancer 9 Blueprint",
          "Weapon Range Enhancer 10 Blueprint",
          "Weapon Skill Modification Enhancer 1 Blueprint",
          "Weapon Skill Modification Enhancer 2 Blueprint",
          "Weapon Skill Modification Enhancer 3 Blueprint",
          "Weapon Skill Modification Enhancer 4 Blueprint",
          "Weapon Skill Modification Enhancer 5 Blueprint",
          "Weapon Skill Modification Enhancer 6 Blueprint",
          "Weapon Skill Modification Enhancer 7 Blueprint",
          "Weapon Skill Modification Enhancer 8 Blueprint",
          "Weapon Skill Modification Enhancer 9 Blueprint",
          "Weapon Skill Modification Enhancer 10 Blueprint",
          "Medical Tool Economy Enhancer 1 Blueprint",
          "Medical Tool Economy Enhancer 2 Blueprint",
          "Medical Tool Economy Enhancer 3 Blueprint",
          "Medical Tool Economy Enhancer 4 Blueprint",
          "Medical Tool Economy Enhancer 5 Blueprint",
          "Medical Tool Economy Enhancer 6 Blueprint",
          "Medical Tool Economy Enhancer 7 Blueprint",
          "Medical Tool Economy Enhancer 8 Blueprint",
          "Medical Tool Economy Enhancer 9 Blueprint",
          "Medical Tool Economy Enhancer 10 Blueprint",
          "Medical Tool Heal Enhancer 1 Blueprint",
          "Medical Tool Heal Enhancer 2 Blueprint",
          "Medical Tool Heal Enhancer 3 Blueprint",
          "Medical Tool Heal Enhancer 4 Blueprint",
          "Medical Tool Heal Enhancer 5 Blueprint",
          "Medical Tool Heal Enhancer 6 Blueprint",
          "Medical Tool Heal Enhancer 7 Blueprint",
          "Medical Tool Heal Enhancer 8 Blueprint",
          "Medical Tool Heal Enhancer 9 Blueprint",
          "Medical Tool Heal Enhancer 10 Blueprint",
          "Medical Tool Skill Modification Enhancer 1 Blueprint",
          "Medical Tool Skill Modification Enhancer 2 Blueprint",
          "Medical Tool Skill Modification Enhancer 3 Blueprint",
          "Medical Tool Skill Modification Enhancer 4 Blueprint",
          "Medical Tool Skill Modification Enhancer 5 Blueprint",
          "Medical Tool Skill Modification Enhancer 6 Blueprint",
          "Medical Tool Skill Modification Enhancer 7 Blueprint",
          "Medical Tool Skill Modification Enhancer 8 Blueprint",
          "Medical Tool Skill Modification Enhancer 9 Blueprint",
          "Medical Tool Skill Modification Enhancer 10 Blueprint",
          "Disc Brake Blueprint",
          "Chair Frame Blueprint",
          "Drive Shaft Blueprint",
          "Girder Beams Blueprint",
          "Radiator Blueprint",
          "Steering Rod Blueprint",
          "Wind Screen Blueprint",
          "Combustor Blueprint",
          "Lamp Attachments Blueprint",
          "Rubber Lists Blueprint",
          "Valkyrie Mk. 1 (C,L) Blueprint (L)",
          "Saehrimnir Mk. 1 (C,L) Blueprint (L)",
          "Valkyrie Mk. 2 (C,L) Blueprint (L)",
          "Saehrimnir Mk. 2 (C,L) Blueprint (L)",
          "Valkyrie Mk. 3 (C,L) Blueprint (L)",
          "Saehrimnir Mk. 3 (C,L) Blueprint (L)",
          "Brünnhilde (C,L) Blueprint (L)",
          "Saehrimnir Mk. 4 (C,L) Blueprint (L)",
          "Sleipnir Mk. 1 (C,L) Blueprint (L)",
          "Sleipnir Mk. 2 (C,L) Blueprint (L)",
          "Sleipnir Mk. 3 (C,L) Blueprint (L)",
          "Sleipnir Mk. 4 (C,L) Blueprint (L)",
          "Jormungand Mk. 1 (C,L) Blueprint (L)",
          "Jormungand Mk. 2 (C,L) Blueprint (L)",
          "Jormungand Mk. 3 (C,L) Blueprint (L)",
          "Jormungand Mk. 4 (C,L) Blueprint (L)",
          "Hovercraft CC Mk. 1 (C,L) Blueprint (L)",
          "Hovercraft CC Mk. 2 (C,L) Blueprint (L)",
          "Hovercraft CC Mk. 3 (C,L) Blueprint (L)",
          "Hovercraft CC Mk. 4 (C,L) Blueprint (L)"
        ]
      }
    },
    methods: {
      async GetBP() {
        for (let item of this.items) {
          await fetch(`https://craftingdb.decentralised.tech/api/bp?name=${encodeURIComponent(item)}`)
          await new Promise(resolve => setTimeout(resolve, 750));
          console.log('Added ', item)
        }
      }
    },
    mounted() {
      console.log(this.items.length)
      // this.GetBP();
    }
  }
</script>